// import React, { useState, useEffect, use } from 'react';
// import Header from '../../layouts/Header';
// import {
//     Col,
//     Row,
//     Card,
//     Button,
//     Form,
//     Modal,
//     Spinner,
//     Badge,
//     InputGroup,
//     FormControl,
//     Pagination,
//     Accordion,
//     Tab,
//     Tabs,
//     Image
// } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import Select from 'react-select';
// import axiosInstance from '../../api/axios'; import { toast } from 'react-toastify';
// import {
//     Tag,
//     Plus,
//     Edit,
//     Trash2,
//     RefreshCw,
//     Search,
//     Eye,
//     X,
//     ShoppingCart,
//     Percent,
//     Calendar,
//     Package,
//     Award,
//     CheckCircle,
//     Gift,
//     Ticket,
//     Crown,
//     TrendingUp,
//     Hash,
//     Route,
//     Layers,
//     MapPin,
//     Navigation,
//     Compass,
//     Upload,
//     Image as ImageIcon
// } from 'lucide-react';
// import { format } from 'date-fns';

// const AutoCouponAllocation = () => {
//     const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
//     const [skin, setSkin] = useState(currentSkin);

//     const { access } = useSelector((state) => state.login);
//     const [couponAccess, setCouponAccess] = useState([]);

//     // Main states
//     const [loading, setLoading] = useState(false);
//     const [allCoupons, setAllCoupons] = useState([]);
//     const [filteredCoupons, setFilteredCoupons] = useState([]);
//     const [journeyCoupons, setJourneyCoupons] = useState([]);
//     const [totalCoupons, setTotalCoupons] = useState(0);
//     const [totalJourneyCoupons, setTotalJourneyCoupons] = useState(0);

//     // Tab state
//     const [activeTab, setActiveTab] = useState('journey-coupons');

//     // Filter states
//     const [searchQuery, setSearchQuery] = useState('');
//     const [couponTypeFilter, setCouponTypeFilter] = useState('ALL');
//     const [statusFilter, setStatusFilter] = useState('ALL');

//     // Modal states
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [selectedCoupon, setSelectedCoupon] = useState(null);

//     // Form states
//     const [formData, setFormData] = useState({
//         title: '',
//         description: '',
//         couponType: "All",
//         isFreebieCoupon: false,
//         nthOrderNumber: '',
//         validityInDays: '',
//         discountType: 'PERCENT',
//         discountPrice: '',
//         applicableQuantityType: 'SINGLE',
//         usageType: 'ONE-TIME',
//         minOrderAmount: '',
//         maxOrderAmount: '',
//         discountAmount: '',
//         freebieProduct: '',
//         freebieQuantity: '',
//         discountPercent: '',
//         maxDiscountAmount: '',
//         applicableProducts: [],
//         applicableCategories: [],
//         excludedProducts: [],
//         // 👇 Added fields for excluding addons / addon values
//         excludedAddonGroups: [],
//         excludedAddonValues: [],
//         newSizeUpgradeAddon: '',
//         minCartValue: '',
//         termsAndConditions: [],
//         displayImage: '' // New field for coupon image
//     });

//     const [submitting, setSubmitting] = useState(false);
//     const [deleteLoading, setDeleteLoading] = useState(false);
//     const [isEditForm, setIsEditForm] = useState(false);

//     // Image upload states
//     const [imagePreview, setImagePreview] = useState('');
//     const [imageFile, setImageFile] = useState(null);
//     const [uploadingImage, setUploadingImage] = useState(false);
//     const [imageAction, setImageAction] = useState('UNCHANGED');

//     // Options states
//     const [categories, setCategories] = useState([]);
//     const [productsData, setProductsData] = useState([]);
//     const [freebieProducts, setFreebieProducts] = useState([]);
//     const [excludedProducts, setExcludedProducts] = useState([])
//     const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
//     const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
//     const [products, setProducts] = useState([]);
//     const [termInput, setTermInput] = useState('');

//     // 👇 Added states for excluding addons / addon values
//     const [allAddonList, setAllAddonList] = useState([]);
//     const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
//     const [filteredAddonValues, setFilteredAddonValues] = useState([]);

//     // Pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const [journeyCurrentPage, setJourneyCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(100);
//     const [totalPages, setTotalPages] = useState('');
//     const [journeyTotalPages, setJourneyTotalPages] = useState('');

//     // Add separate filter states for each tab
//     const [regularSearchQuery, setRegularSearchQuery] = useState('');
//     const [journeySearchQuery, setJourneySearchQuery] = useState('');
//     const [regularCouponTypeFilter, setRegularCouponTypeFilter] = useState('ALL');
//     const [journeyCouponTypeFilter, setJourneyCouponTypeFilter] = useState('ALL');
//     const [regularStatusFilter, setRegularStatusFilter] = useState('ACTIVE');
//     const [journeyStatusFilter, setJourneyStatusFilter] = useState('ACTIVE');
//     const [activeAccordion, setActiveAccordion] = useState("0");
//     const [isTouched, setIsTouched] = useState(false);
//     const [isCouponTypeTouched, setIsCouponTypeTouched] = useState(false);
//     const accessToken = localStorage.getItem('authToken');

//     const [loadingExcludedProducts, setLoadingExcludedProducts] = useState(false);
//     const [isSearched, setIsSearched] = useState(false);
//     const [isRegularSearched, setIsRegularSearched] = useState(false);

//     // Get permissions
//     useEffect(() => {
//         if (Array.isArray(access)) {
//             const filteredAccess = access?.filter((perm) =>
//                 perm?.startsWith("AutoCouponAllocation:")
//             );
//             setCouponAccess(filteredAccess);
//         }
//     }, [access]);

//     // Custom styles for react-select
//     const customSelectStyles = {
//         control: (base, state) => ({ ...base /* unchanged */ }),
//         menu: (base) => ({ ...base /* unchanged */ }),

//         option: (base, state) => ({
//             ...base,
//             backgroundColor: state.isFocused
//                 ? (skin === 'dark' ? '#3a4155' : '#e9ecef')
//                 : (skin === 'dark' ? '#2a3042' : 'white'),
//             color: state.data?.isDelete
//                 ? '#dc3545'
//                 : (skin === 'dark' ? 'white' : 'black'),
//             fontWeight: state.data?.isDelete ? 600 : 'normal',
//             '&:hover': {
//                 backgroundColor: skin === 'dark' ? '#3a4155' : '#e9ecef',
//             }
//         }),

//         multiValue: (base, state) => ({
//             ...base,
//             backgroundColor: state.data?.isDelete
//                 ? '#f8d7da'
//                 : (skin === 'dark' ? '#3a4155' : '#e9ecef'),
//             border: state.data?.isDelete ? '1px solid #dc3545' : 'none',
//         }),

//         multiValueLabel: (base, state) => ({
//             ...base,
//             color: state.data?.isDelete
//                 ? '#dc3545'
//                 : (skin === 'dark' ? 'white' : 'black'),
//             fontWeight: state.data?.isDelete ? 600 : 'normal',
//         }),

//         multiValueRemove: (base) => ({ ...base /* unchanged */ }),
//     };

//     // Fetch all data
//     const fetchInitialData = async () => {
//         await Promise.all([
//             getCoupons(1, itemsPerPage, {}),
//             getJourneyCoupons(1, itemsPerPage, {}),
//             getCategories(),
//             getProducts(),
//             getExProducts(),
//             loadAllProductsForExclusion(),
//             getNewSizeAddons(),
//             getAddonList() // 👈 added: fetch all addon groups/values for exclusion selects
//         ]);
//     };

//     // ✅ Step 1: Prepare filters (business rules)
//     const prepareFilters = (filters = {}) => {
//         const updatedFilters = { ...filters };

//         // 🔒 HARD RESET for ALL (ignore previous state completely)
//         if (filters.couponType === 'ALL') {
//             delete updatedFilters.couponType;
//             return updatedFilters;
//         }

//         // ✅ Category / Product
//         if (filters.couponType === '') {
//             updatedFilters.couponType = null;
//         }

//         return updatedFilters;
//     };



//     // ✅ Step 2: Sanitize filters (cleanup only)
//     const sanitizeFilters = (filters = {}) => {
//         const cleanFilters = {};

//         Object.entries(filters).forEach(([key, value]) => {
//             if (
//                 value !== '' &&
//                 value !== undefined &&
//                 value !== 'ALL'
//             ) {
//                 cleanFilters[key] = value;
//             }
//         });

//         return cleanFilters;
//     };



//     // ==============================
//     // Fetch REGULAR coupons
//     // ==============================
//     const getCoupons = async (page, limit, filters = {}) => {
//         setLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };

//             const preparedFilters = prepareFilters(filters);
//             const cleanedFilters = sanitizeFilters(preparedFilters);

//             const params = new URLSearchParams({
//                 page,
//                 limit,
//                 ...cleanedFilters
//             });

//             const response = await axiosInstance.get(
//                 `auto-coupon-allocation?${params.toString()}`,
//                 { headers }
//             );

//             if (response?.data?.status === true) {
//                 const data = Array.isArray(response?.data?.data)
//                     ? response.data.data
//                     : [];

//                 // ✅ Explicit split
//                 const journeyCouponsList = data.filter(
//                     coupon => coupon?.nthOrderNumber !== null && coupon?.nthOrderNumber !== undefined
//                 );

//                 const allCouponsList = data.filter(
//                     coupon => coupon?.nthOrderNumber === null || coupon?.nthOrderNumber === undefined
//                 );

//                 setAllCoupons(data);
//                 setFilteredCoupons(allCouponsList);
//                 setJourneyCoupons(journeyCouponsList);

//                 setTotalCoupons(allCouponsList.length);
//                 setTotalJourneyCoupons(journeyCouponsList.length);

//                 setTotalPages(
//                     response?.data?.pagination?.totalPages ||
//                     Math.ceil(allCouponsList.length / limit)
//                 );
//             }
//         } catch (error) {
//             showError(error, 'Failed to fetch coupons');
//         } finally {
//             setLoading(false);
//         }
//     };


//     // ==============================
//     // Fetch JOURNEY coupons
//     // ==============================
//     const getJourneyCoupons = async (page, limit, filters = {}) => {
//         setLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };

//             const preparedFilters = prepareFilters({
//                 ...filters,
//                 nthOrderNumber: true
//             });

//             const journeyFilters = sanitizeFilters(preparedFilters);

//             const params = new URLSearchParams({
//                 page,
//                 limit,
//                 ...journeyFilters
//             });

//             const response = await axiosInstance.get(
//                 `auto-coupon-allocation?${params.toString()}`,
//                 { headers }
//             );

//             if (response?.data?.status === true) {
//                 const data = response?.data?.data || [];
//                 console.log("Journey Coupons Data :", data);
//                 let filteredData = data.filter((data) => data?.nthOrderNumber !== null && data?.nthOrderNumber !== undefined);
//                 setJourneyCoupons(filteredData);
//                 setTotalJourneyCoupons(filteredData?.length || 0);
//                 setJourneyTotalPages(
//                     response?.data?.pagination?.totalPages ||
//                     Math.ceil(data.length / limit)
//                 );
//             }
//         } catch (error) {
//             showError(error, 'Failed to fetch journey coupons');
//         } finally {
//             setLoading(false);
//         }
//     };




//     // Get journey stage badge
//     const getJourneyStageBadge = (nthOrder) => {
//         if (!nthOrder) return null;

//         const orderNum = parseInt(nthOrder);

//         if (orderNum === 2) {
//             return <Badge bg="success" className="journey-stage-badge">2nd Order</Badge>;
//         } else if (orderNum === 3) {
//             return <Badge bg="info" className="journey-stage-badge">3rd Order</Badge>;
//         } else if (orderNum >= 4 && orderNum <= 7) {
//             return <Badge bg="warning" className="journey-stage-badge">Mid Journey</Badge>;
//         } else if (orderNum === 8) {
//             return <Badge bg="danger" className="journey-stage-badge">Loyal Customer</Badge>;
//         }

//         return <Badge bg="secondary" className="journey-stage-badge">Order #{nthOrder}</Badge>;
//     };

//     // Get journey stage color
//     const getJourneyStageColor = (nthOrder) => {
//         if (!nthOrder) return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';

//         const orderNum = parseInt(nthOrder);

//         if (orderNum === 2) {
//             return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'; // Green
//         } else if (orderNum === 3) {
//             return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'; // Blue
//         } else if (orderNum >= 4 && orderNum <= 7) {
//             return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'; // Orange/Pink
//         } else if (orderNum >= 8) {
//             return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'; // Red
//         }

//         return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'; // Purple
//     };

//     // Get journey icon
//     const getJourneyIcon = (nthOrder) => {
//         if (!nthOrder) return <Route size={16} />;

//         const orderNum = parseInt(nthOrder);

//         if (orderNum === 2) {
//             return <Compass size={16} />;
//         } else if (orderNum === 3) {
//             return <Navigation size={16} />;
//         } else if (orderNum >= 4 && orderNum <= 7) {
//             return <Layers size={16} />;
//         } else if (orderNum >= 8) {
//             return <MapPin size={16} />;
//         }

//         return <Route size={16} />;
//     };

//     // Fetch categories
//     const getCategories = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("masters/category/get", { headers });

//             if (response?.data?.status === true) {
//                 const categoriesData = response?.data?.data?.categories || [];
//                 const options = categoriesData.map(category => ({
//                     value: category._id,
//                     label: category.name || category.categoryName
//                 }));
//                 setCategories(options);
//             }
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };

//     // New Size Addons Api 
//     const getNewSizeAddons = async () => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`
//             }
//             const response = await axiosInstance.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
//             setNewSizeAddonsList(response?.data?.data?.addons);
//             let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []);
//             setNewProductsFromAddons(newproducts);
//         } catch (error) {
//             console.log("Error :", error);
//         }
//     }

//     // 👇 Added: Fetch all addon groups (with their addon values) for the exclusion selects
//     const getAddonList = async () => {
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };
//             const response = await axiosInstance.get("addons?page=1&limit=100", { headers });

//             if (response?.data?.status === true) {
//                 setAllAddonList(response?.data?.data?.addons || []);
//             }
//         } catch (error) {
//             toast.error(error?.response?.data?.error || "Failed to fetch addons", {
//                 position: "top-right",
//                 autoClose: 3000,
//                 theme: "light",
//             });
//         }
//     };

//     const addonsProducts = newProductsFromAddons?.map((item) => ({
//         value: item?._id,
//         label: item?.name,
//         isDelete: item?.isDelete || false
//     }))

//     const getExProducts = async () => {
//         setLoadingExcludedProducts(true);
//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`
//             };

//             const response = await axiosInstance.get(`product`, { headers });

//             // Merge products from all responses
//             const allProducts = response?.data?.data?.products ?? [];
//             const options = allProducts.map(product => ({
//                 value: product._id,
//                 label: product.name,
//                 isDelete: product.isDelete || false
//             }));

//             setExcludedProducts(options);
//         } catch (error) {
//             console.error('Error fetching products :', error);
//         } finally {
//             setLoadingExcludedProducts(false);
//         }
//     };

//     // Add this new function to load all products initially
//     const loadAllProductsForExclusion = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get('product', { headers });

//             if (response?.data?.status === true) {
//                 const productsData = response?.data?.data?.products || [];
//                 const options = productsData.map(product => ({
//                     value: product._id,
//                     label: product.name
//                 }));

//                 // Set as initial excluded products options
//                 setExcludedProducts(options);
//             }
//         } catch (error) {
//             console.error('Error fetching all products for exclusion:', error);
//         }
//     };

//     // Fetch products with search
//     const getProducts = async (searchTerm = '') => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             let urlParams = `product`;

//             if (searchTerm) {
//                 urlParams += `?search=${searchTerm}`;
//             }
//             const response = await axiosInstance.get(urlParams, { headers });

//             if (response?.data?.status === true) {
//                 const productsData = response?.data?.data?.products || [];
//                 const options = productsData.map(product => ({
//                     value: product._id,
//                     label: product.name
//                 }));

//                 const nonFreePro = response?.data?.data?.products
//                     ?.filter(pro => pro?.isFreebieProduct === false)
//                     .map(product => ({
//                         value: product._id,
//                         label: product.name,
//                         isDelete: product.isDelete || false
//                     }));

//                 const freePro = response?.data?.data?.products
//                     ?.filter(pro => pro?.isFreebieProduct === true)
//                     .map(product => ({
//                         value: product._id,
//                         label: product.name
//                     }));
//                 setFreebieProducts(freePro);
//                 setProductsData(nonFreePro);
//                 setExcludedProducts(nonFreePro);
//             }
//         } catch (error) {
//             console.error('Error fetching products:', error);
//         }
//         return [];
//     };

//     // Load products for async select
//     const loadProducts = async (inputValue) => {
//         return await getProducts(inputValue);
//     };

//     // Convert image file to Base64 and keep file reference
//     const convertToBase64 = (file) => {
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.readAsDataURL(file);
//             reader.onload = () => resolve({
//                 base64: reader.result,
//                 file: file
//             });
//             reader.onerror = error => reject(error);
//         });
//     };

//     // Handle image change
//     const handleImageChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         // Validate file type
//         const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];
//         if (!validTypes.includes(file.type)) {
//             toast.error('Please upload a valid image file (JPEG, PNG, GIF, WebP)');
//             return;
//         }

//         // Validate file size (max 5MB)
//         if (file.size > 5 * 1024 * 1024) {
//             toast.error('Image size should be less than 5MB');
//             return;
//         }

//         setUploadingImage(true);
//         setImageFile(file);
//         setImageAction('ADDED'); // 👈 important
//         try {
//             // Create local preview
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 setImagePreview(reader.result);
//             };
//             reader.readAsDataURL(file);

//             // Convert to Base64 for preview and store file reference
//             const result = await convertToBase64(file);
//             setFormData(prev => ({
//                 ...prev,
//                 displayImage: result.base64
//             }));

//             toast.success('Image added successfully');
//         } catch (error) {
//             console.error('Error converting image:', error);
//             toast.error('Failed to process image');
//         } finally {
//             setUploadingImage(false);
//         }
//     };

//     // Remove image
//     const handleRemoveImage = () => {
//         setImagePreview('');
//         setImageFile(null);
//         setImageAction('REMOVED'); // 👈 important
//         setFormData(prev => ({ ...prev, displayImage: '' }));
//         toast.info('Image removed');
//     };

//     // Handle form input change
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         console.log("Name :", name, "Value :", value);

//         if (isEditForm && name === 'discountType') {
//             setIsTouched(true);
//         }

//         if (isEditForm && name === 'couponType') {
//             setIsCouponTypeTouched(true);
//         }

//         // Convert number fields
//         const numberFields = [
//             'nthOrderNumber', 'validityInDays', 'minOrderAmount', 'maxOrderAmount',
//             'discountAmount', 'discountPrice', 'maxDiscountAmount', 'minCartValue'
//         ];

//         if (numberFields.includes(name)) {
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: value === '' ? '' : Number(value)
//             }));
//         } else {
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: value
//             }));
//         }
//     };

//     // Handle multi-select change
//     const handleMultiSelectChange = async (name, selectedOptions) => {
//         if (name === 'applicableCategories') {
//             const categoryIds = selectedOptions.map(opt => opt.value);

//             // Clear excluded products if no categories selected
//             if (categoryIds.length === 0) {
//                 setFormData(prev => ({
//                     ...prev,
//                     excludedProducts: []
//                 }));
//                 // Load all products as options
//                 await loadAllProductsForExclusion();
//             } else {
//                 // Fetch products for selected categories
//                 await getExProducts(categoryIds);
//             }
//         }

//         setFormData(prev => ({
//             ...prev,
//             [name]: selectedOptions || []
//         }));
//     };

//     const handleSelectChange = (selectedOption) => {
//         setFormData(prev => ({
//             ...prev,
//             freebieProduct: selectedOption.value || null
//         }));
//     }

//     // 👇 Added: Handle "Excluding Addons" / "Excluding Addon Values" selects
//     const handleSelectAllAddonChange = (fieldName, selectedOptions) => {
//         if (fieldName !== 'excludedAddonGroups') {
//             setFormData(prev => ({
//                 ...prev,
//                 [fieldName]: selectedOptions || []
//             }));
//             return;
//         }

//         // Update selected addon groups
//         setSelectedAddonGroups(selectedOptions || []);

//         // ✅ If no addons selected, clear values and reset form data
//         if (!selectedOptions || selectedOptions.length === 0) {
//             setFilteredAddonValues([]);
//             setFormData(prev => ({
//                 ...prev,
//                 excludedAddonGroups: [],
//                 excludedAddonValues: [] // clear dependent addon values
//             }));
//             return;
//         }

//         // ✅ Generate addon value options only for selected addons
//         const addonValuesOptions = selectedOptions.flatMap(option => {
//             const addon = allAddonList?.find(a => a?._id === option?.value);
//             if (!addon) return [];

//             return addon?.addonValues?.map(val => ({
//                 value: {
//                     addonId: addon._id,
//                     addValueId: val._id,
//                     addonTitle: addon.title,
//                     addonValueTitle: val.value
//                 },
//                 label: `${addon.title} - ${val.value}`
//             })) || [];
//         });

//         // ✅ Store the selected addon groups (for formData)
//         const selectedItems = allAddonList.filter(addon =>
//             selectedOptions.some(option => option.value === addon._id)
//         );

//         // ✅ Update filtered values list
//         setFilteredAddonValues(addonValuesOptions);

//         // ✅ Remove excludedAddonValues that no longer belong to selected groups
//         setFormData(prev => {
//             const filteredExcludedValues = (prev.excludedAddonValues || []).filter(val =>
//                 selectedOptions.some(opt => opt.value === val.addonId)
//             );

//             return {
//                 ...prev,
//                 excludedAddonGroups: selectedItems,
//                 excludedAddonValues: filteredExcludedValues
//             };
//         });
//     };

//     // Handle terms and conditions
//     const handleAddTerm = () => {
//         if (termInput.trim() === '') return;

//         setFormData(prev => ({
//             ...prev,
//             termsAndConditions: [...prev.termsAndConditions, termInput.trim()]
//         }));
//         setTermInput('');
//     };

//     const handleRemoveTerm = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             termsAndConditions: prev.termsAndConditions.filter((_, i) => i !== index)
//         }));
//     };

//     // Reset form
//     const resetForm = () => {
//         setFormData({
//             title: '',
//             description: '',
//             couponType: 'All',
//             nthOrderNumber: '',
//             validityInDays: '',
//             discountType: 'PERCENT',
//             usageType: 'ONE-TIME',
//             minOrderAmount: '',
//             maxOrderAmount: '',
//             applicableQuantityType: 'SINGLE',
//             discountPrice: '',
//             excludedProducts: [],
//             // 👇 Added fields for excluding addons / addon values
//             excludedAddonGroups: [],
//             excludedAddonValues: [],
//             discountAmount: '',
//             discountPercent: '',
//             maxDiscountAmount: '',
//             isFreebieCoupon: false,
//             freebieProduct: '',
//             freebieQuantity: '',
//             applicableProducts: [],
//             applicableCategories: [],
//             newSizeUpgradeAddon: '',
//             minCartValue: '',
//             termsAndConditions: [],
//             displayImage: '' // Reset image field
//         });
//         setImagePreview('');
//         setImageFile(null);
//         setTermInput('');
//         // 👇 Added: reset excluding-addon UI state
//         setSelectedAddonGroups([]);
//         setFilteredAddonValues([]);
//     };

//     // Open add modal
//     const handleAddCoupon = () => {
//         resetForm();
//         setShowAddModal(true);
//     };

//     // Open edit modal
//     const handleEditCoupon = async (coupon) => {
//         setSelectedCoupon(coupon);
//         setIsEditForm(true);
//         console.log("Edit Coupon Data :", coupon);

//         // 👇 Added: Rebuild "Excluding Addons" / "Excluding Addon Values" selections from the coupon record.
//         // Expected shape on the coupon: excludedAddons: [{ addonId, addonValueId, addonTitle, addonValueTitle }]
//         const excludedAddonsData = coupon?.excludedAddons || [];
//         const groupIds = [...new Set(excludedAddonsData.map(item => item.addonId))];
//         const selectedGroups = allAddonList.filter(addon => groupIds.includes(addon._id));

//         const selectedAddonGroupOptions = selectedGroups.map(addon => ({
//             value: addon._id,
//             label: addon.title
//         }));

//         const addonValuesOptions = selectedGroups.flatMap(addon =>
//             addon?.addonValues?.map(val => ({
//                 value: {
//                     addonId: addon._id,
//                     addValueId: val._id,
//                     addonTitle: addon.title,
//                     addonValueTitle: val.value
//                 },
//                 label: `${addon.title} - ${val.value}`
//             })) || []
//         );

//         setSelectedAddonGroups(selectedAddonGroupOptions);
//         setFilteredAddonValues(addonValuesOptions);

//         // Convert coupon data to form format
//         const formattedData = {
//             title: coupon?.title || '',
//             description: coupon?.description || '',
//             couponType: coupon?.couponType || '',
//             nthOrderNumber: coupon?.nthOrderNumber || null,
//             validityInDays: coupon?.validityInDays || '',
//             discountType: coupon?.discountType || 'PERCENT',
//             usageType: coupon?.usageType || 'ONE-TIME',
//             minOrderAmount: coupon?.minOrderAmount || '',
//             maxOrderAmount: coupon?.maxOrderAmount || '',
//             isFreebieCoupon: coupon?.isFreebieCoupon || false,
//             freebieQuantity: coupon?.freebieQuantity || '',
//             freebieProduct: coupon?.freebieProduct?._id || '',
//             applicableQuantityType: coupon?.applicableQuantityType || 'SINGLE',
//             discountPrice: coupon?.discountPrice || '',
//             status: coupon?.status || '',
//             discountAmount: coupon?.discountAmount || '',
//             discountPercent: coupon?.discountPercent || '',
//             maxDiscountAmount: coupon?.maxDiscountAmount || '',
//             applicableProducts: coupon?.applicableProducts?.map(product => ({
//                 value: product._id,
//                 label: product.name,
//                 isDelete: product.isDelete || false
//             })) || [],
//             applicableCategories: coupon?.applicableCategories?.map(category => ({
//                 value: category._id,
//                 label: category.name
//             })) || [],
//             excludedProducts: coupon?.excludedProducts?.map(product => ({
//                 value: product._id,
//                 label: product.name,
//                 isDelete: product.isDelete || false
//             })) || [],
//             // 👇 Added: excludedAddonGroups / excludedAddonValues from the fetched coupon
//             excludedAddonGroups: selectedGroups,
//             excludedAddonValues: excludedAddonsData.map(item => ({
//                 addonId: item.addonId,
//                 addValueId: item.addonValueId,
//                 addonTitle: item.addonTitle,
//                 addonValueTitle: item.addonValueTitle
//             })),
//             newSizeUpgradeAddon: coupon?.newSizeUpgradeAddon?._id || '',
//             minCartValue: coupon?.minCartValue || '',
//             termsAndConditions: coupon?.termsAndConditions || [],
//             displayImage: coupon?.displayImage || '' // Include displayImage
//         };

//         console.log("Display Image of Selected Coupon :", coupon?.displayImageUrl);

//         setFormData(formattedData);

//         // Set image preview if exists
//         setImagePreview(coupon?.displayImageUrl || '');
//         setImageAction('UNCHANGED');
//         setImageFile(null);

//         // 🔥 CRITICAL FIX: Load excluded products for the selected categories
//         if (coupon?.applicableCategories?.length > 0) {
//             const categoryIds = coupon.applicableCategories.map(cat => cat._id);
//             await getExProducts(categoryIds);
//         } else {
//             // If no categories selected, load all products for exclusion
//             await loadAllProductsForExclusion();
//         }

//         setShowEditModal(true);
//     };

//     // Open view modal
//     const handleViewCoupon = (coupon) => {
//         setSelectedCoupon(coupon);
//         setShowViewModal(true);
//     };

//     // Open delete modal
//     const handleDeleteCoupon = (coupon) => {
//         setSelectedCoupon(coupon);
//         setShowDeleteModal(true);
//     };

//     const fieldSectionMap = {
//         title: "0",
//         description: "0",
//         status: "0",
//         displayImage: "0", // Added image to basic info section

//         couponType: "1",
//         usageType: "1",
//         nthOrderNumber: "1",
//         validityInDays: "1",
//         minOrderAmount: "1",
//         maxOrderAmount: "1",

//         discountType: "2",
//         discountPercent: "2",
//         discountPrice: "2",
//         discountAmount: "2",
//         minCartValue: "2",
//         applicableCategories: "2",
//         applicableProducts: "2",
//         freebieProduct: "2",
//         freebieQuantity: "2",
//         newSizeUpgradeAddon: "2",
//         excludedAddonGroups: "2",
//         excludedAddonValues: "2",

//         termsAndConditions: "3"
//     };

//     const findFirstInvalidField = () => {
//         if (!formData.title) return "title";
//         if (!formData.description) return "description";
//         if (formData.couponType === 'All') return "couponType";
//         if (!formData.usageType) return "usageType";
//         if (!formData.validityInDays) return "validityInDays";
//         if (!formData.displayImage) return "displayImage";

//         if (
//             formData.discountType === "PERCENT" &&
//             !formData.discountPercent &&
//             !['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData.couponType)
//         ) {
//             return "discountPercent";
//         }

//         if (formData?.couponType === "SIZE_UPGRADE" && !formData.newSizeUpgradeAddon) {
//             return "newSizeUpgradeAddon";
//         }

//         if (
//             formData.discountType === "FLAT" &&
//             !formData.discountAmount
//         ) {
//             return "discountAmount";
//         }

//         if (formData.discountType === "PRICE" && !formData.discountPrice && !['BOGO', 'SIZE_UPGRADE', 'FREEBIE', 'UNIVERSAL', 'CART'].includes(formData.couponType)
//         ) {
//             return "discountPrice";
//         }

//         if (
//             formData.couponType === "FREEBIE" &&
//             (!formData.freebieProduct || !formData.freebieQuantity)
//         ) {
//             return "freebieProduct";
//         }

//         return null;
//     };

//     // SUBMIT This is For Sending Array In Index
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setSubmitting(true);

//         const invalidField = findFirstInvalidField();
//         if (invalidField) {
//             const sectionKey = fieldSectionMap[invalidField];
//             setActiveAccordion(sectionKey);
//             toast.error("Please fill all required fields");
//             setSubmitting(false);
//             return;
//         }

//         const isEdit = showEditModal && selectedCoupon?._id;

//         // ---------------- HELPERS ----------------
//         const appendField = (fd, key, value) => {
//             if (value === undefined || value === '') {
//                 if (isEdit) fd.append(key, null);
//                 return;
//             }
//             fd.append(key, value);
//         };

//         const appendNumberField = (fd, key, value) => {
//             if (value === undefined || value === null || value === '') {
//                 if (isEdit) fd.append(key, null);
//                 return;
//             }
//             fd.append(key, String(value));
//         };

//         const appendIndexedArrayField = (fd, key, arr, mapFn = v => v) => {
//             if (Array.isArray(arr) && arr.length > 0) {
//                 arr.forEach((item, index) => {
//                     fd.append(`${key}[${index}]`, mapFn(item));
//                 });
//             } else {
//                 if (isEdit) {
//                     fd.append(key, JSON.stringify(null));
//                 }
//             }
//         };
//         // -----------------------------------------

//         console.log("Status in Submit :", formData.status);

//         try {
//             const formDataToSend = new FormData();

//             // -------- BASIC FIELDS --------
//             appendField(formDataToSend, 'title', formData.title);
//             appendField(formDataToSend, 'description', formData.description);
//             appendField(formDataToSend, 'couponType', formData.couponType);
//             appendField(formDataToSend, 'validityInDays', formData.validityInDays);
//             appendField(formDataToSend, 'usageType', formData.usageType);
//             appendField(formDataToSend, 'applicableQuantityType', formData.applicableQuantityType);

//             if (formData?.couponType === "FREEBIE") {
//                 appendField(formDataToSend, 'isFreebieCoupon', true);
//             }

//             // -------- DISCOUNT TYPE --------
//             appendField(
//                 formDataToSend,
//                 'discountType',
//                 ['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType)
//                     ? null
//                     : formData.discountType
//             );

//             // -------- NUMBER FIELDS --------
//             appendNumberField(formDataToSend, 'nthOrderNumber', formData.nthOrderNumber);
//             appendNumberField(formDataToSend, 'minOrderAmount', formData.minOrderAmount);
//             appendNumberField(formDataToSend, 'maxOrderAmount', formData.maxOrderAmount);
//             appendNumberField(formDataToSend, 'discountPrice', formData.discountPrice);
//             appendNumberField(formDataToSend, 'discountAmount', formData.discountAmount);
//             appendNumberField(formDataToSend, 'discountPercent', formData.discountPercent);
//             appendNumberField(formDataToSend, 'maxDiscountAmount', formData.maxDiscountAmount);
//             appendNumberField(formDataToSend, 'minCartValue', formData.minCartValue);
//             appendNumberField(formDataToSend, 'freebieQuantity', formData.freebieQuantity);

//             // -------- FREEBIE PRODUCT --------
//             appendField(
//                 formDataToSend,
//                 'freebieProduct',
//                 formData.freebieProduct?.value || formData.freebieProduct
//             );

//             // -------- SIZE UPGRADE ADDON --------
//             appendField(
//                 formDataToSend,
//                 'newSizeUpgradeAddon',
//                 formData.newSizeUpgradeAddon
//             );

//             // -------- ARRAYS --------
//             appendIndexedArrayField(
//                 formDataToSend,
//                 'applicableProducts',
//                 formData.applicableProducts,
//                 p => p.value
//             );

//             appendIndexedArrayField(
//                 formDataToSend,
//                 'applicableCategories',
//                 formData.applicableCategories,
//                 c => c.value
//             );

//             appendIndexedArrayField(
//                 formDataToSend,
//                 'excludedProducts',
//                 formData.excludedProducts,
//                 p => p.value
//             );

//             // -------- EXCLUDED ADDONS (Excluding Addons / Excluding Addon Values) --------
//             // Build a flat payload of { addonId, addonValueId, addonTitle, addonValueTitle }
//             const excludedAddonsPayload = (formData?.excludedAddonValues || []).map((val) => {
//                 const addon = allAddonList.find(a => a._id === val.addonId);
//                 const addonValue = addon?.addonValues?.find(v => v._id === val.addValueId);

//                 return {
//                     addonId: val.addonId,
//                     addonValueId: val.addValueId,
//                     addonTitle: addon?.title || val.addonTitle || "",
//                     addonValueTitle: addonValue?.value || val.addonValueTitle || ""
//                 };
//             });

//             appendIndexedArrayField(
//                 formDataToSend,
//                 'excludedAddons',
//                 excludedAddonsPayload,
//                 (item) => JSON.stringify(item)
//             );

//             appendIndexedArrayField(
//                 formDataToSend,
//                 'termsAndConditions',
//                 formData.termsAndConditions
//             );

//             // -------- IMAGE --------
//             if (!isEdit) {
//                 // POST (ADD)
//                 if (
//                     formData.displayImage &&
//                     typeof formData.displayImage === 'string' &&
//                     formData.displayImage.startsWith('data:image')
//                 ) {
//                     const base64Data = formData.displayImage.split(',')[1];
//                     const byteCharacters = atob(base64Data);
//                     const byteNumbers = new Array(byteCharacters.length);

//                     for (let i = 0; i < byteCharacters.length; i++) {
//                         byteNumbers[i] = byteCharacters.charCodeAt(i);
//                     }

//                     const byteArray = new Uint8Array(byteNumbers);
//                     const blob = new Blob([byteArray], { type: 'image/jpeg' });

//                     formDataToSend.append('displayImage', blob, 'coupon-image.jpg');
//                 }
//             } else {
//                 console.log("hello");

//                 // PUT (EDIT)
//                 if (imageAction === 'ADDED' && imageFile) {
//                     // New image uploaded
//                     formDataToSend.append('displayImage', imageFile);

//                 } else if (imageAction === 'REMOVED') {
//                     // Existing image removed
//                     formDataToSend.append('displayImage', null);
//                 }
//             }

//             // -------- EDIT MODE --------
//             if (isEdit) {
//                 formDataToSend.append('_id', selectedCoupon._id);
//                 formDataToSend.append('status', formData.status);
//             }

//             // -------- DEBUG --------
//             console.log("FormData contents:");
//             for (let pair of formDataToSend.entries()) {
//                 console.log(pair[0], pair[1]);
//             }

//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//             };

//             const response = isEdit
//                 ? await axiosInstance.put('auto-coupon-allocation', formDataToSend, { headers })
//                 : await axiosInstance.post('auto-coupon-allocation', formDataToSend, { headers });

//             if (response?.data?.status) {
//                 toast.success(response?.data?.message || 'Coupon saved successfully!');
//                 setShowAddModal(false);
//                 setShowEditModal(false);
//                 resetForm();
//                 setIsEditForm(false);
//                 // Refresh data based on current tab
//                 if (activeTab === 'journey-coupons') {
//                     const filters = {
//                         search: journeySearchQuery,
//                         couponType: journeyCouponTypeFilter,
//                         status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//                         discountType: '',
//                     };
//                     getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//                 } else {
//                     const filters = {
//                         search: regularSearchQuery,
//                         couponType: regularCouponTypeFilter,
//                         status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//                         discountType: '',
//                     };
//                     getCoupons(currentPage, itemsPerPage, filters);
//                 }
//             }

//         } catch (error) {
//             console.error("Submit Error:", error);
//             showError(error, 'Failed to save coupon');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // Delete coupon
//     const handleDelete = async () => {
//         setDeleteLoading(true);

//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//                 'Content-Type': 'application/json'
//             };

//             const data = {
//                 _id: selectedCoupon._id
//             };

//             const response = await axiosInstance.delete('auto-coupon-allocation', { data, headers });

//             if (response?.data?.status === true) {
//                 toast.success('Coupon deleted successfully!', {
//                     position: "top-right",
//                     autoClose: 3000,
//                 });
//                 setShowDeleteModal(false);

//                 // Refresh data based on current tab
//                 if (activeTab === 'journey-coupons') {
//                     const filters = {
//                         search: journeySearchQuery,
//                         couponType: journeyCouponTypeFilter,
//                         status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//                         discountType: '',
//                     };
//                     getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//                 } else {
//                     const filters = {
//                         search: regularSearchQuery,
//                         couponType: regularCouponTypeFilter,
//                         status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//                         discountType: '',
//                     };
//                     getCoupons(currentPage, itemsPerPage, filters);
//                 }
//             }
//         } catch (error) {
//             showError(error, 'Failed to delete coupon');
//         } finally {
//             setDeleteLoading(false);
//         }
//     };

//     // Error handler
//     const showError = (error, defaultMessage) => {
//         console.log("Error :", error);

//         let errorMessage = "";
//         if (error.response?.status === 400) {
//             errorMessage =
//                 error?.response?.data?.data?.title ||
//                 error?.response?.data?.error;
//         } else if (error.response?.status === 406) {
//             errorMessage =
//                 error?.response?.data?.data?.title ||
//                 error?.response?.data?.error;
//         } else if (error.response?.status === 412) {
//             errorMessage =
//                 error?.response?.data?.data?.message ||
//                 error?.response?.data?.data?.title;
//         } else if (error.response?.status === 500) {
//             errorMessage = error?.response?.data?.error;
//         }

//         toast.error(errorMessage, {
//             position: "top-right",
//             autoClose: 3000,
//             theme: 'light'
//         });
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         try {
//             return format(new Date(dateString), 'dd/MM/yyyy');
//         } catch {
//             return dateString;
//         }
//     };

//     // Format datetime
//     const formatDateTime = (dateString) => {
//         try {
//             return format(new Date(dateString), 'dd/MM/yyyy HH:mm');
//         } catch {
//             return dateString;
//         }
//     };

//     // Get coupon type badge
//     const getCouponTypeBadge = (type) => {
//         const variants = {
//             CART: 'primary',
//             UNIVERSAL: 'success',
//             SIZE_UPGRADE: 'info',
//             BOGO: 'danger'
//         };
//         return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
//     };

//     // Get discount type badge
//     const getDiscountTypeBadge = (type) => {
//         const variants = {
//             PERCENT: 'info',
//             FLAT: 'success'
//         };
//         return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
//     };

//     // Get usage type badge
//     const getUsageTypeBadge = (type) => {
//         const variants = {
//             'ONE-TIME': 'primary',
//             MULTIPLE: 'success',
//             UNLIMITED: 'warning'
//         };
//         return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
//     };

//     // Calculate effective discount
//     const calculateEffectiveDiscount = (coupon) => {
//         if (coupon.discountType === 'PERCENT') {
//             return `${coupon.discountPercent}% (Max ₹${coupon.maxDiscountAmount})`;
//         } else {
//             return `₹${coupon.discountAmount} off`;
//         }
//     };

//     // Get coupon type icon
//     const getCouponTypeIcon = (type) => {
//         const icons = {
//             CART: <ShoppingCart size={16} />,
//             PRODUCT: <Package size={16} />,
//             CATEGORY: <Tag size={16} />,
//             SIZE_UPGRADE: <TrendingUp size={16} />,
//             FIRST_ORDER: <Crown size={16} />,
//             BOGO: <Gift size={16} />
//         };
//         return icons[type] || <Tag size={16} />;
//     };

//     // Get coupon type color
//     const getCouponTypeColor = (type) => {
//         const colors = {
//             CART: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
//             PRODUCT: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
//             CATEGORY: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
//             SIZE_UPGRADE: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
//             FIRST_ORDER: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
//             BOGO: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)'
//         };
//         return colors[type] || 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)';
//     };

//     // Refresh function for both tabs
//     const refreshData = () => {
//         if (activeTab === 'journey-coupons') {
//             const filters = {
//                 search: journeySearchQuery,
//                 couponType: journeyCouponTypeFilter,
//                 status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//                 discountType: '',
//             };
//             getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//         } else {
//             const filters = {
//                 search: regularSearchQuery,
//                 couponType: regularCouponTypeFilter,
//                 status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//                 discountType: '',
//             };
//             getCoupons(currentPage, itemsPerPage, filters);
//         }
//     };

//     // Get paginated coupons
//     const getPaginatedCoupons = (couponsList, page) => {
//         const startIndex = (page - 1) * itemsPerPage;
//         const endIndex = startIndex + itemsPerPage;
//         return couponsList?.slice(startIndex, endIndex);
//     };

//     // Get paginated journey coupons
//     const getPaginatedJourneyCoupons = () => {
//         const startIndex = (journeyCurrentPage - 1) * itemsPerPage;
//         const endIndex = startIndex + itemsPerPage;
//         return journeyCoupons.slice(startIndex, endIndex);
//     };

//     const handleChangeJourneySearch = (e) => {
//         setJourneySearchQuery(e.target.value);
//         setIsSearched(true);
//     };

//     const handleSearchJourney = (e) => {
//         e.preventDefault();
//         const filters = {
//             search: journeySearchQuery,
//             couponType: journeyCouponTypeFilter,
//             status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//             discountType: '',
//         };

//         getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//     };

//     const handleChangeRegularSearch = (e) => {
//         setRegularSearchQuery(e.target.value);
//         setIsRegularSearched(true);
//     };

//     const handleSearchRegular = (e) => {
//         e.preventDefault();
//         const filters = {
//             search: regularSearchQuery,
//             couponType: regularCouponTypeFilter,
//             status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//             discountType: '',
//         };

//         getCoupons(currentPage, itemsPerPage, filters);
//     };

//     useEffect(() => {
//         if (isSearched && journeySearchQuery.trim() === '') {
//             const filters = {
//                 search: journeySearchQuery,
//                 couponType: journeyCouponTypeFilter,
//                 status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//                 discountType: '',
//             };

//             getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//         }
//     }, [journeySearchQuery]);

//     useEffect(() => {
//         if (isRegularSearched && regularSearchQuery.trim() === '') {
//             const filters = {
//                 search: regularSearchQuery,
//                 couponType: regularCouponTypeFilter,
//                 status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//                 discountType: '',
//             };

//             getCoupons(currentPage, itemsPerPage, filters);
//         }

//     }, [regularSearchQuery]);

//     // Initialize
//     useEffect(() => {
//         fetchInitialData();
//     }, []);

//     // Effect for regular coupons tab with backend filtering
//     useEffect(() => {
//         const filters = {
//             search: regularSearchQuery,
//             couponType: regularCouponTypeFilter, // ✅ PASS RAW VALUE
//             status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
//             discountType: '',
//         };

//         if (activeTab === 'all-coupons') {
//             getCoupons(currentPage, itemsPerPage, filters);
//         }
//     }, [regularCouponTypeFilter, regularStatusFilter, currentPage, activeTab]);

//     // Effect for journey coupons tab with backend filtering
//     useEffect(() => {
//         const filters = {
//             search: journeySearchQuery,
//             couponType: journeyCouponTypeFilter, // ✅ PASS RAW VALUE
//             status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
//             discountType: '',
//         };

//         if (activeTab === 'journey-coupons') {
//             getJourneyCoupons(journeyCurrentPage, itemsPerPage, filters);
//         }
//     }, [journeyCouponTypeFilter, journeyStatusFilter, journeyCurrentPage, activeTab]);

//     useEffect(() => {
//         if (formData?.nthOrderNumber) {
//             setFormData(prev => ({
//                 ...prev,
//                 maxOrderAmount: '',
//                 minOrderAmount: ''
//             }));
//         }
//     }, [formData?.nthOrderNumber]);

//     useEffect(() => {
//         if (!isEditForm) {
//             console.log("this log is for Add Form if discount type changes");

//             setFormData(prev => ({
//                 ...prev,
//                 discountAmount: '',
//                 discountPercent: '',
//                 maxDiscountAmount: '',
//                 discountPrice: '',
//                 applicableCategories: [],
//                 applicableProducts: [],
//                 excludedProducts: [],
//                 minCartValue: '',
//                 newSizeUpgradeAddon: '',
//             }))
//         }

//         if (isEditForm && isTouched && formData?.discountType) {
//             console.log("this log is for Edit Form if discount type changes");

//             setFormData(prev => ({
//                 ...prev,
//                 discountAmount: '',
//                 discountPercent: '',
//                 maxDiscountAmount: '',
//                 discountPrice: '',
//                 applicableCategories: [],
//                 applicableProducts: [],
//                 excludedProducts: [],
//                 minCartValue: '',
//                 newSizeUpgradeAddon: ''
//             }))
//         }
//     }, [formData?.discountType, isEditForm, isTouched]);

//     useEffect(() => {
//         if (!isEditForm) {
//             console.log("this log is for Add Form if coupon type changes");

//             setFormData(prev => ({
//                 ...prev,
//                 discountAmount: '',
//                 discountPercent: '',
//                 maxDiscountAmount: '',
//                 discountPrice: '',
//                 applicableCategories: [],
//                 applicableProducts: [],
//                 excludedProducts: [],
//                 minCartValue: '',
//                 newSizeUpgradeAddon: '',
//                 freebieQuantity: '',
//                 freebieProduct: ''
//             }))
//         }

//         if (isEditForm && isCouponTypeTouched && formData?.couponType) {
//             console.log("this log is for Edit Form if coupon type changes");

//             setFormData(prev => ({
//                 ...prev,
//                 discountAmount: '',
//                 discountPercent: '',
//                 maxDiscountAmount: '',
//                 discountPrice: '',
//                 applicableCategories: [],
//                 applicableProducts: [],
//                 excludedProducts: [],
//                 minCartValue: '',
//                 newSizeUpgradeAddon: '',
//                 freebieQuantity: '',
//                 freebieProduct: ''
//             }))
//         }
//     }, [formData?.couponType, isEditForm, isCouponTypeTouched]);

//     useEffect(() => {
//         console.log("Edit Coupon");
//         console.log("Discount Percent", formData?.discountPercent);
//         console.log("Max Discount Amount", formData?.maxDiscountAmount);
//         console.log("Applicable Categories", formData?.applicableCategories);
//         console.log("Minimum Cart Value", formData?.minCartValue);

//     }, [handleEditCoupon]);

//     // Render coupon grid - Updated to show image
//     const renderCouponGrid = (couponList, isJourney = false) => {
//         const couponsToDisplay = isJourney ? getPaginatedJourneyCoupons() : couponList;

//         if (loading) {
//             return (
//                 <div className="text-center py-5">
//                     <Spinner animation="border" variant="primary" size="lg" />
//                     <p className="mt-3 mb-0">Loading coupons...</p>
//                 </div>
//             );
//         }

//         if (couponsToDisplay?.length > 0) {
//             return (
//                 <>
//                     <Row className="g-3 mb-4">
//                         {couponsToDisplay?.map((coupon) => (
//                             <Col key={coupon._id} xs={12} sm={6} md={4} lg={2}>
//                                 <div className="coupon-container">
//                                     {/* Coupon Card */}
//                                     <Card className="coupon-card">
//                                         {/* Coupon Image Section - NEW */}
//                                         {coupon.displayImageUrl && (
//                                             <div className="coupon-image-container">
//                                                 <Image
//                                                     src={coupon.displayImageUrl}
//                                                     alt={coupon.title}
//                                                     fluid
//                                                     className="coupon-image"
//                                                 />
//                                             </div>
//                                         )}

//                                         {/* Main Coupon Body */}
//                                         <div
//                                             className="coupon-main"
//                                             style={{
//                                                 background: isJourney ? getJourneyStageColor(coupon.nthOrderNumber) : getCouponTypeColor(coupon.couponType)
//                                             }}
//                                         >
//                                             {/* Coupon Header */}
//                                             <div className="coupon-header">
//                                                 {!isJourney && (
//                                                     <div className="coupon-type">
//                                                         {isJourney
//                                                             ? getJourneyIcon(coupon.nthOrderNumber)
//                                                             : getCouponTypeIcon(coupon.couponType)
//                                                         }
//                                                         <span className="ms-1 coupon-type-text">
//                                                             {isJourney ? 'JOURNEY' : coupon.couponType !== null ? coupon.couponType : coupon.couponType === null && coupon?.applicableCategories?.length > 0 ? 'CATEGORY' : 'PRODUCT'}
//                                                         </span>
//                                                     </div>
//                                                 )}

//                                                 {coupon?.nthOrderNumber && (
//                                                     <div className="nth-order-badge w-100">
//                                                         <Hash size={10} /> {coupon?.nthOrderNumber}
//                                                     </div>
//                                                 )}
//                                             </div>

//                                             {/* Discount Display */}
//                                             <div className="discount-section">
//                                                 <div className="discount-value">
//                                                     {coupon?.couponType === 'SIZE_UPGRADE' ? (
//                                                         <>
//                                                             <span style={{ fontSize: '15px' }}>SIZE_UPGRADE</span>
//                                                         </>
//                                                     ) : coupon?.couponType === 'BOGO' ? (
//                                                         <>
//                                                             <span style={{ fontSize: '15px' }}>BOGO</span>
//                                                         </>
//                                                     ) : coupon?.couponType === 'FREEBIE' ? (
//                                                         <>
//                                                             <span style={{ fontSize: '15px' }}>FREEBIE</span>
//                                                         </>
//                                                     ) : coupon?.discountType === 'PERCENT' ? (
//                                                         <>
//                                                             <span className="percent">{coupon.discountPercent}</span>
//                                                             <span className="percent-symbol">%</span>
//                                                         </>
//                                                     ) : coupon?.discountType === 'FLAT' ? (
//                                                         <>
//                                                             <span className="rupee">₹</span>
//                                                             <span className="amount">{coupon.discountAmount}</span>
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <span className="rupee">₹</span>
//                                                             <span className="amount">{coupon.discountPrice}</span>
//                                                         </>
//                                                     )}
//                                                 </div>

//                                                 {['SIZE_UPGRADE', 'BOGO', 'FREEBIE'].includes(coupon.couponType) ? (
//                                                     <div className="discount-type-badge">Coupon</div>
//                                                 ) : coupon.discountPrice ? (
//                                                     <div className="off-label">ONLY</div>
//                                                 ) : coupon.discountPercent ? (
//                                                     <div className="off-label">OFF</div>
//                                                 ) : coupon.discountAmount ? (
//                                                     <div className="off-label">FLAT</div>
//                                                 ) : (
//                                                     <div className="off-label">PRICE</div>
//                                                 )}
//                                             </div>

//                                             {/* Coupon Title */}
//                                             <div className="coupon-title">
//                                                 <h5 title={coupon.title}>{coupon.title}</h5>
//                                                 {isJourney && coupon.nthOrderNumber && (
//                                                     <small className="journey-subtitle fw-semibold">
//                                                         For Customer's {coupon.nthOrderNumber}th Order
//                                                     </small>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {/* Coupon Details */}
//                                         <div className="coupon-details">
//                                             {/* Usage & Validity */}
//                                             <div className="detail-item">
//                                                 <span className="detail-label">Usage:</span>
//                                                 <span className="detail-value">
//                                                     <Badge bg="light" text="dark" className="usage-badge">
//                                                         ₹. {coupon.usageType}
//                                                     </Badge>
//                                                 </span>
//                                             </div>

//                                             {/* Validity */}
//                                             <div className="detail-item">
//                                                 <span className="detail-label">Validity:</span>
//                                                 <span className="detail-value">{coupon.validityInDays}</span>
//                                             </div>

//                                             {/* Nth Order No: */}
//                                             {(isJourney) && (
//                                                 <div className="detail-item">
//                                                     <span className="detail-label">Nth Order No:</span>
//                                                     <span className="detail-value">
//                                                         <Badge bg="light" text="dark" className="usage-badge">
//                                                             {coupon.nthOrderNumber}
//                                                         </Badge>
//                                                     </span>
//                                                 </div>
//                                             )}

//                                             {/* Min Order Amount */}
//                                             {(!isJourney) && (
//                                                 <div className="detail-item">
//                                                     <span className="detail-label">Min Order Amount:</span>
//                                                     <span className="detail-value">
//                                                         <span className="detail-value">₹. {coupon.minOrderAmount}</span>
//                                                     </span>
//                                                 </div>
//                                             )}

//                                             {/* Max Order Amount */}
//                                             {(!isJourney) && (
//                                                 <div className="detail-item">
//                                                     <span className="detail-label">Max Order Amount:</span>
//                                                     <span className="detail-value">
//                                                         <span className="detail-value">₹. {coupon.maxOrderAmount}</span>
//                                                     </span>
//                                                 </div>
//                                             )}

//                                             {/* Maximum Discount Amount */}
//                                             {coupon.maxDiscountAmount && (
//                                                 <div className="detail-item">
//                                                     <span className="detail-label">Max. Dis Amount:</span>
//                                                     <span className="detail-value">₹. {coupon.maxDiscountAmount}</span>
//                                                 </div>
//                                             )}

//                                             {/* Minimum Cart Value */}
//                                             {coupon.minCartValue && (
//                                                 <div className="detail-item">
//                                                     <span className="detail-label">Min. Cart Value:</span>
//                                                     <span className="detail-value">₹. {coupon.minCartValue}</span>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* Action Buttons */}
//                                         <div className="coupon-actions">
//                                             <Button
//                                                 variant="outline-primary"
//                                                 size="sm"
//                                                 onClick={() => handleViewCoupon(coupon)}
//                                                 className="action-btn"
//                                                 title="View Details"
//                                             >
//                                                 <Eye size={12} />
//                                             </Button>
//                                             <Button
//                                                 variant="outline-success"
//                                                 size="sm"
//                                                 onClick={() => handleEditCoupon(coupon)}
//                                                 className="action-btn"
//                                                 title="Edit Coupon"
//                                             >
//                                                 <Edit size={12} />
//                                             </Button>
//                                             <Button
//                                                 variant="outline-danger"
//                                                 size="sm"
//                                                 onClick={() => handleDeleteCoupon(coupon)}
//                                                 className="action-btn"
//                                                 title="Delete Coupon"
//                                             >
//                                                 <Trash2 size={12} />
//                                             </Button>
//                                         </div>
//                                     </Card>
//                                 </div>
//                             </Col>
//                         ))}
//                     </Row>

//                     {/* Pagination */}
//                     {(isJourney ? journeyTotalPages > 1 : totalPages > 1) && (
//                         <div className="d-flex justify-content-center mt-4">
//                             <Pagination>
//                                 <Pagination.Prev
//                                     onClick={() => {
//                                         if (isJourney && journeyCurrentPage > 1) {
//                                             setJourneyCurrentPage(journeyCurrentPage - 1);
//                                         } else if (!isJourney && currentPage > 1) {
//                                             setCurrentPage(currentPage - 1);
//                                         }
//                                     }}
//                                     disabled={isJourney ? journeyCurrentPage === 1 : currentPage === 1}
//                                 />
//                                 {Array.from({
//                                     length: isJourney ? journeyTotalPages : totalPages
//                                 }, (_, i) => i + 1).map(number => (
//                                     <Pagination.Item
//                                         key={number}
//                                         active={isJourney ? number === journeyCurrentPage : number === currentPage}
//                                         onClick={() => {
//                                             if (isJourney) {
//                                                 setJourneyCurrentPage(number);
//                                             } else {
//                                                 setCurrentPage(number);
//                                             }
//                                         }}
//                                     >
//                                         {number}
//                                     </Pagination.Item>
//                                 ))}
//                                 <Pagination.Next
//                                     onClick={() => {
//                                         if (isJourney && journeyCurrentPage < journeyTotalPages) {
//                                             setJourneyCurrentPage(journeyCurrentPage + 1);
//                                         } else if (!isJourney && currentPage < totalPages) {
//                                             setCurrentPage(currentPage + 1);
//                                         }
//                                     }}
//                                     disabled={isJourney ? journeyCurrentPage === journeyTotalPages : currentPage === totalPages}
//                                 />
//                             </Pagination>
//                         </div>
//                     )}
//                 </>
//             );
//         }

//         return (
//             <div className="text-center py-5">
//                 <div className="py-5">
//                     {isJourney ? (
//                         <>
//                             <Compass size={64} className="text-muted mb-4" />
//                             <h5 className="mb-3">No Journey Coupons Found</h5>
//                             <p className="text-muted mb-4">
//                                 You haven't created any journey coupons yet.
//                             </p>
//                         </>
//                     ) : (
//                         <>
//                             <Ticket size={64} className="text-muted mb-4" />
//                             <h5 className="mb-3">No Auto Coupons Found</h5>
//                             <p className="text-muted mb-4">
//                                 You haven't created any auto coupon allocations yet.
//                             </p>
//                         </>
//                     )}
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <Header onSkin={setSkin} />

//             <div className="main main-app p-3 p-lg-4">
//                 <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
//                     {/* Header */}
//                     <Row className="pt-3">
//                         <Col>
//                             <div className="d-flex align-items-center justify-content-between mb-1">
//                                 <div className="d-flex align-items-center">
//                                     <Ticket className="me-3" size={26} color="#0d6efd" />
//                                     <h4 className="fw-semibold mb-0">AUTO COUPON ALLOCATION</h4>
//                                 </div>
//                                 <Button
//                                     variant="primary"
//                                     onClick={handleAddCoupon}
//                                 >
//                                     <Plus size={16} className="me-2" />
//                                     Create Auto Coupon
//                                 </Button>
//                             </div>
//                         </Col>
//                         <hr />
//                     </Row>

//                     {/* Tabs Navigation */}
//                     <Row className="mb-4">
//                         <Col>
//                             <Tabs
//                                 activeKey={activeTab}
//                                 onSelect={(k) => setActiveTab(k)}
//                                 className="mb-3"
//                             >
//                                 <Tab eventKey="journey-coupons" title={
//                                     <span className="d-flex align-items-center">
//                                         <Compass size={16} className="me-2" />
//                                         Journey Coupons
//                                         {/* <Badge bg="warning" className="ms-2">{totalJourneyCoupons}</Badge> */}
//                                     </span>
//                                 }>
//                                     {/* Journey Coupons Content */}
//                                     <div className="mt-3">
//                                         {/* Filters Section */}
//                                         <Row className="mb-4">
//                                             <Col md={4}>
//                                                 <InputGroup>
//                                                     <div className="input-group w-100">
//                                                         <input
//                                                             type="text"
//                                                             value={journeySearchQuery}
//                                                             onChange={handleChangeJourneySearch}
//                                                             className="form-control"
//                                                             placeholder="Search for Journey Coupons"
//                                                         />
//                                                         <button className="btn btn-primary" type="button" onClick={handleSearchJourney}>
//                                                             <i className="ri-search-line"></i> Search
//                                                         </button>
//                                                     </div>
//                                                 </InputGroup>
//                                             </Col>
//                                             <Col md={3}>
//                                                 <Form.Select
//                                                     value={journeyCouponTypeFilter}
//                                                     onChange={(e) => setJourneyCouponTypeFilter(e.target.value)}
//                                                 >
//                                                     <option value="ALL" >All Coupon Types</option>
//                                                     <option value="BOGO">BOGO</option>
//                                                     <option value="">Category / Product</option>
//                                                     <option value="CART">Cart</option>
//                                                     <option value="FREEBIE">Freebie</option>
//                                                     <option value="SIZE_UPGRADE">Size Upgrade</option>
//                                                     <option value="UNIVERSAL">Universal</option>
//                                                 </Form.Select>
//                                             </Col>
//                                             <Col md={3}>
//                                                 <Form.Select
//                                                     value={journeyStatusFilter}
//                                                     onChange={(e) => setJourneyStatusFilter(e.target.value)}
//                                                 >
//                                                     <option value="ALL">All Status</option>
//                                                     <option value="ACTIVE">Active</option>
//                                                     <option value="INACTIVE">Inactive</option>
//                                                 </Form.Select>
//                                             </Col>
//                                         </Row>

//                                         {/* Stats & Actions */}
//                                         <Row className="mb-4">
//                                             <Col>
//                                                 <div className="d-flex justify-content-between align-items-center">
//                                                     <div>
//                                                         <h6 className="mb-1">
//                                                             <strong>{totalJourneyCoupons}</strong> Journey Coupons
//                                                         </h6>
//                                                         <small className="text-muted">
//                                                             Showing {Math.min(itemsPerPage, journeyCoupons.length)} of {totalJourneyCoupons}
//                                                         </small>
//                                                     </div>
//                                                     <Button
//                                                         variant="outline-primary"
//                                                         onClick={refreshData}
//                                                         disabled={loading}
//                                                     >
//                                                         <RefreshCw size={16} className="me-2" />
//                                                         {loading ? 'Refreshing...' : 'Refresh'}
//                                                     </Button>
//                                                 </div>
//                                             </Col>
//                                         </Row>

//                                         {/* Journey Coupons Grid */}
//                                         {renderCouponGrid(journeyCoupons, true)}
//                                     </div>
//                                 </Tab>

//                                 <Tab eventKey="all-coupons" title={
//                                     <span className="d-flex align-items-center">
//                                         <Ticket size={16} className="me-2" />
//                                         Other Coupons
//                                         {/* <Badge bg="primary" className="ms-2">{totalCoupons}</Badge> */}
//                                     </span>
//                                 }>
//                                     {/* All Coupons Content */}
//                                     <div className="mt-3">
//                                         {/* Filters Section */}
//                                         <Row className="mb-4">
//                                             <Col md={6}>
//                                                 <InputGroup>
//                                                     {/* <InputGroup.Text>
//                                                         <Search size={18} />
//                                                     </InputGroup.Text>
//                                                     <FormControl
//                                                         placeholder="Search non-journey coupons..."
//                                                         value={regularSearchQuery}
//                                                         onChange={(e) => setRegularSearchQuery(e.target.value)}
//                                                     /> */}
//                                                     <div className="input-group w-100">
//                                                         <input
//                                                             type="text"
//                                                             value={regularSearchQuery}
//                                                             onChange={handleChangeRegularSearch}
//                                                             className="form-control"
//                                                             placeholder="Search for Regular Coupons"
//                                                         />
//                                                         <button className="btn btn-primary" type="button" onClick={handleSearchRegular}>
//                                                             <i className="ri-search-line"></i> Search
//                                                         </button>
//                                                     </div>
//                                                 </InputGroup>
//                                             </Col>
//                                             <Col md={3}>
//                                                 <Form.Select
//                                                     value={regularCouponTypeFilter}
//                                                     onChange={(e) => setRegularCouponTypeFilter(e.target.value)}
//                                                 >
//                                                     <option value="ALL" >All Coupon Types</option>
//                                                     <option value="BOGO">BOGO</option>
//                                                     <option value="">Category / Product</option>
//                                                     <option value="CART">Cart</option>
//                                                     <option value="FREEBIE">Freebie</option>
//                                                     <option value="SIZE_UPGRADE">Size Upgrade</option>
//                                                     <option value="UNIVERSAL">Universal</option>
//                                                 </Form.Select>
//                                             </Col>
//                                             <Col md={3}>
//                                                 <Form.Select
//                                                     value={regularStatusFilter}
//                                                     onChange={(e) => setRegularStatusFilter(e.target.value)}
//                                                 >
//                                                     <option value="ALL">All Status</option>
//                                                     <option value="ACTIVE">Active</option>
//                                                     <option value="INACTIVE">Inactive</option>
//                                                 </Form.Select>
//                                             </Col>
//                                         </Row>

//                                         {/* Stats & Actions */}
//                                         <Row className="mb-4">
//                                             <Col>
//                                                 <div className="d-flex justify-content-between align-items-center">
//                                                     <div>
//                                                         <h6 className="mb-1">
//                                                             <strong>{totalCoupons}</strong> Non-Journey Coupons
//                                                         </h6>
//                                                         <small className="text-muted">
//                                                             Showing {Math.min(itemsPerPage, filteredCoupons.length)} of {totalCoupons}
//                                                         </small>
//                                                     </div>
//                                                     <Button
//                                                         variant="outline-primary"
//                                                         onClick={refreshData}
//                                                         disabled={loading}
//                                                     >
//                                                         <RefreshCw size={16} className="me-2" />
//                                                         {loading ? 'Refreshing...' : 'Refresh'}
//                                                     </Button>
//                                                 </div>
//                                             </Col>
//                                         </Row>

//                                         {/* Coupons Grid */}
//                                         {renderCouponGrid(filteredCoupons, false)}
//                                     </div>
//                                 </Tab>

//                             </Tabs>
//                         </Col>
//                     </Row>
//                 </div>

//                 {/* Add/Edit Modal */}
//                 <Modal show={showAddModal || showEditModal} onHide={() => {
//                     setShowAddModal(false);
//                     setShowEditModal(false);
//                     setIsEditForm(false);
//                     setIsTouched(false);
//                     resetForm();
//                 }} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>
//                             <Ticket size={20} className="me-2" />
//                             {showEditModal ? 'Edit Auto Coupon' : 'Create Auto Coupon'}
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Form onSubmit={handleSubmit}>
//                         <Modal.Body>
//                             <Accordion activeKey={activeAccordion} onSelect={(k) => setActiveAccordion(k)}>
//                                 {/* Basic Information - Updated with Image Upload */}
//                                 <Accordion.Item eventKey="0">
//                                     <Accordion.Header>Basic Information</Accordion.Header>
//                                     <Accordion.Body>
//                                         <Row>
//                                             <Col>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Title <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Form.Control
//                                                         type="text"
//                                                         name="title"
//                                                         value={formData.title}
//                                                         onChange={handleInputChange}
//                                                         placeholder="Enter coupon title"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>

//                                             {isEditForm && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Status<span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             name="status"
//                                                             value={formData?.status}
//                                                             onChange={handleInputChange}
//                                                         >
//                                                             <option value="">Select Status</option>
//                                                             <option value="ACTIVE">ACTIVE</option>
//                                                             <option value="INACTIVE">INACTIVE</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             <Col md={12}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">Description <span className='text-danger'>*</span></Form.Label>
//                                                     <Form.Control
//                                                         as="textarea"
//                                                         rows={3}
//                                                         name="description"
//                                                         value={formData.description}
//                                                         onChange={handleInputChange}
//                                                         placeholder="Enter coupon description"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>

//                                             {/* Display Image Upload Section - NEW */}
//                                             <Col md={12}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold d-flex align-items-center">
//                                                         <ImageIcon size={16} className="me-2" />
//                                                         Coupon Display Image
//                                                         <span className="text-danger ms-1">*</span>
//                                                     </Form.Label>

//                                                     {imagePreview ? (
//                                                         <div className="image-preview-container mb-3">
//                                                             <div className="d-flex align-items-center justify-content-between mb-2">
//                                                                 <small className="text-success">
//                                                                     <CheckCircle size={14} className="me-1" />
//                                                                     Image added successfully
//                                                                 </small>
//                                                                 <Button
//                                                                     variant="outline-danger"
//                                                                     size="sm"
//                                                                     onClick={handleRemoveImage}
//                                                                     disabled={uploadingImage}
//                                                                 >
//                                                                     <X size={14} className="me-1" />
//                                                                     Remove
//                                                                 </Button>
//                                                             </div>
//                                                             <div className="border rounded p-2 bg-light">
//                                                                 <Image
//                                                                     src={imagePreview}
//                                                                     alt="Coupon preview"
//                                                                     fluid
//                                                                     className="uploaded-image-preview"
//                                                                     style={{ maxHeight: '150px', objectFit: 'contain' }}
//                                                                 />
//                                                             </div>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="image-upload-area border rounded p-4 text-center">
//                                                             <input
//                                                                 type="file"
//                                                                 id="couponImageUpload"
//                                                                 accept="image/*"
//                                                                 onChange={handleImageChange}
//                                                                 className="d-none"
//                                                                 disabled={uploadingImage}
//                                                             />
//                                                             <label htmlFor="couponImageUpload" className="cursor-pointer d-flex flex-column align-items-center">
//                                                                 {uploadingImage ? (
//                                                                     <>
//                                                                         <Spinner animation="border" size="sm" className="mb-2" />
//                                                                         <small>Processing image...</small>
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <Upload size={48} className="text-muted mb-2" />
//                                                                         <div className="mb-2">
//                                                                             <Button style={{ pointerEvents: 'none' }} variant="outline-primary" size="sm">
//                                                                                 Choose Image
//                                                                             </Button>
//                                                                         </div>
//                                                                         <small className="text-muted">
//                                                                             Recommended: JPG/PNG/WEBP/GIF (Max 5MB)
//                                                                         </small>
//                                                                     </>
//                                                                 )}
//                                                             </label>
//                                                         </div>
//                                                     )}

//                                                     <Form.Text className="text-muted">
//                                                         This image will be displayed with the coupon in the app.
//                                                     </Form.Text>
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>
//                                     </Accordion.Body>
//                                 </Accordion.Item>

//                                 {/* Discount Configuration */}
//                                 <Accordion.Item eventKey="1">
//                                     <Accordion.Header>Coupon Details</Accordion.Header>
//                                     <Accordion.Body>
//                                         <Row>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Coupon Type <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Form.Select
//                                                         name="couponType"
//                                                         value={formData.couponType}
//                                                         onChange={handleInputChange}
//                                                         disabled={isEditForm}
//                                                     >
//                                                         <option value="All">Select Coupon Type</option>
//                                                         <option value="">Category / Product</option>
//                                                         <option value="BOGO">BOGO</option>
//                                                         <option value="CART">Cart</option>
//                                                         <option value="FREEBIE">Freebie</option>
//                                                         <option value="SIZE_UPGRADE">Size Upgrade</option>
//                                                         <option value="UNIVERSAL">Universal</option>
//                                                     </Form.Select>
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Usage Type <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Form.Select
//                                                         name="usageType"
//                                                         value={formData.usageType}
//                                                         onChange={handleInputChange}
//                                                     >
//                                                         <option value="ONE-TIME">One Time Use</option>
//                                                         <option value="MULTIPLE">Multiple Use</option>
//                                                     </Form.Select>
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                         <Row>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Nth Order Number
//                                                     </Form.Label>
//                                                     <Form.Control
//                                                         type="number"
//                                                         name="nthOrderNumber"
//                                                         value={formData.nthOrderNumber}
//                                                         onChange={handleInputChange}
//                                                         disabled={formData.maxOrderAmount && formData.minOrderAmount}
//                                                         placeholder="For Which Order You Want to Give This Coupon"
//                                                         min="2"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">
//                                                         Validity (Days) <span className="text-danger">*</span>
//                                                     </Form.Label>
//                                                     <Form.Control
//                                                         type="number"
//                                                         name="validityInDays"
//                                                         value={formData.validityInDays}
//                                                         onChange={handleInputChange}
//                                                         placeholder="Coupon validity in days"
//                                                         min="1"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                         <Row>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">Minimum Order Amount</Form.Label>
//                                                     <Form.Control
//                                                         type="number"
//                                                         name="minOrderAmount"
//                                                         value={formData.minOrderAmount}
//                                                         onChange={handleInputChange}
//                                                         placeholder="Enter minimum order amount"
//                                                         disabled={formData.nthOrderNumber}
//                                                         min="1"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                             <Col md={6}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">Maximum Order Amount</Form.Label>
//                                                     <Form.Control
//                                                         type="number"
//                                                         name="maxOrderAmount"
//                                                         value={formData?.maxOrderAmount}
//                                                         onChange={handleInputChange}
//                                                         placeholder="Enter maximum order amount"
//                                                         disabled={formData?.nthOrderNumber}
//                                                         min="1"
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                     </Accordion.Body>
//                                 </Accordion.Item>

//                                 {/* Applicability Rules */}
//                                 <Accordion.Item eventKey="2">
//                                     <Accordion.Header>Discount Configuration</Accordion.Header>
//                                     <Accordion.Body>
//                                         <Row>
//                                             {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Discount Type <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             name="discountType"
//                                                             value={formData.discountType}
//                                                             onChange={handleInputChange}
//                                                         >
//                                                             <option value="PERCENT">Percentage</option>
//                                                             {!['UNIVERSAL', 'CART', 'CART', 'FREEBIE'].includes(formData?.couponType) && (
//                                                                 <option value="PRICE">Discounted Price</option>
//                                                             )}
//                                                             {!['UNIVERSAL'].includes(formData?.couponType) && (
//                                                                 <option value="FLAT">Flat Amount</option>
//                                                             )}
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE', 'CART', 'UNIVERSAL'].includes(formData?.couponType) && formData?.discountType === 'PRICE' && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Applicable Qty Type <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Select
//                                                             name="applicableQuantityType"
//                                                             value={formData.applicableQuantityType}
//                                                             onChange={handleInputChange}
//                                                         >
//                                                             <option value="SINGLE">Single Use</option>
//                                                             <option value="MULTIPLE">Multiple Use</option>
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {(formData.discountType === 'PRICE' && formData.couponType !== 'BOGO' && formData?.couponType !== 'SIZE_UPGRADE' && formData?.couponType !== 'FREEBIE') && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Discounted Price <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Control
//                                                             type="number"
//                                                             name="discountPrice"
//                                                             value={formData.discountPrice}
//                                                             disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
//                                                             onChange={handleInputChange}
//                                                             placeholder="Enter discounted price"
//                                                             min="1"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {!['UNIVERSAL', 'SIZE_UPGRADE'].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Minimum Cart Value</Form.Label>
//                                                         <Form.Control
//                                                             type="number"
//                                                             name="minCartValue"
//                                                             value={formData.minCartValue}
//                                                             onChange={handleInputChange}
//                                                             placeholder="Enter minimum cart value"
//                                                             min="1"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {(formData.discountType === 'PERCENT' && formData.couponType !== 'BOGO' && formData?.couponType !== 'SIZE_UPGRADE' && formData?.couponType !== 'FREEBIE') ? (
//                                                 <>
//                                                     <Col md={6}>
//                                                         <Form.Group className="mb-3">
//                                                             <Form.Label className="fw-semibold">
//                                                                 Discount Percent <span className="text-danger">*</span>
//                                                             </Form.Label>
//                                                             <Form.Control
//                                                                 type="number"
//                                                                 name="discountPercent"
//                                                                 value={formData.discountPercent}
//                                                                 disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
//                                                                 onChange={handleInputChange}
//                                                                 placeholder="Enter discount percentage"
//                                                                 min="1"
//                                                                 max="100"
//                                                             />
//                                                         </Form.Group>
//                                                     </Col>
//                                                     <Col md={6}>
//                                                         <Form.Group className="mb-3">
//                                                             <Form.Label className="fw-semibold">
//                                                                 Max Discount Amount
//                                                             </Form.Label>
//                                                             <Form.Control
//                                                                 type="number"
//                                                                 name="maxDiscountAmount"
//                                                                 value={formData.maxDiscountAmount}
//                                                                 disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
//                                                                 onChange={handleInputChange}
//                                                                 placeholder="Enter maximum discount amount"
//                                                                 min="1"
//                                                             />
//                                                         </Form.Group>
//                                                     </Col>
//                                                 </>
//                                             ) : (
//                                                 <>
//                                                     {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType) && formData?.discountType !== 'PRICE' && formData?.discountType !== 'PERCENT' && (
//                                                         <Col md={6}>
//                                                             <Form.Group className="mb-3">
//                                                                 <Form.Label className="fw-semibold">
//                                                                     Discount Amount <span className="text-danger">*</span>
//                                                                 </Form.Label>
//                                                                 <Form.Control
//                                                                     type="number"
//                                                                     name="discountAmount"
//                                                                     value={formData.discountAmount}
//                                                                     disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
//                                                                     onChange={handleInputChange}
//                                                                     placeholder="Enter flat discount amount"
//                                                                     min="1"
//                                                                 />
//                                                             </Form.Group>
//                                                         </Col>
//                                                     )}
//                                                 </>
//                                             )}

//                                             {formData?.couponType === 'FREEBIE' && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Freebie Products</Form.Label>
//                                                         <Select
//                                                             options={freebieProducts}
//                                                             value={freebieProducts?.find(
//                                                                 opt => opt.value === formData.freebieProduct
//                                                             )}
//                                                             onChange={handleSelectChange}
//                                                             placeholder="Select freebie product..."
//                                                             styles={customSelectStyles}
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}
//                                             {formData.couponType === 'FREEBIE' && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">
//                                                             Freebie Quantity <span className="text-danger">*</span>
//                                                         </Form.Label>
//                                                         <Form.Control
//                                                             type="number"
//                                                             name="freebieQuantity"
//                                                             value={formData.freebieQuantity}
//                                                             disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE'}
//                                                             onChange={handleInputChange}
//                                                             placeholder="Enter Freebie quantity"
//                                                             min="1"
//                                                             max="100"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {!['CART', 'FREEBIE', 'SIZE_UPGRADE', 'UNIVERSAL'].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Applicable Categories</Form.Label>
//                                                         <Select
//                                                             isMulti
//                                                             closeMenuOnSelect={false}
//                                                             options={categories}
//                                                             value={formData.applicableCategories}
//                                                             onChange={(selected) => handleMultiSelectChange('applicableCategories', selected)}
//                                                             placeholder="Select applicable categories..."
//                                                             styles={customSelectStyles}
//                                                             isDisabled={formData?.couponType == 'FREEBIE'}
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}
//                                             {/* {(formData?.couponType !== 'FREEBIE') && ( */}
//                                             <Col md="6" lg="6" className='mb-3'>
//                                                 <Form.Label className="fw-semibold">
//                                                     Select Excluded Products
//                                                 </Form.Label>
//                                                 <Select
//                                                     isMulti
//                                                     value={formData?.excludedProducts}
//                                                     onChange={(selected) => handleMultiSelectChange('excludedProducts', selected)}
//                                                     options={excludedProducts}
//                                                     placeholder="Select Excluded Products"
//                                                     closeMenuOnSelect={false}
//                                                     styles={customSelectStyles}
//                                                     formatOptionLabel={(option) => (
//                                                         <span style={{ color: option.isDelete ? '#dc3545' : 'inherit', fontWeight: option.isDelete ? 600 : 'normal' }}>
//                                                             {option.label}{option.isDelete ? ' (Deleted)' : ''}
//                                                         </span>
//                                                     )}
//                                                     theme={(theme) => ({
//                                                         ...theme,
//                                                         borderRadius: 0,
//                                                         colors: { ...theme.colors, primary25: "#e9ecef", primary: "#007bff" },
//                                                     })}
//                                                     isLoading={loadingExcludedProducts}
//                                                     noOptionsMessage={() => "No products found"}
//                                                 />
//                                                 <Form.Text className="text-muted">
//                                                     Products to exclude from this coupon
//                                                 </Form.Text>
//                                             </Col>
//                                             {/* )} */}

//                                             {/* 👇 Added: Select Excluding Addons */}
//                                             <Col md={6} className='mb-3'>
//                                                 <Form.Group>
//                                                     <Form.Label className="fw-semibold">
//                                                         Select Excluding Addons
//                                                     </Form.Label>
//                                                     <Select
//                                                         isMulti
//                                                         closeMenuOnSelect={false}
//                                                         options={allAddonList?.map(addon => ({
//                                                             value: addon._id,
//                                                             label: addon.title
//                                                         }))}
//                                                         value={selectedAddonGroups}
//                                                         onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
//                                                         styles={customSelectStyles}
//                                                         placeholder="Select addon groups..."
//                                                         theme={(theme) => ({
//                                                             ...theme,
//                                                             borderRadius: 0,
//                                                             colors: { ...theme.colors, primary25: "#e9ecef", primary: "#007bff" },
//                                                         })}
//                                                     />
//                                                 </Form.Group>
//                                             </Col>

//                                             {/* 👇 Added: Select Excluding Addon Values */}
//                                             <Col md={6} className='mb-3'>
//                                                 <Form.Group>
//                                                     <Form.Label className='fw-semibold'>
//                                                         Select Excluding Addon Values
//                                                     </Form.Label>
//                                                     <Select
//                                                         isMulti
//                                                         closeMenuOnSelect={false}
//                                                         options={filteredAddonValues}
//                                                         value={formData?.excludedAddonValues?.map(val => ({
//                                                             value: val,
//                                                             label: `${allAddonList.find(a => a._id === val.addonId)?.title || val.addonTitle || ''} - ${
//                                                                 allAddonList
//                                                                     .find(a => a._id === val.addonId)
//                                                                     ?.addonValues?.find(v => v._id === val.addValueId)?.value
//                                                                 || val.addonValueTitle || ''
//                                                             }`
//                                                         }))}
//                                                         onChange={(selectedOptions) => {
//                                                             setFormData(prev => ({
//                                                                 ...prev,
//                                                                 excludedAddonValues: selectedOptions ? selectedOptions.map(opt => opt.value) : []
//                                                             }));
//                                                         }}
//                                                         styles={customSelectStyles}
//                                                         placeholder="Select addon values to exclude..."
//                                                         getOptionLabel={(option) => option.label}
//                                                         getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
//                                                         noOptionsMessage={() =>
//                                                             selectedAddonGroups.length === 0
//                                                                 ? "Select an addon group first"
//                                                                 : "No addon values found"
//                                                         }
//                                                     />
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                         <Row>
//                                             {!['CART', 'FREEBIE', 'BOGO', 'UNIVERSAL', ''].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Applicable Categories</Form.Label>
//                                                         <Select
//                                                             isMulti
//                                                             options={categories}
//                                                             value={formData.applicableCategories}
//                                                             onChange={(selected) => handleMultiSelectChange('applicableCategories', selected)}
//                                                             placeholder="Select applicable categories..."
//                                                             styles={customSelectStyles}
//                                                             isDisabled={formData?.couponType == 'FREEBIE'}
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {!['BOGO', 'CART', 'FREEBIE', 'UNIVERSAL'].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Applicable Products</Form.Label>
//                                                         <Select
//                                                             isMulti
//                                                             closeMenuOnSelect={false}
//                                                             options={formData.couponType === 'SIZE_UPGRADE' ? addonsProducts : productsData}
//                                                             value={formData.applicableProducts}
//                                                             onChange={(selected) => handleMultiSelectChange('applicableProducts', selected)}
//                                                             placeholder="Select applicable products..."
//                                                             styles={customSelectStyles}
//                                                             formatOptionLabel={(option) => (
//                                                                 <span style={{ color: option.isDelete ? '#dc3545' : 'inherit', fontWeight: option.isDelete ? 600 : 'normal' }}>
//                                                                     {option.label}{option.isDelete ? ' (Deleted)' : ''}
//                                                                 </span>
//                                                             )}
//                                                             isDisabled={formData?.couponType == 'FREEBIE'}
//                                                         />
//                                                         {/* <Select
//                                                             isMulti
//                                                             closeMenuOnSelect={false}
//                                                             options={formData.couponType === 'SIZE_UPGRADE' ? addonsProducts : productsData}
//                                                             value={formData.applicableProducts}
//                                                             onChange={(selected) => handleMultiSelectChange('applicableProducts', selected)}
//                                                             placeholder="Select applicable products..."
//                                                             styles={customSelectStyles}
//                                                             isDisabled={formData?.couponType == 'FREEBIE'}
//                                                         /> */}
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {!['UNIVERSAL', 'FREEBIE', 'BOGO', 'CART', ''].includes(formData?.couponType) && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Minimum Cart Value</Form.Label>
//                                                         <Form.Control
//                                                             type="number"
//                                                             name="minCartValue"
//                                                             value={formData.minCartValue}
//                                                             onChange={handleInputChange}
//                                                             placeholder="Enter minimum cart value"
//                                                             min="1"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}

//                                             {formData?.couponType === 'SIZE_UPGRADE' && (
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label className="fw-semibold">Size Upgrade Addon <span className='ms-1 text-danger'>*</span></Form.Label>
//                                                         <Form.Select
//                                                             name="newSizeUpgradeAddon"
//                                                             value={formData.newSizeUpgradeAddon}
//                                                             onChange={handleInputChange}
//                                                         >
//                                                             <option value="">Select Size Upgrade Addon</option>
//                                                             {newSizeAddonsList?.map((addon) => (
//                                                                 <option key={addon._id} value={addon._id}>{addon.title} [{addon.identifier}]</option>
//                                                             ))}
//                                                         </Form.Select>
//                                                     </Form.Group>
//                                                 </Col>
//                                             )}
//                                         </Row>
//                                     </Accordion.Body>
//                                 </Accordion.Item>

//                                 {/* Terms and Conditions */}
//                                 <Accordion.Item eventKey="3">
//                                     <Accordion.Header>Terms and Conditions</Accordion.Header>
//                                     <Accordion.Body>
//                                         <Row>
//                                             <Col md={12}>
//                                                 <Form.Group className="mb-3">
//                                                     <Form.Label className="fw-semibold">Add Terms</Form.Label>
//                                                     <InputGroup>
//                                                         <Form.Control
//                                                             type="text"
//                                                             value={termInput}
//                                                             onChange={(e) => setTermInput(e.target.value)}
//                                                             placeholder="Enter a term and condition"
//                                                             onKeyPress={(e) => {
//                                                                 if (e.key === 'Enter') {
//                                                                     e.preventDefault();
//                                                                     handleAddTerm();
//                                                                 }
//                                                             }}
//                                                         />
//                                                         <Button
//                                                             variant="outline-primary"
//                                                             onClick={handleAddTerm}
//                                                         >
//                                                             Add
//                                                         </Button>
//                                                     </InputGroup>
//                                                 </Form.Group>
//                                             </Col>
//                                         </Row>

//                                         {/* Terms List */}
//                                         {formData.termsAndConditions.length > 0 && (
//                                             <Row>
//                                                 <Col md={12}>
//                                                     <div className="border rounded p-3">
//                                                         <h6 className="mb-3">Added Terms:</h6>
//                                                         <ul className="list-group">
//                                                             {formData.termsAndConditions.map((term, index) => (
//                                                                 <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
//                                                                     <span>{term}</span>
//                                                                     <Button
//                                                                         variant="outline-danger"
//                                                                         size="sm"
//                                                                         onClick={() => handleRemoveTerm(index)}
//                                                                     >
//                                                                         <X size={14} />
//                                                                     </Button>
//                                                                 </li>
//                                                             ))}
//                                                         </ul>
//                                                     </div>
//                                                 </Col>
//                                             </Row>
//                                         )}
//                                     </Accordion.Body>
//                                 </Accordion.Item>
//                             </Accordion>
//                         </Modal.Body>
//                         <Modal.Footer>
//                             <Button
//                                 variant="secondary"
//                                 onClick={() => {
//                                     setShowAddModal(false);
//                                     setShowEditModal(false);
//                                     setIsEditForm(false);
//                                     resetForm();
//                                 }}
//                                 disabled={submitting}
//                             >
//                                 Cancel
//                             </Button>
//                             <Button
//                                 variant="primary"
//                                 type="submit"
//                                 disabled={submitting || uploadingImage}
//                             >
//                                 {submitting ? (
//                                     <>
//                                         <Spinner
//                                             as="span"
//                                             animation="border"
//                                             size="sm"
//                                             className="me-2"
//                                         />
//                                         {showEditModal ? 'Updating...' : 'Creating...'}
//                                     </>
//                                 ) : (
//                                     showEditModal ? 'Update Coupon' : 'Create Coupon'
//                                 )}
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal>

//                 {/* View Modal - Updated to show image */}
//                 <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>
//                             <Ticket size={20} className="me-2" />
//                             Coupon Details
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         {selectedCoupon ? (
//                             <div className="coupon-details">
//                                 {/* Coupon Image - NEW */}
//                                 {selectedCoupon.displayImageUrl && (
//                                     <div className="text-center mb-4">
//                                         <Image
//                                             src={selectedCoupon.displayImageUrl}
//                                             alt={selectedCoupon.title}
//                                             fluid
//                                             className="rounded border"
//                                             style={{ maxHeight: '200px', objectFit: 'contain' }}
//                                         />
//                                     </div>
//                                 )}

//                                 {/* Header */}
//                                 <div className="d-flex align-items-center justify-content-between mb-4">
//                                     <div className='text-white'>.</div>
//                                     <div>
//                                         <h4 className="fw-bold mb-1">{selectedCoupon.title}</h4>
//                                         <p className="text-muted text-center mb-0">{selectedCoupon.description}</p>
//                                     </div>
//                                     <div className="d-flex gap-2">
//                                         {selectedCoupon.nthOrderNumber && parseInt(selectedCoupon.nthOrderNumber) >= 2 && (
//                                             <Badge bg="warning" className="journey-badge">
//                                                 <Compass size={12} className="me-1" />
//                                                 Journey Coupon
//                                             </Badge>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Discount Summary Row */}
//                                 <div className="mb-4">
//                                     <div className="discount-summary-card p-3 border rounded bg-light">
//                                         <div className="row align-items-center">
//                                             <div className="col-md-6">
//                                                 <h5 className="mb-1">Discount Offered</h5>
//                                                 <p className="text-muted small mb-0">Effective discount value for customers</p>
//                                             </div>
//                                             <div className="col-md-6 text-end">
//                                                 <div className="display-5 fw-bold text-success">
//                                                     {selectedCoupon.couponType === 'SIZE_UPGRADE' ? (
//                                                         <>SIZE UPGRADE</>
//                                                     ) : selectedCoupon.couponType === 'BOGO' ? (
//                                                         <>BOGO OFFER</>
//                                                     ) : selectedCoupon.couponType === 'FREEBIE' ? (
//                                                         <>FREEBIE</>
//                                                     ) : selectedCoupon.discountType === 'PERCENT' ? (
//                                                         <>{selectedCoupon.discountPercent}% OFF</>
//                                                     ) : selectedCoupon.discountAmount ? (
//                                                         <>₹ {selectedCoupon.discountAmount} OFF</>
//                                                     ) : selectedCoupon.discountPercent ? (
//                                                         <>{selectedCoupon.discountPercent}% OFF</>
//                                                     ) : (
//                                                         <>₹ {selectedCoupon.discountPrice} ONLY</>
//                                                     )}
//                                                 </div>
//                                                 {selectedCoupon.discountType === 'PERCENT' && selectedCoupon.maxDiscountAmount && (
//                                                     <div className="text-muted small">
//                                                         (Maximum ₹{selectedCoupon.maxDiscountAmount})
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Journey Stage Info */}
//                                 {selectedCoupon.nthOrderNumber && (
//                                     <div className="mb-4">
//                                         <h6 className="d-flex align-items-center">
//                                             <Route size={16} className="me-2" />
//                                             Journey Information
//                                         </h6>
//                                         <div className="journey-info-card p-3 border rounded">
//                                             <div className="row">
//                                                 <div className="col-md-12">
//                                                     <div className="mb-2">
//                                                         <small className="text-muted me-3">Applicable Order : </small>
//                                                         <strong>On Customer's {selectedCoupon.nthOrderNumber}th Order</strong>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Details in Cards */}
//                                 <Row className="g-3">
//                                     {/* Basic Info - Updated to include image info */}
//                                     <Col md={6}>
//                                         <Card className="h-100">
//                                             <Card.Header className="bg-light">
//                                                 <h6 className="mb-0">
//                                                     <Award size={16} className="me-2" />
//                                                     Basic Information
//                                                 </h6>
//                                             </Card.Header>
//                                             <Card.Body>
//                                                 <div className="mb-2">
//                                                     <small className="text-muted d-block">Coupon Type:</small>
//                                                     <strong>{selectedCoupon.couponType ? selectedCoupon.couponType : 'Category / Products'}</strong>
//                                                 </div>
//                                                 <div className="mb-2">
//                                                     <small className="text-muted d-block">Usage Type:</small>
//                                                     <strong>{selectedCoupon.usageType}</strong>
//                                                 </div>
//                                                 <div className="mb-2">
//                                                     <small className="text-muted d-block">Validity:</small>
//                                                     <strong>{selectedCoupon.validityInDays} days</strong>
//                                                 </div>
//                                                 {selectedCoupon.maxOrderAmount && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Max Order Amount:</small>
//                                                         <strong>₹{selectedCoupon.maxOrderAmount}</strong>
//                                                     </div>
//                                                 )}
//                                                 {selectedCoupon.minOrderAmount && (
//                                                     <div className="mb-2 mt-3">
//                                                         <small className="text-muted d-block">Min Order Amount:</small>
//                                                         <strong>₹{selectedCoupon.minOrderAmount || '0'}</strong>
//                                                     </div>
//                                                 )}
//                                             </Card.Body>
//                                         </Card>
//                                     </Col>

//                                     {/* Discount Info */}
//                                     <Col md={6}>
//                                         <Card className="h-100">
//                                             <Card.Header className="bg-light">
//                                                 <h6 className="mb-0">
//                                                     <Percent size={16} className="me-2" />
//                                                     Discount Details
//                                                 </h6>
//                                             </Card.Header>
//                                             <Card.Body>

//                                                 {selectedCoupon.couponType === 'SIZE_UPGRADE' ? (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Offer Type:</small>
//                                                         <strong>Size Upgrade Coupon</strong>
//                                                     </div>
//                                                 ) : selectedCoupon.couponType === 'BOGO' ? (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Offer Type:</small>
//                                                         <strong>Buy One Get One Offer</strong>
//                                                     </div>
//                                                 ) : selectedCoupon.couponType === 'FREEBIE' ? (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Offer Type:</small>
//                                                         <strong>Freebie Offer</strong>
//                                                     </div>
//                                                 ) : selectedCoupon.discountType === 'PERCENT' ? (
//                                                     <>
//                                                         <div className="mb-2">
//                                                             <small className="text-muted d-block">Discount Percentage:</small>
//                                                             <div className="d-flex align-items-center">
//                                                                 <strong className="me-2">{selectedCoupon.discountPercent}%</strong>
//                                                             </div>
//                                                         </div>
//                                                         {selectedCoupon.maxDiscountAmount && (
//                                                             <div className="mb-2">
//                                                                 <small className="text-muted d-block">Maximum Discount:</small>
//                                                                 <strong>₹ {selectedCoupon.maxDiscountAmount}</strong>
//                                                             </div>
//                                                         )}
//                                                     </>
//                                                 ) : selectedCoupon.discountType === 'FLAT' ? (
//                                                     <>
//                                                         <div className="mb-2">
//                                                             <small className="text-muted d-block">Flat Discount:</small>
//                                                             <strong>₹ {selectedCoupon.discountAmount || '0'}</strong>
//                                                         </div>
//                                                     </>
//                                                 ) : (
//                                                     <>
//                                                         {selectedCoupon.discountPercent && (
//                                                             <div className="mb-2">
//                                                                 <small className="text-muted d-block">Discount Percentage:</small>
//                                                                 <div className="d-flex align-items-center">
//                                                                     <strong className="me-2">{selectedCoupon.discountPercent}%</strong>
//                                                                     {selectedCoupon.maxDiscountAmount && (
//                                                                         <Badge bg="success" className="fw-normal">
//                                                                             Up to ₹{selectedCoupon.maxDiscountAmount}
//                                                                         </Badge>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                         {selectedCoupon.discountAmount && (
//                                                             <div className="mb-2">
//                                                                 <small className="text-muted d-block">Flat Discount:</small>
//                                                                 <strong>₹{selectedCoupon.discountAmount}</strong>
//                                                             </div>
//                                                         )}
//                                                     </>
//                                                 )}

//                                                 {!['SIZE_UPGRADE', 'BOGO', 'FREEBIE'].includes(selectedCoupon?.couponType) && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Discount Type:</small>
//                                                         <strong>{selectedCoupon.discountType ? `${selectedCoupon.discountType}` : "Category / Product Coupon"}</strong>
//                                                     </div>
//                                                 )}

//                                                 {selectedCoupon?.freebieQuantity && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Freebie Qty:</small>
//                                                         <strong>{selectedCoupon.freebieQuantity}</strong>
//                                                     </div>
//                                                 )}

//                                                 {selectedCoupon?.freebieQuantity && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Freebie Product:</small>
//                                                         <strong>{selectedCoupon?.freebieProduct?.name}</strong>
//                                                     </div>
//                                                 )}

//                                                 {selectedCoupon?.discountPrice && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Applicable qty:</small>
//                                                         <strong>{selectedCoupon.applicableQuantityType}</strong>
//                                                     </div>
//                                                 )}
//                                                 {selectedCoupon?.discountPrice && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Discounted Price:</small>
//                                                         <strong>₹ {selectedCoupon.discountPrice} only</strong>
//                                                     </div>
//                                                 )}

//                                                 {selectedCoupon.newSizeUpgradeAddon && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Size Upgrade:</small>
//                                                         <strong>{selectedCoupon?.newSizeUpgradeAddon?.title} [{selectedCoupon?.newSizeUpgradeAddon?.identifier}]</strong>
//                                                     </div>
//                                                 )}

//                                                 {selectedCoupon?.minCartValue && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Minimum Cart Value:</small>
//                                                         <strong>₹ {selectedCoupon.minCartValue}</strong>
//                                                     </div>
//                                                 )}


//                                             </Card.Body>
//                                         </Card>
//                                     </Col>

//                                     {/* Applicability */}
//                                     <Col md={6}>
//                                         <Card className="h-100">
//                                             <Card.Header className="bg-light">
//                                                 <h6 className="mb-0">
//                                                     <Package size={16} className="me-2" />
//                                                     Applicability
//                                                 </h6>
//                                             </Card.Header>
//                                             <Card.Body>
//                                                 {selectedCoupon.applicableProducts?.length > 0 ? (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Applicable Products:</small>
//                                                         <div className="mt-1">
//                                                             {selectedCoupon.applicableProducts.map((product, idx) => (
//                                                                 <Badge key={idx} bg="info" className="me-1 mb-1">
//                                                                     {product.name}
//                                                                 </Badge>
//                                                             ))}
//                                                         </div>
//                                                     </div>
//                                                 ) : selectedCoupon.applicableCategories?.length > 0 ? (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Applicable Categories:</small>
//                                                         <div className="mt-1">
//                                                             {selectedCoupon.applicableCategories.map((category, idx) => (
//                                                                 <Badge key={idx} bg="info" className="me-1 mb-1">
//                                                                     {category.name}
//                                                                 </Badge>
//                                                             ))}
//                                                         </div>
//                                                     </div>
//                                                 ) : (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Applicable On:</small>
//                                                         <strong>All Products & Categories</strong>
//                                                     </div>
//                                                 )}
//                                                 {selectedCoupon?.excludedProducts?.length > 0 && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Excluded Products:</small>
//                                                         <div className="mt-1">
//                                                             {selectedCoupon.excludedProducts.map((category, idx) => (
//                                                                 <Badge key={idx} bg="info" className="me-1 mb-1">
//                                                                     {category.name}
//                                                                 </Badge>
//                                                             ))}
//                                                         </div>
//                                                     </div>
//                                                 )}

//                                                 {/* 👇 Added: Excluded Addons / Addon Values */}
//                                                 {selectedCoupon?.excludedAddons?.length > 0 && (
//                                                     <div className="mb-2">
//                                                         <small className="text-muted d-block">Excluded Addon Values:</small>
//                                                         <div className="mt-1">
//                                                             {selectedCoupon.excludedAddons.map((addon, idx) => (
//                                                                 <Badge key={idx} bg="secondary" className="me-1 mb-1">
//                                                                     {addon.addonTitle} - {addon.addonValueTitle}
//                                                                 </Badge>
//                                                             ))}
//                                                         </div>
//                                                     </div>
//                                                 )}

//                                             </Card.Body>
//                                         </Card>
//                                     </Col>

//                                     {/* Terms & Meta */}
//                                     {selectedCoupon?.termsAndConditions?.length > 0 && (
//                                         <Col md={6}>
//                                             <Card className="h-100">
//                                                 <Card.Header className="bg-light">
//                                                     <h6 className="mb-0">
//                                                         <Calendar size={16} className="me-2" />
//                                                         Additional Information
//                                                     </h6>
//                                                 </Card.Header>
//                                                 <Card.Body>
//                                                     {selectedCoupon.termsAndConditions?.length > 0 && (
//                                                         <div className="mb-3">
//                                                             <small className="text-muted d-block">Terms & Conditions:</small>
//                                                             <ul className="ps-3 mb-0">
//                                                                 {selectedCoupon.termsAndConditions.map((term, idx) => (
//                                                                     <li key={idx} className="small">{term}</li>
//                                                                 ))}
//                                                             </ul>
//                                                         </div>
//                                                     )}

//                                                 </Card.Body>
//                                             </Card>
//                                         </Col>
//                                     )}
//                                 </Row>
//                             </div>
//                         ) : (
//                             <div className="text-center py-4">
//                                 <Spinner animation="border" variant="primary" />
//                                 <p className="mt-2 mb-0">Loading coupon details...</p>
//                             </div>
//                         )}
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="secondary" onClick={() => setShowViewModal(false)}>
//                             Close
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* Delete Confirmation Modal */}
//                 <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Confirm Delete</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <p>Are you sure you want to delete this auto coupon?</p>
//                         <p className="text-muted small">
//                             This action cannot be undone. The coupon will be permanently deleted.
//                         </p>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button
//                             variant="secondary"
//                             onClick={() => setShowDeleteModal(false)}
//                             disabled={deleteLoading}
//                         >
//                             Cancel
//                         </Button>
//                         <Button
//                             variant="danger"
//                             onClick={handleDelete}
//                             disabled={deleteLoading}
//                         >
//                             {deleteLoading ? (
//                                 <>
//                                     <Spinner
//                                         as="span"
//                                         animation="border"
//                                         size="sm"
//                                         role="status"
//                                         aria-hidden="true"
//                                         className="me-2"
//                                     />
//                                     Deleting...
//                                 </>
//                             ) : (
//                                 "Delete Coupon"
//                             )}
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>
//             </div>

//             {/* Enhanced CSS for coupon design - 6 COLUMN LAYOUT - Updated for image */}
//             <style jsx>{`
//                 .coupon-container {
//                     position: relative;
//                     transition: transform 0.3s ease;
//                     height: 100%;
//                 }
                
//                 .coupon-container:hover {
//                     transform: translateY(-3px);
//                 }
                
//                 .coupon-card {
//                     border-radius: 10px;
//                     overflow: hidden;
//                     border: 1.5px dashed #dee2e6;
//                     box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
//                     transition: all 0.3s ease;
//                     position: relative;
//                     background: white;
//                     display: flex;
//                     flex-direction: column;
//                     height: 100%;
//                     min-height: 350px;
//                 }
                
//                 .coupon-card:hover {
//                     box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
//                     border-color: #0d6efd;
//                 }
                
//                 /* Coupon Image Container - NEW */
//                 .coupon-image-container {
//                     height: 100px;
//                     overflow: hidden;
//                     border-bottom: 1px solid #dee2e6;
//                 }
                
//                 .coupon-image {
//                     width: 100%;
//                     height: 100%;
//                     object-fit: cover;
//                 }
                
//                 .coupon-main {
//                     padding: 15px;
//                     color: white;
//                     position: relative;
//                     flex-shrink: 0;
//                 }
                
//                 .coupon-header {
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: flex-start;
//                     margin-bottom: 8px;
//                     min-height: 32px;
//                 }
                
//                 .coupon-type {
//                     display: flex;
//                     align-items: center;
//                     font-size: 10px;
//                     font-weight: 600;
//                     background: rgba(255, 255, 255, 0.2);
//                     padding: 3px 8px;
//                     border-radius: 15px;
//                     backdrop-filter: blur(4px);
//                     max-width: 70%;
//                 }
                
//                 .coupon-type-text {
//                     white-space: nowrap;
//                     overflow: hidden;
//                     text-overflow: ellipsis;
//                     font-size: 10px;
//                 }
                
//                 .nth-order-badge {
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     background: rgba(255, 255, 255, 0.3);
//                     color: white;
//                     padding: 3px 6px;
//                     border-radius: 15px;
//                     font-size: 10px;
//                     font-weight: 600;
//                     width: 24px;
//                     height: 24px;
//                 }
                
//                 /* Journey specific styles */
//                 .journey-stage-indicator {
//                     display: flex;
//                     justify-content: center;
//                     margin: 8px 0;
//                 }
                
//                 .journey-stage-badge {
//                     font-size: 9px;
//                     padding: 3px 8px;
//                     border-radius: 15px;
//                 }
                
//                 .journey-subtitle {
//                     font-size: 10px;
//                     opacity: 0.9;
//                     margin-top: 3px;
//                     display: block;
//                 }
                
//                 .journey-legend {
//                     background: #f8f9fa;
//                 }
                
//                 .journey-badge {
//                     display: flex;
//                     align-items: center;
//                 }
                
//                 .journey-info-card {
//                     background: #fff9e6;
//                 }
                
//                 /* Discount Display */
//                 .discount-section {
//                     text-align: center;
//                     margin: 5px 0;
//                     display: flex;
//                     flex-direction: column;
//                     justify-content: center;
//                 }
                
//                 .discount-value {
//                     font-size: 24px;
//                     font-weight: 800;
//                     line-height: 1;
//                     margin-bottom: 2px;
//                     display: flex;
//                     align-items: baseline;
//                     justify-content: center;
//                     gap: 2px;
//                     flex-wrap: wrap;
//                 }
                
//                 .percent {
//                     font-size: 22px;
//                 }
                
//                 .percent-symbol {
//                     font-size: 18px;
//                     margin-right: 4px;
//                 }
                
//                 .rupee {
//                     font-size: 16px;
//                     margin-right: 2px;
//                 }
                
//                 .amount {
//                     font-size: 22px;
//                 }
                
//                 .off-label {
//                     font-size: 12px;
//                     font-weight: 600;
//                     opacity: 0.9;
//                     margin-top: 2px;
//                 }
                
//                 .max-discount {
//                     font-size: 10px;
//                     font-weight: 500;
//                     opacity: 0.9;
//                     background: rgba(255, 255, 255, 0.2);
//                     padding: 3px 8px;
//                     border-radius: 15px;
//                     display: inline-block;
//                     margin-top: 5px;
//                 }
                
//                 .coupon-title {
//                     text-align: center;
//                     display: flex;
//                     flex-direction: column;
//                     justify-content: center;
//                 }
                
//                 .coupon-title h5 {
//                     font-size: 13px;
//                     font-weight: 700;
//                     margin: 0;
//                     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
//                     display: -webkit-box;
//                     -webkit-line-clamp: 2;
//                     -webkit-box-orient: vertical;
//                     overflow: hidden;
//                     text-overflow: ellipsis;
//                     line-height: 1.3;
//                 }
                
//                 .coupon-details {
//                     padding: 12px 15px;
//                     background: white;
//                     flex: 1;
//                     display: flex;
//                     flex-direction: column;
//                     justify-content: space-between;
//                 }
                
//                 .detail-item {
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     padding: 4px 0;
//                     border-bottom: 1px solid #f1f3f4;
//                 }
                
//                 .detail-item:last-child {
//                     border-bottom: none;
//                 }
                
//                 .detail-label {
//                     font-size: 10px;
//                     color: #6c757d;
//                     font-weight: 600;
//                     white-space: nowrap;
//                 }
                
//                 .detail-value {
//                     font-size: 10px;
//                     font-weight: 600;
//                     text-align: right;
//                     padding-left: 6px;
//                     word-break: break-word;
//                     flex-shrink: 1;
//                     min-width: 0;
//                 }
                
//                 .usage-badge {
//                     font-size: 9px;
//                     padding: 2px 6px;
//                 }
                
//                 .created-date {
//                     margin-top: 8px;
//                     text-align: center;
//                     font-size: 9px;
//                     color: #6c757d;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     min-height: 16px;
//                 }
                
//                 .coupon-actions {
//                     padding: 10px 15px;
//                     background: #f8f9fa;
//                     border-top: 1px solid #e9ecef;
//                     display: flex;
//                     gap: 6px;
//                     flex-wrap: nowrap;
//                     flex-shrink: 0;
//                 }
                
//                 .action-btn {
//                     flex: 1;
//                     font-size: 10px;
//                     padding: 4px 6px;
//                     white-space: nowrap;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                 }
                
//                 /* Image upload styles */
//                 .image-upload-area {
//                     background: #f8f9fa;
//                     cursor: pointer;
//                     transition: all 0.3s ease;
//                 }
                
//                 .image-upload-area:hover {
//                     background: #e9ecef;
//                     border-color: #0d6efd;
//                 }
                
//                 .cursor-pointer {
//                     cursor: pointer;
//                 }
                
//                 .uploaded-image-preview {
//                     max-width: 100%;
//                     height: auto;
//                 }
                
//                 /* Responsive adjustments */
//                 @media (max-width: 1400px) {
//                     .coupon-card {
//                         min-height: 340px;
//                     }
                    
//                     .discount-value {
//                         font-size: 22px;
//                     }
                    
//                     .percent, .amount {
//                         font-size: 24px;
//                     }
                    
//                     .coupon-title h5 {
//                         font-size: 12px;
//                     }
//                 }
                
//                 @media (max-width: 1200px) {
//                     .coupon-card {
//                         min-height: 330px;
//                     }
                    
//                     .coupon-main {
//                         padding: 12px;
//                     }
                    
//                     .coupon-details {
//                         padding: 10px 12px;
//                     }
                    
//                     .discount-value {
//                         font-size: 20px;
//                     }
                    
//                     .percent, .amount {
//                         font-size: 22px;
//                     }
//                 }
                
//                 @media (max-width: 992px) {
//                     .coupon-card {
//                         min-height: 350px;
//                     }
                    
//                     .coupon-title h5 {
//                         font-size: 12px;
//                     }
                    
//                     .detail-label {
//                         font-size: 9px;
//                     }
                    
//                     .detail-value {
//                         font-size: 10px;
//                     }
//                 }
                
//                 @media (max-width: 768px) {
//                     .coupon-container {
//                         height: auto;
//                     }
                    
//                     .coupon-card {
//                         min-height: auto;
//                         height: auto;
//                     }
                    
//                     .coupon-actions {
//                         flex-direction: row;
//                     }
                    
//                     .action-btn {
//                         font-size: 9px;
//                         padding: 3px 5px;
//                     }
                    
//                     .discount-value {
//                         font-size: 18px;
//                     }
                    
//                     .percent, .amount {
//                         font-size: 20px;
//                     }
                    
//                     .off-label {
//                         font-size: 11px;
//                     }
//                 }
                
//                 @media (max-width: 576px) {
//                     .coupon-card {
//                         min-height: auto;
//                         margin-bottom: 15px;
//                     }
                    
//                     .coupon-main {
//                         padding: 10px;
//                     }
                    
//                     .coupon-details {
//                         padding: 8px 10px;
//                     }
                    
//                     .discount-value {
//                         font-size: 16px;
//                         flex-direction: column;
//                         gap: 1px;
//                     }
                    
//                     .percent, .amount {
//                         font-size: 18px;
//                     }
                    
//                     .off-label {
//                         margin-left: 0;
//                         font-size: 10px;
//                     }
                    
//                     .coupon-title h5 {
//                         font-size: 11px;
//                     }
//                 }
                
//                 /* Ensure all cards have same height in row */
//                 .row.g-3 {
//                     display: flex;
//                     flex-wrap: wrap;
//                 }
                
//                 .row.g-3 > [class*="col-"] {
//                     display: flex;
//                     flex-direction: column;
//                 }
//             `}</style>
//         </>
//     );
// };

// export default AutoCouponAllocation;




// ----------------- New Code -------------------
import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import {
    Col,
    Row,
    Card,
    Button,
    Form,
    Modal,
    Spinner,
    Badge,
    InputGroup,
    Pagination,
    Accordion,
    Tab,
    Tabs,
    Image
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import {
    Tag,
    Plus,
    Edit,
    Trash2,
    RefreshCw,
    Eye,
    X,
    ShoppingCart,
    Percent,
    Calendar,
    Package,
    Award,
    CheckCircle,
    Gift,
    Ticket,
    Crown,
    TrendingUp,
    Hash,
    Route,
    Layers,
    MapPin,
    Navigation,
    Compass,
    Upload,
    MessageSquare,
    Image as ImageIcon
} from 'lucide-react';
import { format } from 'date-fns';

const AutoCouponAllocation = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);

    const { access } = useSelector((state) => state.login);
    const [couponAccess, setCouponAccess] = useState([]);

    // Main states
    const [loading, setLoading] = useState(false);
    const [allCoupons, setAllCoupons] = useState([]);
    const [filteredCoupons, setFilteredCoupons] = useState([]);
    const [journeyCoupons, setJourneyCoupons] = useState([]);
    const [totalCoupons, setTotalCoupons] = useState(0);
    const [totalJourneyCoupons, setTotalJourneyCoupons] = useState(0);

    // Feedback coupons states
    const [feedbackCoupons, setFeedbackCoupons] = useState([]);
    const [totalFeedbackCoupons, setTotalFeedbackCoupons] = useState(0);

    // Tab state
    const [activeTab, setActiveTab] = useState('journey-coupons');

    // Modal states
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState(null);

    // Form states
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        couponType: "All",
        isFreebieCoupon: false,
        isFeedBackCoupon: false,
        nthOrderNumber: '',
        validityInDays: '',
        discountType: 'PERCENT',
        discountPrice: '',
        applicableQuantityType: 'SINGLE',
        usageType: 'ONE-TIME',
        minOrderAmount: '',
        maxOrderAmount: '',
        discountAmount: '',
        freebieProduct: '',
        freebieQuantity: '',
        discountPercent: '',
        maxDiscountAmount: '',
        applicableProducts: [],
        applicableCategories: [],
        excludedProducts: [],
        excludedAddonGroups: [],
        excludedAddonValues: [],
        maxAddonsAllowed: '',
        newSizeUpgradeAddon: '',
        minCartValue: '',
        termsAndConditions: [],
        displayImage: ''
    });

    const [submitting, setSubmitting] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isEditForm, setIsEditForm] = useState(false);

    // Image upload states
    const [imagePreview, setImagePreview] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [imageAction, setImageAction] = useState('UNCHANGED');

    // Options states
    const [categories, setCategories] = useState([]);
    const [productsData, setProductsData] = useState([]);
    const [freebieProducts, setFreebieProducts] = useState([]);
    const [excludedProducts, setExcludedProducts] = useState([]);
    const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
    const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
    const [termInput, setTermInput] = useState('');

    // Excluding addons / addon values
    const [allAddonList, setAllAddonList] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [journeyCurrentPage, setJourneyCurrentPage] = useState(1);
    const [feedbackCurrentPage, setFeedbackCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);
    const [totalPages, setTotalPages] = useState('');
    const [journeyTotalPages, setJourneyTotalPages] = useState('');
    const [feedbackTotalPages, setFeedbackTotalPages] = useState('');

    // Separate filter states for each tab
    const [regularSearchQuery, setRegularSearchQuery] = useState('');
    const [journeySearchQuery, setJourneySearchQuery] = useState('');
    const [feedbackSearchQuery, setFeedbackSearchQuery] = useState('');
    const [regularCouponTypeFilter, setRegularCouponTypeFilter] = useState('ALL');
    const [journeyCouponTypeFilter, setJourneyCouponTypeFilter] = useState('ALL');
    const [feedbackCouponTypeFilter, setFeedbackCouponTypeFilter] = useState('ALL');
    const [regularStatusFilter, setRegularStatusFilter] = useState('ACTIVE');
    const [journeyStatusFilter, setJourneyStatusFilter] = useState('ACTIVE');
    const [feedbackStatusFilter, setFeedbackStatusFilter] = useState('ACTIVE');
    const [activeAccordion, setActiveAccordion] = useState("0");
    const [isTouched, setIsTouched] = useState(false);
    const [isCouponTypeTouched, setIsCouponTypeTouched] = useState(false);
    const accessToken = localStorage.getItem('authToken');

    const [loadingExcludedProducts, setLoadingExcludedProducts] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [isRegularSearched, setIsRegularSearched] = useState(false);
    const [isFeedbackSearched, setIsFeedbackSearched] = useState(false);

    // Get permissions
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("AutoCouponAllocation:")
            );
            setCouponAccess(filteredAccess);
        }
    }, [access]);

    // Custom styles for react-select
    // NOTE: control / menu / multiValueRemove were "unchanged" placeholders in the
    // code that was shared. Paste your original bodies back in for those three.
    const customSelectStyles = {
        control: (base, state) => ({ ...base /* unchanged */ }),
        menu: (base) => ({ ...base /* unchanged */ }),

        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused
                ? (skin === 'dark' ? '#3a4155' : '#e9ecef')
                : (skin === 'dark' ? '#2a3042' : 'white'),
            color: state.data?.isDelete
                ? '#dc3545'
                : (skin === 'dark' ? 'white' : 'black'),
            fontWeight: state.data?.isDelete ? 600 : 'normal',
            '&:hover': {
                backgroundColor: skin === 'dark' ? '#3a4155' : '#e9ecef',
            }
        }),

        multiValue: (base, state) => ({
            ...base,
            backgroundColor: state.data?.isDelete
                ? '#f8d7da'
                : (skin === 'dark' ? '#3a4155' : '#e9ecef'),
            border: state.data?.isDelete ? '1px solid #dc3545' : 'none',
        }),

        multiValueLabel: (base, state) => ({
            ...base,
            color: state.data?.isDelete
                ? '#dc3545'
                : (skin === 'dark' ? 'white' : 'black'),
            fontWeight: state.data?.isDelete ? 600 : 'normal',
        }),

        multiValueRemove: (base) => ({ ...base /* unchanged */ }),
    };

    // Fetch all data
    const fetchInitialData = async () => {
        await Promise.all([
            getCoupons(1, itemsPerPage, {}),
            getJourneyCoupons(1, itemsPerPage, {}),
            getFeedbackCoupons(1, itemsPerPage, {}),
            getCategories(),
            getProducts(),
            getExProducts(),
            loadAllProductsForExclusion(),
            getNewSizeAddons(),
            getAddonList()
        ]);
    };

    // Step 1: Prepare filters (business rules)
    const prepareFilters = (filters = {}) => {
        const updatedFilters = { ...filters };

        // HARD RESET for ALL (ignore previous state completely)
        if (filters.couponType === 'ALL') {
            delete updatedFilters.couponType;
            return updatedFilters;
        }

        // Category / Product
        if (filters.couponType === '') {
            updatedFilters.couponType = null;
        }

        return updatedFilters;
    };

    // Step 2: Sanitize filters (cleanup only)
    const sanitizeFilters = (filters = {}) => {
        const cleanFilters = {};

        Object.entries(filters).forEach(([key, value]) => {
            if (
                value !== '' &&
                value !== undefined &&
                value !== 'ALL'
            ) {
                cleanFilters[key] = value;
            }
        });

        return cleanFilters;
    };

    // ==============================
    // Fetch REGULAR coupons
    // ==============================
    const getCoupons = async (page, limit, filters = {}) => {
        setLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };

            const preparedFilters = prepareFilters(filters);
            const cleanedFilters = sanitizeFilters(preparedFilters);

            const params = new URLSearchParams({
                page,
                limit,
                ...cleanedFilters
            });

            const response = await axiosInstance.get(
                `auto-coupon-allocation?${params.toString()}`,
                { headers }
            );

            if (response?.data?.status === true) {
                const data = Array.isArray(response?.data?.data)
                    ? response.data.data
                    : [];

                // Explicit split
                const journeyCouponsList = data.filter(
                    coupon => coupon?.nthOrderNumber !== null && coupon?.nthOrderNumber !== undefined
                );

                // Feedback coupons are excluded from "Other Coupons"
                const allCouponsList = data.filter(
                    coupon =>
                        (coupon?.nthOrderNumber === null || coupon?.nthOrderNumber === undefined) &&
                        coupon?.isFeedBackCoupon !== true
                );

                setAllCoupons(data);
                setFilteredCoupons(allCouponsList);
                setJourneyCoupons(journeyCouponsList);

                setTotalCoupons(allCouponsList.length);
                setTotalJourneyCoupons(journeyCouponsList.length);

                setTotalPages(
                    response?.data?.pagination?.totalPages ||
                    Math.ceil(allCouponsList.length / limit)
                );
            }
        } catch (error) {
            showError(error, 'Failed to fetch coupons');
        } finally {
            setLoading(false);
        }
    };

    // ==============================
    // Fetch JOURNEY coupons
    // ==============================
    const getJourneyCoupons = async (page, limit, filters = {}) => {
        setLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };

            const preparedFilters = prepareFilters({
                ...filters,
                nthOrderNumber: true
            });

            const journeyFilters = sanitizeFilters(preparedFilters);

            const params = new URLSearchParams({
                page,
                limit,
                ...journeyFilters
            });

            const response = await axiosInstance.get(
                `auto-coupon-allocation?${params.toString()}`,
                { headers }
            );

            if (response?.data?.status === true) {
                const data = response?.data?.data || [];
                let filteredData = data.filter((item) => item?.nthOrderNumber !== null && item?.nthOrderNumber !== undefined);
                setJourneyCoupons(filteredData);
                setTotalJourneyCoupons(filteredData?.length || 0);
                setJourneyTotalPages(
                    response?.data?.pagination?.totalPages ||
                    Math.ceil(data.length / limit)
                );
            }
        } catch (error) {
            showError(error, 'Failed to fetch journey coupons');
        } finally {
            setLoading(false);
        }
    };

    // ==============================
    // Fetch FEEDBACK coupons
    // ==============================
    const getFeedbackCoupons = async (page, limit, filters = {}) => {
        setLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };

            const preparedFilters = prepareFilters({
                ...filters,
                isFeedBackCoupon: true
            });

            const feedbackFilters = sanitizeFilters(preparedFilters);

            const params = new URLSearchParams({
                page,
                limit,
                ...feedbackFilters
            });

            const response = await axiosInstance.get(
                `auto-coupon-allocation?${params.toString()}`,
                { headers }
            );

            if (response?.data?.status === true) {
                const data = response?.data?.data || [];
                // Client-side safety filter in case the API ignores the query param
                const filteredData = data.filter((item) => item?.isFeedBackCoupon === true);
                setFeedbackCoupons(filteredData);
                setTotalFeedbackCoupons(filteredData?.length || 0);
                setFeedbackTotalPages(
                    response?.data?.pagination?.totalPages ||
                    Math.ceil(data.length / limit)
                );
            }
        } catch (error) {
            showError(error, 'Failed to fetch feedback coupons');
        } finally {
            setLoading(false);
        }
    };

    // Get journey stage badge
    const getJourneyStageBadge = (nthOrder) => {
        if (!nthOrder) return null;

        const orderNum = parseInt(nthOrder);

        if (orderNum === 2) {
            return <Badge bg="success" className="journey-stage-badge">2nd Order</Badge>;
        } else if (orderNum === 3) {
            return <Badge bg="info" className="journey-stage-badge">3rd Order</Badge>;
        } else if (orderNum >= 4 && orderNum <= 7) {
            return <Badge bg="warning" className="journey-stage-badge">Mid Journey</Badge>;
        } else if (orderNum === 8) {
            return <Badge bg="danger" className="journey-stage-badge">Loyal Customer</Badge>;
        }

        return <Badge bg="secondary" className="journey-stage-badge">Order #{nthOrder}</Badge>;
    };

    // Get journey stage color
    const getJourneyStageColor = (nthOrder) => {
        return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';
    };

    // Get journey icon
    const getJourneyIcon = (nthOrder) => {
        if (!nthOrder) return <Route size={16} />;

        const orderNum = parseInt(nthOrder);

        if (orderNum === 2) {
            return <Compass size={16} />;
        } else if (orderNum === 3) {
            return <Navigation size={16} />;
        } else if (orderNum >= 4 && orderNum <= 7) {
            return <Layers size={16} />;
        } else if (orderNum >= 8) {
            return <MapPin size={16} />;
        }

        return <Route size={16} />;
    };

    // Fetch categories
    const getCategories = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                const categoriesData = response?.data?.data?.categories || [];
                const options = categoriesData.map(category => ({
                    value: category._id,
                    label: category.name || category.categoryName
                }));
                setCategories(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    // New Size Addons Api
    const getNewSizeAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axiosInstance.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
            setNewSizeAddonsList(response?.data?.data?.addons);
            let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []);
            setNewProductsFromAddons(newproducts);
        } catch (error) {
            console.log("Error :", error);
        }
    };

    // Fetch all addon groups (with their addon values) for the exclusion selects
    const getAddonList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("addons?page=1&limit=100", { headers });

            if (response?.data?.status === true) {
                setAllAddonList(response?.data?.data?.addons || []);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const addonsProducts = newProductsFromAddons?.map((item) => ({
        value: item?._id,
        label: item?.name,
        isDelete: item?.isDelete || false
    }));

    const getExProducts = async () => {
        setLoadingExcludedProducts(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const response = await axiosInstance.get(`product`, { headers });

            const allProducts = response?.data?.data?.products ?? [];
            const options = allProducts.map(product => ({
                value: product._id,
                label: product.name,
                isDelete: product.isDelete || false
            }));

            setExcludedProducts(options);
        } catch (error) {
            console.error('Error fetching products :', error);
        } finally {
            setLoadingExcludedProducts(false);
        }
    };

    // Load all products initially
    const loadAllProductsForExclusion = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get('product', { headers });

            if (response?.data?.status === true) {
                const productsList = response?.data?.data?.products || [];
                const options = productsList.map(product => ({
                    value: product._id,
                    label: product.name
                }));

                setExcludedProducts(options);
            }
        } catch (error) {
            console.error('Error fetching all products for exclusion:', error);
        }
    };

    // Fetch products with search
    const getProducts = async (searchTerm = '') => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            let urlParams = `product`;

            if (searchTerm) {
                urlParams += `?search=${searchTerm}`;
            }
            const response = await axiosInstance.get(urlParams, { headers });

            if (response?.data?.status === true) {
                const nonFreePro = response?.data?.data?.products
                    ?.filter(pro => pro?.isFreebieProduct === false)
                    .map(product => ({
                        value: product._id,
                        label: product.name,
                        isDelete: product.isDelete || false
                    }));

                const freePro = response?.data?.data?.products
                    ?.filter(pro => pro?.isFreebieProduct === true)
                    .map(product => ({
                        value: product._id,
                        label: product.name
                    }));
                setFreebieProducts(freePro);
                setProductsData(nonFreePro);
                setExcludedProducts(nonFreePro);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
        return [];
    };

    // Load products for async select
    const loadProducts = async (inputValue) => {
        return await getProducts(inputValue);
    };

    // Convert image file to Base64 and keep file reference
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve({
                base64: reader.result,
                file: file
            });
            reader.onerror = error => reject(error);
        });
    };

    // Handle image change
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            toast.error('Please upload a valid image file (JPEG, PNG, GIF, WebP)');
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error('Image size should be less than 5MB');
            return;
        }

        setUploadingImage(true);
        setImageFile(file);
        setImageAction('ADDED');
        try {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);

            const result = await convertToBase64(file);
            setFormData(prev => ({
                ...prev,
                displayImage: result.base64
            }));

            toast.success('Image added successfully');
        } catch (error) {
            console.error('Error converting image:', error);
            toast.error('Failed to process image');
        } finally {
            setUploadingImage(false);
        }
    };

    // Remove image
    const handleRemoveImage = () => {
        setImagePreview('');
        setImageFile(null);
        setImageAction('REMOVED');
        setFormData(prev => ({ ...prev, displayImage: '' }));
        toast.info('Image removed');
    };

    // Handle form input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (isEditForm && name === 'discountType') {
            setIsTouched(true);
        }

        if (isEditForm && name === 'couponType') {
            setIsCouponTypeTouched(true);
        }

        // Convert number fields
        const numberFields = [
            'nthOrderNumber', 'validityInDays', 'minOrderAmount', 'maxOrderAmount',
            'discountAmount', 'discountPrice', 'maxDiscountAmount', 'minCartValue',
            'maxAddonsAllowed'
        ];

        if (numberFields.includes(name)) {
            const newValue = value === '' ? '' : Number(value);

            setFormData(prev => ({
                ...prev,
                [name]: newValue,
                // Nth / Min / Max entered -> feedback coupon must be false
                ...(['nthOrderNumber', 'minOrderAmount', 'maxOrderAmount'].includes(name) &&
                    newValue !== '' && { isFeedBackCoupon: false })
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Handle Is Feedback Coupon select (converts "true"/"false" string to boolean)
    // Selecting Yes clears Nth Order Number, Min and Max order amount
    const handleFeedbackChange = (e) => {
        const isYes = e.target.value === 'true';

        setFormData(prev => ({
            ...prev,
            isFeedBackCoupon: isYes,
            ...(isYes && {
                nthOrderNumber: '',
                minOrderAmount: '',
                maxOrderAmount: ''
            })
        }));
    };

    // Handle multi-select change
    const handleMultiSelectChange = async (name, selectedOptions) => {
        if (name === 'applicableCategories') {
            const categoryIds = (selectedOptions || []).map(opt => opt.value);

            // Clear excluded products if no categories selected
            if (categoryIds.length === 0) {
                setFormData(prev => ({
                    ...prev,
                    excludedProducts: []
                }));
                await loadAllProductsForExclusion();
            } else {
                await getExProducts(categoryIds);
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: selectedOptions || []
        }));
    };

    const handleSelectChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            freebieProduct: selectedOption.value || null
        }));
    };

    // Handle "Excluding Addons" / "Excluding Addon Values" selects
    const handleSelectAllAddonChange = (fieldName, selectedOptions) => {
        if (fieldName !== 'excludedAddonGroups') {
            setFormData(prev => ({
                ...prev,
                [fieldName]: selectedOptions || []
            }));
            return;
        }

        setSelectedAddonGroups(selectedOptions || []);

        // If no addons selected, clear values and reset form data
        if (!selectedOptions || selectedOptions.length === 0) {
            setFilteredAddonValues([]);
            setFormData(prev => ({
                ...prev,
                excludedAddonGroups: [],
                excludedAddonValues: []
            }));
            return;
        }

        // Generate addon value options only for selected addons
        const addonValuesOptions = selectedOptions.flatMap(option => {
            const addon = allAddonList?.find(a => a?._id === option?.value);
            if (!addon) return [];

            return addon?.addonValues?.map(val => ({
                value: {
                    addonId: addon._id,
                    addValueId: val._id,
                    addonTitle: addon.title,
                    addonValueTitle: val.value
                },
                label: `${addon.title} - ${val.value}`
            })) || [];
        });

        const selectedItems = allAddonList.filter(addon =>
            selectedOptions.some(option => option.value === addon._id)
        );

        setFilteredAddonValues(addonValuesOptions);

        // Remove excludedAddonValues that no longer belong to selected groups
        setFormData(prev => {
            const filteredExcludedValues = (prev.excludedAddonValues || []).filter(val =>
                selectedOptions.some(opt => opt.value === val.addonId)
            );

            return {
                ...prev,
                excludedAddonGroups: selectedItems,
                excludedAddonValues: filteredExcludedValues
            };
        });
    };

    // Handle terms and conditions
    const handleAddTerm = () => {
        if (termInput.trim() === '') return;

        setFormData(prev => ({
            ...prev,
            termsAndConditions: [...prev.termsAndConditions, termInput.trim()]
        }));
        setTermInput('');
    };

    const handleRemoveTerm = (index) => {
        setFormData(prev => ({
            ...prev,
            termsAndConditions: prev.termsAndConditions.filter((_, i) => i !== index)
        }));
    };

    // Reset form
    const resetForm = () => {
        setFormData({
            title: '',
            description: '',
            couponType: 'All',
            isFeedBackCoupon: false,
            nthOrderNumber: '',
            validityInDays: '',
            discountType: 'PERCENT',
            usageType: 'ONE-TIME',
            minOrderAmount: '',
            maxOrderAmount: '',
            applicableQuantityType: 'SINGLE',
            discountPrice: '',
            excludedProducts: [],
            excludedAddonGroups: [],
            excludedAddonValues: [],
            maxAddonsAllowed: '',
            discountAmount: '',
            discountPercent: '',
            maxDiscountAmount: '',
            isFreebieCoupon: false,
            freebieProduct: '',
            freebieQuantity: '',
            applicableProducts: [],
            applicableCategories: [],
            newSizeUpgradeAddon: '',
            minCartValue: '',
            termsAndConditions: [],
            displayImage: ''
        });
        setImagePreview('');
        setImageFile(null);
        setTermInput('');
        setSelectedAddonGroups([]);
        setFilteredAddonValues([]);
    };

    // Close add/edit modal (single place so all "touched" flags are reset)
    const closeFormModal = () => {
        setShowAddModal(false);
        setShowEditModal(false);
        setIsEditForm(false);
        setIsTouched(false);
        setIsCouponTypeTouched(false);
        resetForm();
    };

    // Open add modal
    const handleAddCoupon = () => {
        resetForm();
        setIsEditForm(false);
        setIsTouched(false);
        setIsCouponTypeTouched(false);
        setShowAddModal(true);
    };

    // Open edit modal
    const handleEditCoupon = async (coupon) => {
        setSelectedCoupon(coupon);
        setIsEditForm(true);
        setIsTouched(false);
        setIsCouponTypeTouched(false);

        // Rebuild "Excluding Addons" / "Excluding Addon Values" selections from the coupon record.
        const excludedAddonsData = coupon?.excludedAddons || [];
        const groupIds = [...new Set(excludedAddonsData.map(item => item.addonId))];
        const selectedGroups = allAddonList.filter(addon => groupIds.includes(addon._id));

        const selectedAddonGroupOptions = selectedGroups.map(addon => ({
            value: addon._id,
            label: addon.title
        }));

        const addonValuesOptions = selectedGroups.flatMap(addon =>
            addon?.addonValues?.map(val => ({
                value: {
                    addonId: addon._id,
                    addValueId: val._id,
                    addonTitle: addon.title,
                    addonValueTitle: val.value
                },
                label: `${addon.title} - ${val.value}`
            })) || []
        );

        setSelectedAddonGroups(selectedAddonGroupOptions);
        setFilteredAddonValues(addonValuesOptions);

        // Convert coupon data to form format
        const formattedData = {
            title: coupon?.title || '',
            description: coupon?.description || '',
            couponType: coupon?.couponType || '',
            isFeedBackCoupon: coupon?.isFeedBackCoupon === true,
            nthOrderNumber: coupon?.nthOrderNumber || null,
            validityInDays: coupon?.validityInDays || '',
            discountType: coupon?.discountType || 'PERCENT',
            usageType: coupon?.usageType || 'ONE-TIME',
            minOrderAmount: coupon?.minOrderAmount || '',
            maxOrderAmount: coupon?.maxOrderAmount || '',
            isFreebieCoupon: coupon?.isFreebieCoupon || false,
            freebieQuantity: coupon?.freebieQuantity || '',
            freebieProduct: coupon?.freebieProduct?._id || '',
            applicableQuantityType: coupon?.applicableQuantityType || 'SINGLE',
            discountPrice: coupon?.discountPrice || '',
            status: coupon?.status || '',
            discountAmount: coupon?.discountAmount || '',
            discountPercent: coupon?.discountPercent || '',
            maxDiscountAmount: coupon?.maxDiscountAmount || '',
            applicableProducts: coupon?.applicableProducts?.map(product => ({
                value: product._id,
                label: product.name,
                isDelete: product.isDelete || false
            })) || [],
            applicableCategories: coupon?.applicableCategories?.map(category => ({
                value: category._id,
                label: category.name
            })) || [],
            excludedProducts: coupon?.excludedProducts?.map(product => ({
                value: product._id,
                label: product.name,
                isDelete: product.isDelete || false
            })) || [],
            excludedAddonGroups: selectedGroups,
            excludedAddonValues: excludedAddonsData.map(item => ({
                addonId: item.addonId,
                addValueId: item.addonValueId,
                addonTitle: item.addonTitle,
                addonValueTitle: item.addonValueTitle
            })),
            maxAddonsAllowed: coupon?.maxAddonsAllowed ?? '', // ?? keeps a saved 0
            newSizeUpgradeAddon: coupon?.newSizeUpgradeAddon?._id || '',
            minCartValue: coupon?.minCartValue || '',
            termsAndConditions: coupon?.termsAndConditions || [],
            displayImage: coupon?.displayImage || ''
        };

        setFormData(formattedData);

        // Set image preview if exists
        setImagePreview(coupon?.displayImageUrl || '');
        setImageAction('UNCHANGED');
        setImageFile(null);

        // Load excluded products for the selected categories
        if (coupon?.applicableCategories?.length > 0) {
            const categoryIds = coupon.applicableCategories.map(cat => cat._id);
            await getExProducts(categoryIds);
        } else {
            await loadAllProductsForExclusion();
        }

        setShowEditModal(true);
    };

    // Open view modal
    const handleViewCoupon = (coupon) => {
        setSelectedCoupon(coupon);
        setShowViewModal(true);
    };

    // Open delete modal
    const handleDeleteCoupon = (coupon) => {
        setSelectedCoupon(coupon);
        setShowDeleteModal(true);
    };

    const fieldSectionMap = {
        title: "0",
        description: "0",
        status: "0",
        displayImage: "0",

        couponType: "1",
        usageType: "1",
        nthOrderNumber: "1",
        isFeedBackCoupon: "1",
        validityInDays: "1",
        minOrderAmount: "1",
        maxOrderAmount: "1",

        discountType: "2",
        discountPercent: "2",
        discountPrice: "2",
        discountAmount: "2",
        minCartValue: "2",
        applicableCategories: "2",
        applicableProducts: "2",
        freebieProduct: "2",
        freebieQuantity: "2",
        newSizeUpgradeAddon: "2",
        excludedAddonGroups: "2",
        excludedAddonValues: "2",
        maxAddonsAllowed: "2",

        termsAndConditions: "3"
    };

    // ---------- Feedback coupon derived flags ----------
    const isFilled = (v) => v !== '' && v !== null && v !== undefined;

    const hasNth = isFilled(formData.nthOrderNumber);
    const hasOrderAmount = isFilled(formData.minOrderAmount) || isFilled(formData.maxOrderAmount);
    const isFeedbackSelected = formData.isFeedBackCoupon === true;

    // Feedback dropdown is locked when Nth or Min/Max order amount has a value
    const feedbackDisabled = hasNth || hasOrderAmount;

    // Returns a discountType that is actually allowed for the given coupon type.
    // (Same rules the Discount Type dropdown uses.) Falls back to PERCENT.
    const getValidDiscountType = (couponType, currentType) => {
        // These types have no Discount Type field at all
        if (['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(couponType)) return 'PERCENT';
        if (currentType === 'PRICE' && ['UNIVERSAL', 'CART'].includes(couponType)) return 'PERCENT';
        if (currentType === 'FLAT' && couponType === 'UNIVERSAL') return 'PERCENT';
        return currentType || 'PERCENT';
    };

    const findFirstInvalidField = () => {
        if (!formData.title) return "title";
        if (!formData.description) return "description";
        if (formData.couponType === 'All') return "couponType";
        if (!formData.usageType) return "usageType";
        if (!formData.validityInDays) return "validityInDays";
        if (!formData.displayImage) return "displayImage";

        if (
            formData.discountType === "PERCENT" &&
            !formData.discountPercent &&
            !['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData.couponType)
        ) {
            return "discountPercent";
        }

        if (formData?.couponType === "SIZE_UPGRADE" && !formData.newSizeUpgradeAddon) {
            return "newSizeUpgradeAddon";
        }

        if (
            formData.discountType === "FLAT" &&
            !formData.discountAmount &&
            !['BOGO', 'SIZE_UPGRADE', 'FREEBIE', 'UNIVERSAL'].includes(formData.couponType)
        ) {
            return "discountAmount";
        }

        if (formData.discountType === "PRICE" && !formData.discountPrice && !['BOGO', 'SIZE_UPGRADE', 'FREEBIE', 'UNIVERSAL', 'CART'].includes(formData.couponType)
        ) {
            return "discountPrice";
        }

        if (
            formData.couponType === "FREEBIE" &&
            (!formData.freebieProduct || !formData.freebieQuantity)
        ) {
            return "freebieProduct";
        }

        return null;
    };

    // Filters helpers for each tab
    const getJourneyFilters = () => ({
        search: journeySearchQuery,
        couponType: journeyCouponTypeFilter,
        status: journeyStatusFilter !== 'ALL' ? journeyStatusFilter : '',
        discountType: '',
    });

    const getRegularFilters = () => ({
        search: regularSearchQuery,
        couponType: regularCouponTypeFilter,
        status: regularStatusFilter !== 'ALL' ? regularStatusFilter : '',
        discountType: '',
    });

    const getFeedbackFilters = () => ({
        search: feedbackSearchQuery,
        couponType: feedbackCouponTypeFilter,
        status: feedbackStatusFilter !== 'ALL' ? feedbackStatusFilter : '',
        discountType: '',
    });

    // Refresh function for all tabs
    const refreshData = () => {
        if (activeTab === 'journey-coupons') {
            getJourneyCoupons(journeyCurrentPage, itemsPerPage, getJourneyFilters());
        } else if (activeTab === 'feedback-coupons') {
            getFeedbackCoupons(feedbackCurrentPage, itemsPerPage, getFeedbackFilters());
        } else {
            getCoupons(currentPage, itemsPerPage, getRegularFilters());
        }
    };

    // SUBMIT This is For Sending Array In Index
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const invalidField = findFirstInvalidField();
        if (invalidField) {
            const sectionKey = fieldSectionMap[invalidField];
            setActiveAccordion(sectionKey);
            toast.error("Please fill all required fields");
            setSubmitting(false);
            return;
        }

        const isEdit = showEditModal && selectedCoupon?._id;

        // ---------------- HELPERS ----------------
        const appendField = (fd, key, value) => {
            if (value === undefined || value === '') {
                if (isEdit) fd.append(key, null);
                return;
            }
            fd.append(key, value);
        };

        const appendNumberField = (fd, key, value) => {
            if (value === undefined || value === null || value === '') {
                if (isEdit) fd.append(key, null);
                return;
            }
            fd.append(key, String(value));
        };

        const appendIndexedArrayField = (fd, key, arr, mapFn = v => v) => {
            if (Array.isArray(arr) && arr.length > 0) {
                arr.forEach((item, index) => {
                    fd.append(`${key}[${index}]`, mapFn(item));
                });
            } else {
                if (isEdit) {
                    fd.append(key, JSON.stringify(null));
                }
            }
        };
        // -----------------------------------------

        try {
            const formDataToSend = new FormData();

            // -------- BASIC FIELDS --------
            appendField(formDataToSend, 'title', formData.title);
            appendField(formDataToSend, 'description', formData.description);
            appendField(formDataToSend, 'couponType', formData.couponType);
            appendField(formDataToSend, 'validityInDays', formData.validityInDays);
            appendField(formDataToSend, 'usageType', formData.usageType);
            appendField(formDataToSend, 'applicableQuantityType', formData.applicableQuantityType);

            // Feedback is always false when Nth number / Min / Max order amount is present.
            // Always sent as "true" / "false" (on create and edit)
            const sendFeedback = !hasNth && !hasOrderAmount && !!formData.isFeedBackCoupon;
            formDataToSend.append('isFeedBackCoupon', String(sendFeedback));

            if (formData?.couponType === "FREEBIE") {
                appendField(formDataToSend, 'isFreebieCoupon', true);
            }

            // -------- DISCOUNT TYPE --------
            appendField(
                formDataToSend,
                'discountType',
                ['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType)
                    ? null
                    : formData.discountType
            );

            // -------- NUMBER FIELDS --------
            appendNumberField(formDataToSend, 'nthOrderNumber', formData.nthOrderNumber);
            appendNumberField(formDataToSend, 'minOrderAmount', formData.minOrderAmount);
            appendNumberField(formDataToSend, 'maxOrderAmount', formData.maxOrderAmount);
            appendNumberField(formDataToSend, 'discountPrice', formData.discountPrice);
            appendNumberField(formDataToSend, 'discountAmount', formData.discountAmount);
            appendNumberField(formDataToSend, 'discountPercent', formData.discountPercent);
            appendNumberField(formDataToSend, 'maxDiscountAmount', formData.maxDiscountAmount);
            appendNumberField(formDataToSend, 'minCartValue', formData.minCartValue);
            appendNumberField(formDataToSend, 'freebieQuantity', formData.freebieQuantity);
            // not sent for FREEBIE; on edit an empty value is sent as null so it clears
            appendNumberField(
                formDataToSend,
                'maxAddonsAllowed',
                formData.couponType === 'FREEBIE' ? '' : formData.maxAddonsAllowed
            );

            // -------- FREEBIE PRODUCT --------
            appendField(
                formDataToSend,
                'freebieProduct',
                formData.freebieProduct?.value || formData.freebieProduct
            );

            // -------- SIZE UPGRADE ADDON --------
            appendField(
                formDataToSend,
                'newSizeUpgradeAddon',
                formData.newSizeUpgradeAddon
            );

            // -------- ARRAYS --------
            appendIndexedArrayField(
                formDataToSend,
                'applicableProducts',
                formData.applicableProducts,
                p => p.value
            );

            appendIndexedArrayField(
                formDataToSend,
                'applicableCategories',
                formData.applicableCategories,
                c => c.value
            );

            appendIndexedArrayField(
                formDataToSend,
                'excludedProducts',
                formData.excludedProducts,
                p => p.value
            );

            // -------- EXCLUDED ADDONS --------
            const excludedAddonsPayload = (formData?.excludedAddonValues || []).map((val) => {
                const addon = allAddonList.find(a => a._id === val.addonId);
                const addonValue = addon?.addonValues?.find(v => v._id === val.addValueId);

                return {
                    addonId: val.addonId,
                    addonValueId: val.addValueId,
                    addonTitle: addon?.title || val.addonTitle || "",
                    addonValueTitle: addonValue?.value || val.addonValueTitle || ""
                };
            });

            appendIndexedArrayField(
                formDataToSend,
                'excludedAddons',
                excludedAddonsPayload,
                (item) => JSON.stringify(item)
            );

            appendIndexedArrayField(
                formDataToSend,
                'termsAndConditions',
                formData.termsAndConditions
            );

            // -------- IMAGE --------
            if (!isEdit) {
                // POST (ADD)
                if (
                    formData.displayImage &&
                    typeof formData.displayImage === 'string' &&
                    formData.displayImage.startsWith('data:image')
                ) {
                    const base64Data = formData.displayImage.split(',')[1];
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'image/jpeg' });

                    formDataToSend.append('displayImage', blob, 'coupon-image.jpg');
                }
            } else {
                // PUT (EDIT)
                if (imageAction === 'ADDED' && imageFile) {
                    formDataToSend.append('displayImage', imageFile);
                } else if (imageAction === 'REMOVED') {
                    formDataToSend.append('displayImage', null);
                }
            }

            // -------- EDIT MODE --------
            if (isEdit) {
                formDataToSend.append('_id', selectedCoupon._id);
                formDataToSend.append('status', formData.status);
            }

            // -------- DEBUG --------
            console.log("FormData contents:");
            for (let pair of formDataToSend.entries()) {
                console.log(pair[0], pair[1]);
            }

            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = isEdit
                ? await axiosInstance.put('auto-coupon-allocation', formDataToSend, { headers })
                : await axiosInstance.post('auto-coupon-allocation', formDataToSend, { headers });

            if (response?.data?.status) {
                toast.success(response?.data?.message || 'Coupon saved successfully!');
                closeFormModal();
                refreshData();
            }

        } catch (error) {
            console.error("Submit Error:", error);
            showError(error, 'Failed to save coupon');
        } finally {
            setSubmitting(false);
        }
    };

    // Delete coupon
    const handleDelete = async () => {
        setDeleteLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };

            const data = {
                _id: selectedCoupon._id
            };

            const response = await axiosInstance.delete('auto-coupon-allocation', { data, headers });

            if (response?.data?.status === true) {
                toast.success('Coupon deleted successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                });
                setShowDeleteModal(false);
                refreshData();
            }
        } catch (error) {
            showError(error, 'Failed to delete coupon');
        } finally {
            setDeleteLoading(false);
        }
    };

    // Error handler
    const showError = (error, defaultMessage) => {
        console.log("Error :", error);

        let errorMessage = "";
        if (error.response?.status === 400) {
            errorMessage =
                error?.response?.data?.data?.title ||
                error?.response?.data?.error;
        } else if (error.response?.status === 406) {
            errorMessage =
                error?.response?.data?.data?.title ||
                error?.response?.data?.error;
        } else if (error.response?.status === 412) {
            errorMessage =
                error?.response?.data?.data?.message ||
                error?.response?.data?.data?.title;
        } else if (error.response?.status === 500) {
            errorMessage = error?.response?.data?.error;
        }

        toast.error(errorMessage || defaultMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: 'light'
        });
    };

    // Format date
    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), 'dd/MM/yyyy');
        } catch {
            return dateString;
        }
    };

    // Format datetime
    const formatDateTime = (dateString) => {
        try {
            return format(new Date(dateString), 'dd/MM/yyyy HH:mm');
        } catch {
            return dateString;
        }
    };

    // Get coupon type badge
    const getCouponTypeBadge = (type) => {
        const variants = {
            CART: 'primary',
            UNIVERSAL: 'success',
            SIZE_UPGRADE: 'info',
            BOGO: 'danger'
        };
        return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
    };

    // Get discount type badge
    const getDiscountTypeBadge = (type) => {
        const variants = {
            PERCENT: 'info',
            FLAT: 'success'
        };
        return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
    };

    // Get usage type badge
    const getUsageTypeBadge = (type) => {
        const variants = {
            'ONE-TIME': 'primary',
            MULTIPLE: 'success',
            UNLIMITED: 'warning'
        };
        return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
    };

    // Calculate effective discount
    const calculateEffectiveDiscount = (coupon) => {
        if (coupon.discountType === 'PERCENT') {
            return `${coupon.discountPercent}% (Max ₹${coupon.maxDiscountAmount})`;
        } else {
            return `₹${coupon.discountAmount} off`;
        }
    };

    // Get coupon type icon
    const getCouponTypeIcon = (type) => {
        const icons = {
            CART: <ShoppingCart size={16} />,
            PRODUCT: <Package size={16} />,
            CATEGORY: <Tag size={16} />,
            SIZE_UPGRADE: <TrendingUp size={16} />,
            FIRST_ORDER: <Crown size={16} />,
            BOGO: <Gift size={16} />
        };
        return icons[type] || <Tag size={16} />;
    };

    // Get coupon type color
    const getCouponTypeColor = (type) => {
        return 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)';
    };

    // Get paginated journey coupons
    const getPaginatedJourneyCoupons = () => {
        const startIndex = (journeyCurrentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return journeyCoupons.slice(startIndex, endIndex);
    };

    // ---------- Search handlers ----------
    const handleChangeJourneySearch = (e) => {
        setJourneySearchQuery(e.target.value);
        setIsSearched(true);
    };

    const handleSearchJourney = (e) => {
        e.preventDefault();
        getJourneyCoupons(journeyCurrentPage, itemsPerPage, getJourneyFilters());
    };

    const handleChangeRegularSearch = (e) => {
        setRegularSearchQuery(e.target.value);
        setIsRegularSearched(true);
    };

    const handleSearchRegular = (e) => {
        e.preventDefault();
        getCoupons(currentPage, itemsPerPage, getRegularFilters());
    };

    const handleChangeFeedbackSearch = (e) => {
        setFeedbackSearchQuery(e.target.value);
        setIsFeedbackSearched(true);
    };

    const handleSearchFeedback = (e) => {
        e.preventDefault();
        getFeedbackCoupons(feedbackCurrentPage, itemsPerPage, getFeedbackFilters());
    };

    // Reload when search box is cleared
    useEffect(() => {
        if (isSearched && journeySearchQuery.trim() === '') {
            getJourneyCoupons(journeyCurrentPage, itemsPerPage, getJourneyFilters());
        }
    }, [journeySearchQuery]);

    useEffect(() => {
        if (isRegularSearched && regularSearchQuery.trim() === '') {
            getCoupons(currentPage, itemsPerPage, getRegularFilters());
        }
    }, [regularSearchQuery]);

    useEffect(() => {
        if (isFeedbackSearched && feedbackSearchQuery.trim() === '') {
            getFeedbackCoupons(feedbackCurrentPage, itemsPerPage, getFeedbackFilters());
        }
    }, [feedbackSearchQuery]);

    // Initialize
    useEffect(() => {
        fetchInitialData();
    }, []);

    // Effect for regular coupons tab with backend filtering
    useEffect(() => {
        if (activeTab === 'all-coupons') {
            getCoupons(currentPage, itemsPerPage, getRegularFilters());
        }
    }, [regularCouponTypeFilter, regularStatusFilter, currentPage, activeTab]);

    // Effect for journey coupons tab with backend filtering
    useEffect(() => {
        if (activeTab === 'journey-coupons') {
            getJourneyCoupons(journeyCurrentPage, itemsPerPage, getJourneyFilters());
        }
    }, [journeyCouponTypeFilter, journeyStatusFilter, journeyCurrentPage, activeTab]);

    // Effect for feedback coupons tab with backend filtering
    useEffect(() => {
        if (activeTab === 'feedback-coupons') {
            getFeedbackCoupons(feedbackCurrentPage, itemsPerPage, getFeedbackFilters());
        }
    }, [feedbackCouponTypeFilter, feedbackStatusFilter, feedbackCurrentPage, activeTab]);

    useEffect(() => {
        if (formData?.nthOrderNumber) {
            setFormData(prev => ({
                ...prev,
                maxOrderAmount: '',
                minOrderAmount: ''
            }));
        }
    }, [formData?.nthOrderNumber]);

    useEffect(() => {
        if (!isEditForm) {
            setFormData(prev => ({
                ...prev,
                discountAmount: '',
                discountPercent: '',
                maxDiscountAmount: '',
                discountPrice: '',
                applicableCategories: [],
                applicableProducts: [],
                excludedProducts: [],
                minCartValue: '',
                newSizeUpgradeAddon: '',
            }));
        }

        if (isEditForm && isTouched && formData?.discountType) {
            setFormData(prev => ({
                ...prev,
                discountAmount: '',
                discountPercent: '',
                maxDiscountAmount: '',
                discountPrice: '',
                applicableCategories: [],
                applicableProducts: [],
                excludedProducts: [],
                minCartValue: '',
                newSizeUpgradeAddon: ''
            }));
        }
    }, [formData?.discountType, isEditForm, isTouched]);

    useEffect(() => {
        if (!isEditForm) {
            setFormData(prev => ({
                ...prev,
                discountAmount: '',
                discountPercent: '',
                maxDiscountAmount: '',
                discountPrice: '',
                applicableCategories: [],
                applicableProducts: [],
                excludedProducts: [],
                minCartValue: '',
                newSizeUpgradeAddon: '',
                freebieQuantity: '',
                freebieProduct: '',
                maxAddonsAllowed: '',
                // keep discountType valid for the newly selected coupon type
                discountType: getValidDiscountType(formData?.couponType, prev.discountType)
            }));
        }

        // Edit form: coupon type is now editable, so when the user changes it
        // the dependent fields are reset (same behaviour as the Add form)
        if (isEditForm && isCouponTypeTouched && formData?.couponType !== undefined) {
            setFormData(prev => ({
                ...prev,
                discountAmount: '',
                discountPercent: '',
                maxDiscountAmount: '',
                discountPrice: '',
                applicableCategories: [],
                applicableProducts: [],
                excludedProducts: [],
                minCartValue: '',
                newSizeUpgradeAddon: '',
                freebieQuantity: '',
                freebieProduct: '',
                maxAddonsAllowed: '',
                // keep discountType valid for the newly selected coupon type
                discountType: getValidDiscountType(formData?.couponType, prev.discountType)
            }));
        }
    }, [formData?.couponType, isEditForm, isCouponTypeTouched]);

    // Render coupon grid
    const renderCouponGrid = (couponList, isJourney = false, isFeedback = false) => {
        const couponsToDisplay = isJourney ? getPaginatedJourneyCoupons() : couponList;

        // Pagination values depend on which tab is being rendered
        const pageNow = isJourney ? journeyCurrentPage : isFeedback ? feedbackCurrentPage : currentPage;
        const pagesTotal = Number(isJourney ? journeyTotalPages : isFeedback ? feedbackTotalPages : totalPages) || 0;
        const setPage = isJourney ? setJourneyCurrentPage : isFeedback ? setFeedbackCurrentPage : setCurrentPage;

        if (loading) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" size="lg" />
                    <p className="mt-3 mb-0">Loading coupons...</p>
                </div>
            );
        }

        if (couponsToDisplay?.length > 0) {
            return (
                <>
                    <Row className="g-3 mb-4">
                        {couponsToDisplay?.map((coupon) => (
                            <Col key={coupon._id} xs={12} sm={6} md={4} lg={2}>
                                <div className="coupon-container">
                                    {/* Coupon Card */}
                                    <Card className="coupon-card">
                                        {/* Coupon Image Section */}
                                        {coupon.displayImageUrl && (
                                            <div className="coupon-image-container">
                                                <Image
                                                    src={coupon.displayImageUrl}
                                                    alt={coupon.title}
                                                    fluid
                                                    className="coupon-image"
                                                />
                                            </div>
                                        )}

                                        {/* Main Coupon Body */}
                                        <div
                                            className="coupon-main"
                                            style={{
                                                background: isJourney ? getJourneyStageColor(coupon.nthOrderNumber) : getCouponTypeColor(coupon.couponType)
                                            }}
                                        >
                                            {/* Coupon Header */}
                                            <div className="coupon-header">
                                                {!isJourney && (
                                                    <div className="coupon-type">
                                                        {getCouponTypeIcon(coupon.couponType)}
                                                        <span className="ms-1 coupon-type-text">
                                                            {coupon.couponType !== null ? coupon.couponType : coupon.couponType === null && coupon?.applicableCategories?.length > 0 ? 'CATEGORY' : 'PRODUCT'}
                                                        </span>
                                                    </div>
                                                )}

                                                {coupon?.nthOrderNumber && (
                                                    <div className="nth-order-badge w-100">
                                                        <Hash size={10} /> {coupon?.nthOrderNumber}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Discount Display */}
                                            <div className="discount-section">
                                                <div className="discount-value">
                                                    {coupon?.couponType === 'SIZE_UPGRADE' ? (
                                                        <>
                                                            <span style={{ fontSize: '15px' }}>SIZE_UPGRADE</span>
                                                        </>
                                                    ) : coupon?.couponType === 'BOGO' ? (
                                                        <>
                                                            <span style={{ fontSize: '15px' }}>BOGO</span>
                                                        </>
                                                    ) : coupon?.couponType === 'FREEBIE' ? (
                                                        <>
                                                            <span style={{ fontSize: '15px' }}>FREEBIE</span>
                                                        </>
                                                    ) : coupon?.discountType === 'PERCENT' ? (
                                                        <>
                                                            <span className="percent">{coupon.discountPercent}</span>
                                                            <span className="percent-symbol">%</span>
                                                        </>
                                                    ) : coupon?.discountType === 'FLAT' ? (
                                                        <>
                                                            <span className="rupee">₹</span>
                                                            <span className="amount">{coupon.discountAmount}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span className="rupee">₹</span>
                                                            <span className="amount">{coupon.discountPrice}</span>
                                                        </>
                                                    )}
                                                </div>

                                                {['SIZE_UPGRADE', 'BOGO', 'FREEBIE'].includes(coupon.couponType) ? (
                                                    <div className="discount-type-badge">Coupon</div>
                                                ) : coupon.discountPrice ? (
                                                    <div className="off-label">ONLY</div>
                                                ) : coupon.discountPercent ? (
                                                    <div className="off-label">OFF</div>
                                                ) : coupon.discountAmount ? (
                                                    <div className="off-label">FLAT</div>
                                                ) : (
                                                    <div className="off-label">PRICE</div>
                                                )}
                                            </div>

                                            {/* Coupon Title */}
                                            <div className="coupon-title">
                                                <h5 title={coupon.title}>{coupon.title}</h5>
                                                {isJourney && coupon.nthOrderNumber && (
                                                    <small className="journey-subtitle fw-semibold">
                                                        For Customer's {coupon.nthOrderNumber}th Order
                                                    </small>
                                                )}
                                                {isFeedback && (
                                                    <small className="journey-subtitle fw-semibold">
                                                        Feedback Coupon
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        {/* Coupon Details */}
                                        <div className="coupon-details">
                                            {/* Usage */}
                                            <div className="detail-item">
                                                <span className="detail-label">Usage:</span>
                                                <span className="detail-value">
                                                    <Badge bg="light" text="dark" className="usage-badge">
                                                        ₹. {coupon.usageType}
                                                    </Badge>
                                                </span>
                                            </div>

                                            {/* Validity */}
                                            <div className="detail-item">
                                                <span className="detail-label">Validity:</span>
                                                <span className="detail-value">{coupon.validityInDays}</span>
                                            </div>

                                            {/* Nth Order No: */}
                                            {(isJourney) && (
                                                <div className="detail-item">
                                                    <span className="detail-label">Nth Order No:</span>
                                                    <span className="detail-value">
                                                        <Badge bg="light" text="dark" className="usage-badge">
                                                            {coupon.nthOrderNumber}
                                                        </Badge>
                                                    </span>
                                                </div>
                                            )}

                                            {/* Min Order Amount */}
                                            {(!isJourney && coupon.minOrderAmount) && (
                                                <div className="detail-item">
                                                    <span className="detail-label">Min Order Amount:</span>
                                                    <span className="detail-value">
                                                        <span className="detail-value">₹. {coupon.minOrderAmount}</span>
                                                    </span>
                                                </div>
                                            )}

                                            {/* Max Order Amount */}
                                            {(!isJourney && coupon.maxOrderAmount) && (
                                                <div className="detail-item">
                                                    <span className="detail-label">Max Order Amount:</span>
                                                    <span className="detail-value">
                                                        <span className="detail-value">₹. {coupon.maxOrderAmount}</span>
                                                    </span>
                                                </div>
                                            )}

                                            {/* Maximum Discount Amount */}
                                            {coupon.maxDiscountAmount && (
                                                <div className="detail-item">
                                                    <span className="detail-label">Max. Dis Amount:</span>
                                                    <span className="detail-value">₹. {coupon.maxDiscountAmount}</span>
                                                </div>
                                            )}

                                            {/* Minimum Cart Value */}
                                            {coupon.minCartValue && (
                                                <div className="detail-item">
                                                    <span className="detail-label">Min. Cart Value:</span>
                                                    <span className="detail-value">₹. {coupon.minCartValue}</span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="coupon-actions">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => handleViewCoupon(coupon)}
                                                className="action-btn"
                                                title="View Details"
                                            >
                                                <Eye size={12} />
                                            </Button>
                                            <Button
                                                variant="outline-success"
                                                size="sm"
                                                onClick={() => handleEditCoupon(coupon)}
                                                className="action-btn"
                                                title="Edit Coupon"
                                            >
                                                <Edit size={12} />
                                            </Button>
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => handleDeleteCoupon(coupon)}
                                                className="action-btn"
                                                title="Delete Coupon"
                                            >
                                                <Trash2 size={12} />
                                            </Button>
                                        </div>
                                    </Card>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    {/* Pagination */}
                    {pagesTotal > 1 && (
                        <div className="d-flex justify-content-center mt-4">
                            <Pagination>
                                <Pagination.Prev
                                    onClick={() => pageNow > 1 && setPage(pageNow - 1)}
                                    disabled={pageNow === 1}
                                />
                                {Array.from({ length: pagesTotal }, (_, i) => i + 1).map(number => (
                                    <Pagination.Item
                                        key={number}
                                        active={number === pageNow}
                                        onClick={() => setPage(number)}
                                    >
                                        {number}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next
                                    onClick={() => pageNow < pagesTotal && setPage(pageNow + 1)}
                                    disabled={pageNow === pagesTotal}
                                />
                            </Pagination>
                        </div>
                    )}
                </>
            );
        }

        return (
            <div className="text-center py-5">
                <div className="py-5">
                    {isJourney ? (
                        <>
                            <Compass size={64} className="text-muted mb-4" />
                            <h5 className="mb-3">No Journey Coupons Found</h5>
                            <p className="text-muted mb-4">
                                You haven't created any journey coupons yet.
                            </p>
                        </>
                    ) : isFeedback ? (
                        <>
                            <MessageSquare size={64} className="text-muted mb-4" />
                            <h5 className="mb-3">No Feedback Coupons Found</h5>
                            <p className="text-muted mb-4">
                                You haven't created any feedback coupons yet.
                            </p>
                        </>
                    ) : (
                        <>
                            <Ticket size={64} className="text-muted mb-4" />
                            <h5 className="mb-3">No Auto Coupons Found</h5>
                            <p className="text-muted mb-4">
                                You haven't created any auto coupon allocations yet.
                            </p>
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <Header onSkin={setSkin} />

            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    {/* Header */}
                    <Row className="pt-3">
                        <Col>
                            <div className="d-flex align-items-center justify-content-between mb-1">
                                <div className="d-flex align-items-center">
                                    <Ticket className="me-3" size={26} color="#0d6efd" />
                                    <h4 className="fw-semibold mb-0">AUTO COUPON ALLOCATION</h4>
                                </div>
                                <Button
                                    variant="primary"
                                    onClick={handleAddCoupon}
                                >
                                    <Plus size={16} className="me-2" />
                                    Create Auto Coupon
                                </Button>
                            </div>
                        </Col>
                        <hr />
                    </Row>

                    {/* Tabs Navigation */}
                    <Row className="mb-4">
                        <Col>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                className="mb-3"
                            >
                                {/* ---------------- Journey Coupons ---------------- */}
                                <Tab eventKey="journey-coupons" title={
                                    <span className="d-flex align-items-center">
                                        <Compass size={16} className="me-2" />
                                        Journey Coupons
                                    </span>
                                }>
                                    <div className="mt-3">
                                        {/* Filters Section */}
                                        <Row className="mb-4">
                                            <Col md={4}>
                                                <InputGroup>
                                                    <div className="input-group w-100">
                                                        <input
                                                            type="text"
                                                            value={journeySearchQuery}
                                                            onChange={handleChangeJourneySearch}
                                                            className="form-control"
                                                            placeholder="Search for Journey Coupons"
                                                        />
                                                        <button className="btn btn-primary" type="button" onClick={handleSearchJourney}>
                                                            <i className="ri-search-line"></i> Search
                                                        </button>
                                                    </div>
                                                </InputGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={journeyCouponTypeFilter}
                                                    onChange={(e) => setJourneyCouponTypeFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Coupon Types</option>
                                                    <option value="BOGO">BOGO</option>
                                                    <option value="">Category / Product</option>
                                                    <option value="CART">Cart</option>
                                                    <option value="FREEBIE">Freebie</option>
                                                    <option value="SIZE_UPGRADE">Size Upgrade</option>
                                                    <option value="UNIVERSAL">Universal</option>
                                                </Form.Select>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={journeyStatusFilter}
                                                    onChange={(e) => setJourneyStatusFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Status</option>
                                                    <option value="ACTIVE">Active</option>
                                                    <option value="INACTIVE">Inactive</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>

                                        {/* Stats & Actions */}
                                        <Row className="mb-4">
                                            <Col>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="mb-1">
                                                            <strong>{totalJourneyCoupons}</strong> Journey Coupons
                                                        </h6>
                                                        <small className="text-muted">
                                                            Showing {Math.min(itemsPerPage, journeyCoupons.length)} of {totalJourneyCoupons}
                                                        </small>
                                                    </div>
                                                    <Button
                                                        variant="outline-primary"
                                                        onClick={refreshData}
                                                        disabled={loading}
                                                    >
                                                        <RefreshCw size={16} className="me-2" />
                                                        {loading ? 'Refreshing...' : 'Refresh'}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Journey Coupons Grid */}
                                        {renderCouponGrid(journeyCoupons, true)}
                                    </div>
                                </Tab>

                                {/* ---------------- Other Coupons ---------------- */}
                                <Tab eventKey="all-coupons" title={
                                    <span className="d-flex align-items-center">
                                        <Ticket size={16} className="me-2" />
                                        Other Coupons
                                    </span>
                                }>
                                    <div className="mt-3">
                                        {/* Filters Section */}
                                        <Row className="mb-4">
                                            <Col md={6}>
                                                <InputGroup>
                                                    <div className="input-group w-100">
                                                        <input
                                                            type="text"
                                                            value={regularSearchQuery}
                                                            onChange={handleChangeRegularSearch}
                                                            className="form-control"
                                                            placeholder="Search for Regular Coupons"
                                                        />
                                                        <button className="btn btn-primary" type="button" onClick={handleSearchRegular}>
                                                            <i className="ri-search-line"></i> Search
                                                        </button>
                                                    </div>
                                                </InputGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={regularCouponTypeFilter}
                                                    onChange={(e) => setRegularCouponTypeFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Coupon Types</option>
                                                    <option value="BOGO">BOGO</option>
                                                    <option value="">Category / Product</option>
                                                    <option value="CART">Cart</option>
                                                    <option value="FREEBIE">Freebie</option>
                                                    <option value="SIZE_UPGRADE">Size Upgrade</option>
                                                    <option value="UNIVERSAL">Universal</option>
                                                </Form.Select>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={regularStatusFilter}
                                                    onChange={(e) => setRegularStatusFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Status</option>
                                                    <option value="ACTIVE">Active</option>
                                                    <option value="INACTIVE">Inactive</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>

                                        {/* Stats & Actions */}
                                        <Row className="mb-4">
                                            <Col>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="mb-1">
                                                            <strong>{totalCoupons}</strong> Non-Journey Coupons
                                                        </h6>
                                                        <small className="text-muted">
                                                            Showing {Math.min(itemsPerPage, filteredCoupons.length)} of {totalCoupons}
                                                        </small>
                                                    </div>
                                                    <Button
                                                        variant="outline-primary"
                                                        onClick={refreshData}
                                                        disabled={loading}
                                                    >
                                                        <RefreshCw size={16} className="me-2" />
                                                        {loading ? 'Refreshing...' : 'Refresh'}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Coupons Grid */}
                                        {renderCouponGrid(filteredCoupons, false)}
                                    </div>
                                </Tab>

                                {/* ---------------- Feedback Coupons ---------------- */}
                                <Tab eventKey="feedback-coupons" title={
                                    <span className="d-flex align-items-center">
                                        <MessageSquare size={16} className="me-2" />
                                        Feedback Coupons
                                    </span>
                                }>
                                    <div className="mt-3">
                                        {/* Filters Section */}
                                        <Row className="mb-4">
                                            <Col md={6}>
                                                <InputGroup>
                                                    <div className="input-group w-100">
                                                        <input
                                                            type="text"
                                                            value={feedbackSearchQuery}
                                                            onChange={handleChangeFeedbackSearch}
                                                            className="form-control"
                                                            placeholder="Search for Feedback Coupons"
                                                        />
                                                        <button className="btn btn-primary" type="button" onClick={handleSearchFeedback}>
                                                            <i className="ri-search-line"></i> Search
                                                        </button>
                                                    </div>
                                                </InputGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={feedbackCouponTypeFilter}
                                                    onChange={(e) => setFeedbackCouponTypeFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Coupon Types</option>
                                                    <option value="BOGO">BOGO</option>
                                                    <option value="">Category / Product</option>
                                                    <option value="CART">Cart</option>
                                                    <option value="FREEBIE">Freebie</option>
                                                    <option value="SIZE_UPGRADE">Size Upgrade</option>
                                                    <option value="UNIVERSAL">Universal</option>
                                                </Form.Select>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Select
                                                    value={feedbackStatusFilter}
                                                    onChange={(e) => setFeedbackStatusFilter(e.target.value)}
                                                >
                                                    <option value="ALL">All Status</option>
                                                    <option value="ACTIVE">Active</option>
                                                    <option value="INACTIVE">Inactive</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>

                                        {/* Stats & Actions */}
                                        <Row className="mb-4">
                                            <Col>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="mb-1">
                                                            <strong>{totalFeedbackCoupons}</strong> Feedback Coupons
                                                        </h6>
                                                        <small className="text-muted">
                                                            Showing {Math.min(itemsPerPage, feedbackCoupons.length)} of {totalFeedbackCoupons}
                                                        </small>
                                                    </div>
                                                    <Button
                                                        variant="outline-primary"
                                                        onClick={refreshData}
                                                        disabled={loading}
                                                    >
                                                        <RefreshCw size={16} className="me-2" />
                                                        {loading ? 'Refreshing...' : 'Refresh'}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Feedback Coupons Grid */}
                                        {renderCouponGrid(feedbackCoupons, false, true)}
                                    </div>
                                </Tab>

                            </Tabs>
                        </Col>
                    </Row>
                </div>

                {/* Add/Edit Modal */}
                <Modal show={showAddModal || showEditModal} onHide={closeFormModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <Ticket size={20} className="me-2" />
                            {showEditModal ? 'Edit Auto Coupon' : 'Create Auto Coupon'}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Accordion activeKey={activeAccordion} onSelect={(k) => setActiveAccordion(k)}>
                                {/* Basic Information */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Basic Information</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Title <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="title"
                                                        value={formData.title}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter coupon title"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {isEditForm && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Status<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="status"
                                                            value={formData?.status}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="">Select Status</option>
                                                            <option value="ACTIVE">ACTIVE</option>
                                                            <option value="INACTIVE">INACTIVE</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Description <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter coupon description"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {/* Display Image Upload Section */}
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold d-flex align-items-center">
                                                        <ImageIcon size={16} className="me-2" />
                                                        Coupon Display Image
                                                        <span className="text-danger ms-1">*</span>
                                                    </Form.Label>

                                                    {imagePreview ? (
                                                        <div className="image-preview-container mb-3">
                                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                                <small className="text-success">
                                                                    <CheckCircle size={14} className="me-1" />
                                                                    Image added successfully
                                                                </small>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={handleRemoveImage}
                                                                    disabled={uploadingImage}
                                                                >
                                                                    <X size={14} className="me-1" />
                                                                    Remove
                                                                </Button>
                                                            </div>
                                                            <div className="border rounded p-2 bg-light">
                                                                <Image
                                                                    src={imagePreview}
                                                                    alt="Coupon preview"
                                                                    fluid
                                                                    className="uploaded-image-preview"
                                                                    style={{ maxHeight: '150px', objectFit: 'contain' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="image-upload-area border rounded p-4 text-center">
                                                            <input
                                                                type="file"
                                                                id="couponImageUpload"
                                                                accept="image/*"
                                                                onChange={handleImageChange}
                                                                className="d-none"
                                                                disabled={uploadingImage}
                                                            />
                                                            <label htmlFor="couponImageUpload" className="cursor-pointer d-flex flex-column align-items-center">
                                                                {uploadingImage ? (
                                                                    <>
                                                                        <Spinner animation="border" size="sm" className="mb-2" />
                                                                        <small>Processing image...</small>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Upload size={48} className="text-muted mb-2" />
                                                                        <div className="mb-2">
                                                                            <Button style={{ pointerEvents: 'none' }} variant="outline-primary" size="sm">
                                                                                Choose Image
                                                                            </Button>
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            Recommended: JPG/PNG/WEBP/GIF (Max 5MB)
                                                                        </small>
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>
                                                    )}

                                                    <Form.Text className="text-muted">
                                                        This image will be displayed with the coupon in the app.
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* Coupon Details */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Coupon Details</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Coupon Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="couponType"
                                                        value={formData.couponType}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="All">Select Coupon Type</option>
                                                        <option value="">Category / Product</option>
                                                        <option value="BOGO">BOGO</option>
                                                        <option value="CART">Cart</option>
                                                        <option value="FREEBIE">Freebie</option>
                                                        <option value="SIZE_UPGRADE">Size Upgrade</option>
                                                        <option value="UNIVERSAL">Universal</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Usage Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="usageType"
                                                        value={formData.usageType}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="ONE-TIME">One Time Use</option>
                                                        <option value="MULTIPLE">Multiple Use</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* 3 columns: Nth Order Number | Is Feedback Coupon | Validity */}
                                        <Row>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Nth Order Number
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="nthOrderNumber"
                                                        value={formData.nthOrderNumber ?? ''}
                                                        onChange={handleInputChange}
                                                        disabled={isFeedbackSelected || (formData.maxOrderAmount && formData.minOrderAmount)}
                                                        placeholder="For Which Order You Want to Give This Coupon"
                                                        min="2"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Is Feedback Coupon
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="isFeedBackCoupon"
                                                        value={String(feedbackDisabled ? false : formData.isFeedBackCoupon)}
                                                        onChange={handleFeedbackChange}
                                                        disabled={feedbackDisabled}
                                                    >
                                                        <option value="false">No</option>
                                                        <option value="true">Yes</option>
                                                    </Form.Select>
                                                    {feedbackDisabled && (
                                                        <Form.Text className="text-muted">
                                                            Disabled when Nth Order Number or Min/Max Order Amount is set
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        Validity (Days) <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="validityInDays"
                                                        value={formData.validityInDays}
                                                        onChange={handleInputChange}
                                                        placeholder="Coupon validity in days"
                                                        min="1"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Minimum Order Amount</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="minOrderAmount"
                                                        value={formData.minOrderAmount}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter minimum order amount"
                                                        disabled={formData.nthOrderNumber || isFeedbackSelected}
                                                        min="1"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Maximum Order Amount</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="maxOrderAmount"
                                                        value={formData?.maxOrderAmount}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter maximum order amount"
                                                        disabled={formData?.nthOrderNumber || isFeedbackSelected}
                                                        min="1"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* Discount Configuration */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Discount Configuration</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Discount Type <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="discountType"
                                                            value={formData.discountType}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="PERCENT">Percentage</option>
                                                            {!['UNIVERSAL', 'CART', 'CART', 'FREEBIE'].includes(formData?.couponType) && (
                                                                <option value="PRICE">Discounted Price</option>
                                                            )}
                                                            {!['UNIVERSAL'].includes(formData?.couponType) && (
                                                                <option value="FLAT">Flat Amount</option>
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE', 'CART', 'UNIVERSAL'].includes(formData?.couponType) && formData?.discountType === 'PRICE' && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Applicable Qty Type <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="applicableQuantityType"
                                                            value={formData.applicableQuantityType}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="SINGLE">Single Use</option>
                                                            <option value="MULTIPLE">Multiple Use</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {(formData.discountType === 'PRICE' && formData.couponType !== 'BOGO' && formData?.couponType !== 'SIZE_UPGRADE' && formData?.couponType !== 'FREEBIE') && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Discounted Price <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="discountPrice"
                                                            value={formData.discountPrice}
                                                            disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
                                                            onChange={handleInputChange}
                                                            placeholder="Enter discounted price"
                                                            min="1"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {!['UNIVERSAL', 'SIZE_UPGRADE'].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Minimum Cart Value</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="minCartValue"
                                                            value={formData.minCartValue}
                                                            onChange={handleInputChange}
                                                            placeholder="Enter minimum cart value"
                                                            min="1"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {(formData.discountType === 'PERCENT' && formData.couponType !== 'BOGO' && formData?.couponType !== 'SIZE_UPGRADE' && formData?.couponType !== 'FREEBIE') ? (
                                                <>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">
                                                                Discount Percent <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="discountPercent"
                                                                value={formData.discountPercent}
                                                                disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
                                                                onChange={handleInputChange}
                                                                placeholder="Enter discount percentage"
                                                                min="1"
                                                                max="100"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="fw-semibold">
                                                                Max Discount Amount
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="maxDiscountAmount"
                                                                value={formData.maxDiscountAmount}
                                                                disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
                                                                onChange={handleInputChange}
                                                                placeholder="Enter maximum discount amount"
                                                                min="1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            ) : (
                                                <>
                                                    {!['BOGO', 'SIZE_UPGRADE', 'FREEBIE'].includes(formData?.couponType) && formData?.discountType !== 'PRICE' && formData?.discountType !== 'PERCENT' && (
                                                        <Col md={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label className="fw-semibold">
                                                                    Discount Amount <span className="text-danger">*</span>
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name="discountAmount"
                                                                    value={formData.discountAmount}
                                                                    disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE' || formData?.couponType === 'FREEBIE'}
                                                                    onChange={handleInputChange}
                                                                    placeholder="Enter flat discount amount"
                                                                    min="1"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                </>
                                            )}

                                            {formData?.couponType === 'FREEBIE' && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Freebie Products</Form.Label>
                                                        <Select
                                                            options={freebieProducts}
                                                            value={freebieProducts?.find(
                                                                opt => opt.value === formData.freebieProduct
                                                            )}
                                                            onChange={handleSelectChange}
                                                            placeholder="Select freebie product..."
                                                            styles={customSelectStyles}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            {formData.couponType === 'FREEBIE' && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">
                                                            Freebie Quantity <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="freebieQuantity"
                                                            value={formData.freebieQuantity}
                                                            disabled={formData.couponType === 'BOGO' || formData?.couponType === 'SIZE_UPGRADE'}
                                                            onChange={handleInputChange}
                                                            placeholder="Enter Freebie quantity"
                                                            min="1"
                                                            max="100"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {!['CART', 'FREEBIE', 'SIZE_UPGRADE', 'UNIVERSAL'].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Applicable Categories</Form.Label>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={categories}
                                                            value={formData.applicableCategories}
                                                            onChange={(selected) => handleMultiSelectChange('applicableCategories', selected)}
                                                            placeholder="Select applicable categories..."
                                                            styles={customSelectStyles}
                                                            isDisabled={formData?.couponType == 'FREEBIE'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            <Col md="6" lg="6" className='mb-3'>
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Products
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    value={formData?.excludedProducts}
                                                    onChange={(selected) => handleMultiSelectChange('excludedProducts', selected)}
                                                    options={excludedProducts}
                                                    placeholder="Select Excluded Products"
                                                    closeMenuOnSelect={false}
                                                    styles={customSelectStyles}
                                                    formatOptionLabel={(option) => (
                                                        <span style={{ color: option.isDelete ? '#dc3545' : 'inherit', fontWeight: option.isDelete ? 600 : 'normal' }}>
                                                            {option.label}{option.isDelete ? ' (Deleted)' : ''}
                                                        </span>
                                                    )}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: { ...theme.colors, primary25: "#e9ecef", primary: "#007bff" },
                                                    })}
                                                    isLoading={loadingExcludedProducts}
                                                    noOptionsMessage={() => "No products found"}
                                                />
                                                <Form.Text className="text-muted">
                                                    Products to exclude from this coupon
                                                </Form.Text>
                                            </Col>

                                            {/* Select Excluding Addons */}
                                            <Col md={6} className='mb-3'>
                                                <Form.Group>
                                                    <Form.Label className="fw-semibold">
                                                        Select Excluding Addons
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={allAddonList?.map(addon => ({
                                                            value: addon._id,
                                                            label: addon.title
                                                        }))}
                                                        value={selectedAddonGroups}
                                                        onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
                                                        styles={customSelectStyles}
                                                        placeholder="Select addon groups..."
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: { ...theme.colors, primary25: "#e9ecef", primary: "#007bff" },
                                                        })}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {/* Select Excluding Addon Values */}
                                            <Col md={6} className='mb-3'>
                                                <Form.Group>
                                                    <Form.Label className='fw-semibold'>
                                                        Select Excluding Addon Values
                                                    </Form.Label>
                                                    <Select
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={filteredAddonValues}
                                                        value={formData?.excludedAddonValues?.map(val => ({
                                                            value: val,
                                                            label: `${allAddonList.find(a => a._id === val.addonId)?.title || val.addonTitle || ''} - ${
                                                                allAddonList
                                                                    .find(a => a._id === val.addonId)
                                                                    ?.addonValues?.find(v => v._id === val.addValueId)?.value
                                                                || val.addonValueTitle || ''
                                                            }`
                                                        }))}
                                                        onChange={(selectedOptions) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                excludedAddonValues: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                                                            }));
                                                        }}
                                                        styles={customSelectStyles}
                                                        placeholder="Select addon values to exclude..."
                                                        getOptionLabel={(option) => option.label}
                                                        getOptionValue={(option) => `${option.value.addonId}-${option.value.addValueId}`}
                                                        noOptionsMessage={() =>
                                                            selectedAddonGroups.length === 0
                                                                ? "Select an addon group first"
                                                                : "No addon values found"
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>

                                            {/* Max Addons Allowed (hidden for Freebie) */}
                                            {formData?.couponType !== 'FREEBIE' && (
                                                <Col md={6} className='mb-3'>
                                                    <Form.Group>
                                                        <Form.Label className="fw-semibold">Max Addons Allowed</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            min={0}
                                                            name="maxAddonsAllowed"
                                                            placeholder="Max Addons Allowed"
                                                            value={formData.maxAddonsAllowed ?? ''}
                                                            onChange={(e) => {
                                                                if (/^\d*$/.test(e.target.value)) {
                                                                    handleInputChange(e);
                                                                }
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}
                                        </Row>

                                        <Row>
                                            {!['CART', 'FREEBIE', 'BOGO', 'UNIVERSAL', ''].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Applicable Categories</Form.Label>
                                                        <Select
                                                            isMulti
                                                            options={categories}
                                                            value={formData.applicableCategories}
                                                            onChange={(selected) => handleMultiSelectChange('applicableCategories', selected)}
                                                            placeholder="Select applicable categories..."
                                                            styles={customSelectStyles}
                                                            isDisabled={formData?.couponType == 'FREEBIE'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {!['BOGO', 'CART', 'FREEBIE', 'UNIVERSAL'].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Applicable Products</Form.Label>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={formData.couponType === 'SIZE_UPGRADE' ? addonsProducts : productsData}
                                                            value={formData.applicableProducts}
                                                            onChange={(selected) => handleMultiSelectChange('applicableProducts', selected)}
                                                            placeholder="Select applicable products..."
                                                            styles={customSelectStyles}
                                                            formatOptionLabel={(option) => (
                                                                <span style={{ color: option.isDelete ? '#dc3545' : 'inherit', fontWeight: option.isDelete ? 600 : 'normal' }}>
                                                                    {option.label}{option.isDelete ? ' (Deleted)' : ''}
                                                                </span>
                                                            )}
                                                            isDisabled={formData?.couponType == 'FREEBIE'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {!['UNIVERSAL', 'FREEBIE', 'BOGO', 'CART', ''].includes(formData?.couponType) && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Minimum Cart Value</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="minCartValue"
                                                            value={formData.minCartValue}
                                                            onChange={handleInputChange}
                                                            placeholder="Enter minimum cart value"
                                                            min="1"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}

                                            {formData?.couponType === 'SIZE_UPGRADE' && (
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold">Size Upgrade Addon <span className='ms-1 text-danger'>*</span></Form.Label>
                                                        <Form.Select
                                                            name="newSizeUpgradeAddon"
                                                            value={formData.newSizeUpgradeAddon}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="">Select Size Upgrade Addon</option>
                                                            {newSizeAddonsList?.map((addon) => (
                                                                <option key={addon._id} value={addon._id}>{addon.title} [{addon.identifier}]</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* Terms and Conditions */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Terms and Conditions</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">Add Terms</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            value={termInput}
                                                            onChange={(e) => setTermInput(e.target.value)}
                                                            placeholder="Enter a term and condition"
                                                            onKeyPress={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    handleAddTerm();
                                                                }
                                                            }}
                                                        />
                                                        <Button
                                                            variant="outline-primary"
                                                            onClick={handleAddTerm}
                                                        >
                                                            Add
                                                        </Button>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Terms List */}
                                        {formData.termsAndConditions.length > 0 && (
                                            <Row>
                                                <Col md={12}>
                                                    <div className="border rounded p-3">
                                                        <h6 className="mb-3">Added Terms:</h6>
                                                        <ul className="list-group">
                                                            {formData.termsAndConditions.map((term, index) => (
                                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                                    <span>{term}</span>
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => handleRemoveTerm(index)}
                                                                    >
                                                                        <X size={14} />
                                                                    </Button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                onClick={closeFormModal}
                                disabled={submitting}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={submitting || uploadingImage}
                            >
                                {submitting ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            className="me-2"
                                        />
                                        {showEditModal ? 'Updating...' : 'Creating...'}
                                    </>
                                ) : (
                                    showEditModal ? 'Update Coupon' : 'Create Coupon'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* View Modal */}
                <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <Ticket size={20} className="me-2" />
                            Coupon Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedCoupon ? (
                            <div className="coupon-details">
                                {/* Coupon Image */}
                                {selectedCoupon.displayImageUrl && (
                                    <div className="text-center mb-4">
                                        <Image
                                            src={selectedCoupon.displayImageUrl}
                                            alt={selectedCoupon.title}
                                            fluid
                                            className="rounded border"
                                            style={{ maxHeight: '200px', objectFit: 'contain' }}
                                        />
                                    </div>
                                )}

                                {/* Header */}
                                <div className="d-flex align-items-center justify-content-between mb-4">
                                    <div className='text-white'>.</div>
                                    <div>
                                        <h4 className="fw-bold mb-1">{selectedCoupon.title}</h4>
                                        <p className="text-muted text-center mb-0">{selectedCoupon.description}</p>
                                    </div>
                                    <div className="d-flex gap-2">
                                        {selectedCoupon.nthOrderNumber && parseInt(selectedCoupon.nthOrderNumber) >= 2 && (
                                            <Badge bg="warning" className="journey-badge">
                                                <Compass size={12} className="me-1" />
                                                Journey Coupon
                                            </Badge>
                                        )}
                                        {selectedCoupon.isFeedBackCoupon === true && (
                                            <Badge bg="info" className="journey-badge">
                                                <MessageSquare size={12} className="me-1" />
                                                Feedback Coupon
                                            </Badge>
                                        )}
                                    </div>
                                </div>

                                {/* Discount Summary Row */}
                                <div className="mb-4">
                                    <div className="discount-summary-card p-3 border rounded bg-light">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <h5 className="mb-1">Discount Offered</h5>
                                                <p className="text-muted small mb-0">Effective discount value for customers</p>
                                            </div>
                                            <div className="col-md-6 text-end">
                                                <div className="display-5 fw-bold text-success">
                                                    {selectedCoupon.couponType === 'SIZE_UPGRADE' ? (
                                                        <>SIZE UPGRADE</>
                                                    ) : selectedCoupon.couponType === 'BOGO' ? (
                                                        <>BOGO OFFER</>
                                                    ) : selectedCoupon.couponType === 'FREEBIE' ? (
                                                        <>FREEBIE</>
                                                    ) : selectedCoupon.discountType === 'PERCENT' ? (
                                                        <>{selectedCoupon.discountPercent}% OFF</>
                                                    ) : selectedCoupon.discountAmount ? (
                                                        <>₹ {selectedCoupon.discountAmount} OFF</>
                                                    ) : selectedCoupon.discountPercent ? (
                                                        <>{selectedCoupon.discountPercent}% OFF</>
                                                    ) : (
                                                        <>₹ {selectedCoupon.discountPrice} ONLY</>
                                                    )}
                                                </div>
                                                {selectedCoupon.discountType === 'PERCENT' && selectedCoupon.maxDiscountAmount && (
                                                    <div className="text-muted small">
                                                        (Maximum ₹{selectedCoupon.maxDiscountAmount})
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Journey Stage Info */}
                                {selectedCoupon.nthOrderNumber && (
                                    <div className="mb-4">
                                        <h6 className="d-flex align-items-center">
                                            <Route size={16} className="me-2" />
                                            Journey Information
                                        </h6>
                                        <div className="journey-info-card p-3 border rounded">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="mb-2">
                                                        <small className="text-muted me-3">Applicable Order : </small>
                                                        <strong>On Customer's {selectedCoupon.nthOrderNumber}th Order</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Details in Cards */}
                                <Row className="g-3">
                                    {/* Basic Info */}
                                    <Col md={6}>
                                        <Card className="h-100">
                                            <Card.Header className="bg-light">
                                                <h6 className="mb-0">
                                                    <Award size={16} className="me-2" />
                                                    Basic Information
                                                </h6>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className="mb-2">
                                                    <small className="text-muted d-block">Coupon Type:</small>
                                                    <strong>{selectedCoupon.couponType ? selectedCoupon.couponType : 'Category / Products'}</strong>
                                                </div>
                                                <div className="mb-2">
                                                    <small className="text-muted d-block">Usage Type:</small>
                                                    <strong>{selectedCoupon.usageType}</strong>
                                                </div>
                                                <div className="mb-2">
                                                    <small className="text-muted d-block">Validity:</small>
                                                    <strong>{selectedCoupon.validityInDays} days</strong>
                                                </div>
                                                <div className="mb-2">
                                                    <small className="text-muted d-block">Feedback Coupon:</small>
                                                    <strong>{selectedCoupon.isFeedBackCoupon ? 'Yes' : 'No'}</strong>
                                                </div>
                                                {selectedCoupon.maxOrderAmount && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Max Order Amount:</small>
                                                        <strong>₹{selectedCoupon.maxOrderAmount}</strong>
                                                    </div>
                                                )}
                                                {selectedCoupon.minOrderAmount && (
                                                    <div className="mb-2 mt-3">
                                                        <small className="text-muted d-block">Min Order Amount:</small>
                                                        <strong>₹{selectedCoupon.minOrderAmount || '0'}</strong>
                                                    </div>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    {/* Discount Info */}
                                    <Col md={6}>
                                        <Card className="h-100">
                                            <Card.Header className="bg-light">
                                                <h6 className="mb-0">
                                                    <Percent size={16} className="me-2" />
                                                    Discount Details
                                                </h6>
                                            </Card.Header>
                                            <Card.Body>

                                                {selectedCoupon.couponType === 'SIZE_UPGRADE' ? (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Offer Type:</small>
                                                        <strong>Size Upgrade Coupon</strong>
                                                    </div>
                                                ) : selectedCoupon.couponType === 'BOGO' ? (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Offer Type:</small>
                                                        <strong>Buy One Get One Offer</strong>
                                                    </div>
                                                ) : selectedCoupon.couponType === 'FREEBIE' ? (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Offer Type:</small>
                                                        <strong>Freebie Offer</strong>
                                                    </div>
                                                ) : selectedCoupon.discountType === 'PERCENT' ? (
                                                    <>
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">Discount Percentage:</small>
                                                            <div className="d-flex align-items-center">
                                                                <strong className="me-2">{selectedCoupon.discountPercent}%</strong>
                                                            </div>
                                                        </div>
                                                        {selectedCoupon.maxDiscountAmount && (
                                                            <div className="mb-2">
                                                                <small className="text-muted d-block">Maximum Discount:</small>
                                                                <strong>₹ {selectedCoupon.maxDiscountAmount}</strong>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : selectedCoupon.discountType === 'FLAT' ? (
                                                    <>
                                                        <div className="mb-2">
                                                            <small className="text-muted d-block">Flat Discount:</small>
                                                            <strong>₹ {selectedCoupon.discountAmount || '0'}</strong>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {selectedCoupon.discountPercent && (
                                                            <div className="mb-2">
                                                                <small className="text-muted d-block">Discount Percentage:</small>
                                                                <div className="d-flex align-items-center">
                                                                    <strong className="me-2">{selectedCoupon.discountPercent}%</strong>
                                                                    {selectedCoupon.maxDiscountAmount && (
                                                                        <Badge bg="success" className="fw-normal">
                                                                            Up to ₹{selectedCoupon.maxDiscountAmount}
                                                                        </Badge>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {selectedCoupon.discountAmount && (
                                                            <div className="mb-2">
                                                                <small className="text-muted d-block">Flat Discount:</small>
                                                                <strong>₹{selectedCoupon.discountAmount}</strong>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {!['SIZE_UPGRADE', 'BOGO', 'FREEBIE'].includes(selectedCoupon?.couponType) && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Discount Type:</small>
                                                        <strong>{selectedCoupon.discountType ? `${selectedCoupon.discountType}` : "Category / Product Coupon"}</strong>
                                                    </div>
                                                )}

                                                {selectedCoupon?.freebieQuantity && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Freebie Qty:</small>
                                                        <strong>{selectedCoupon.freebieQuantity}</strong>
                                                    </div>
                                                )}

                                                {selectedCoupon?.freebieQuantity && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Freebie Product:</small>
                                                        <strong>{selectedCoupon?.freebieProduct?.name}</strong>
                                                    </div>
                                                )}

                                                {selectedCoupon?.discountPrice && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Applicable qty:</small>
                                                        <strong>{selectedCoupon.applicableQuantityType}</strong>
                                                    </div>
                                                )}
                                                {selectedCoupon?.discountPrice && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Discounted Price:</small>
                                                        <strong>₹ {selectedCoupon.discountPrice} only</strong>
                                                    </div>
                                                )}

                                                {selectedCoupon.newSizeUpgradeAddon && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Size Upgrade:</small>
                                                        <strong>{selectedCoupon?.newSizeUpgradeAddon?.title} [{selectedCoupon?.newSizeUpgradeAddon?.identifier}]</strong>
                                                    </div>
                                                )}

                                                {selectedCoupon?.minCartValue && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Minimum Cart Value:</small>
                                                        <strong>₹ {selectedCoupon.minCartValue}</strong>
                                                    </div>
                                                )}

                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    {/* Applicability */}
                                    <Col md={6}>
                                        <Card className="h-100">
                                            <Card.Header className="bg-light">
                                                <h6 className="mb-0">
                                                    <Package size={16} className="me-2" />
                                                    Applicability
                                                </h6>
                                            </Card.Header>
                                            <Card.Body>
                                                {selectedCoupon.applicableProducts?.length > 0 ? (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Applicable Products:</small>
                                                        <div className="mt-1">
                                                            {selectedCoupon.applicableProducts.map((product, idx) => (
                                                                <Badge key={idx} bg="info" className="me-1 mb-1">
                                                                    {product.name}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : selectedCoupon.applicableCategories?.length > 0 ? (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Applicable Categories:</small>
                                                        <div className="mt-1">
                                                            {selectedCoupon.applicableCategories.map((category, idx) => (
                                                                <Badge key={idx} bg="info" className="me-1 mb-1">
                                                                    {category.name}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Applicable On:</small>
                                                        <strong>All Products & Categories</strong>
                                                    </div>
                                                )}
                                                {selectedCoupon?.excludedProducts?.length > 0 && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Excluded Products:</small>
                                                        <div className="mt-1">
                                                            {selectedCoupon.excludedProducts.map((category, idx) => (
                                                                <Badge key={idx} bg="info" className="me-1 mb-1">
                                                                    {category.name}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Excluded Addons / Addon Values */}
                                                {selectedCoupon?.excludedAddons?.length > 0 && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Excluded Addon Values:</small>
                                                        <div className="mt-1">
                                                            {selectedCoupon.excludedAddons.map((addon, idx) => (
                                                                <Badge key={idx} bg="secondary" className="me-1 mb-1">
                                                                    {addon.addonTitle} - {addon.addonValueTitle}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Max Addons Allowed */}
                                                {selectedCoupon?.maxAddonsAllowed !== null && selectedCoupon?.maxAddonsAllowed !== undefined && (
                                                    <div className="mb-2">
                                                        <small className="text-muted d-block">Max Addons Allowed:</small>
                                                        <strong>{selectedCoupon.maxAddonsAllowed}</strong>
                                                    </div>
                                                )}

                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    {/* Terms & Meta */}
                                    {selectedCoupon?.termsAndConditions?.length > 0 && (
                                        <Col md={6}>
                                            <Card className="h-100">
                                                <Card.Header className="bg-light">
                                                    <h6 className="mb-0">
                                                        <Calendar size={16} className="me-2" />
                                                        Additional Information
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body>
                                                    {selectedCoupon.termsAndConditions?.length > 0 && (
                                                        <div className="mb-3">
                                                            <small className="text-muted d-block">Terms & Conditions:</small>
                                                            <ul className="ps-3 mb-0">
                                                                {selectedCoupon.termsAndConditions.map((term, idx) => (
                                                                    <li key={idx} className="small">{term}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}

                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2 mb-0">Loading coupon details...</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowViewModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to delete this auto coupon?</p>
                        <p className="text-muted small">
                            This action cannot be undone. The coupon will be permanently deleted.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowDeleteModal(false)}
                            disabled={deleteLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            onClick={handleDelete}
                            disabled={deleteLoading}
                        >
                            {deleteLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Deleting...
                                </>
                            ) : (
                                "Delete Coupon"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            {/* Coupon card styles */}
            <style jsx>{`
                .coupon-container {
                    position: relative;
                    transition: transform 0.3s ease;
                    height: 100%;
                }

                .coupon-container:hover {
                    transform: translateY(-3px);
                }

                .coupon-card {
                    border-radius: 10px;
                    overflow: hidden;
                    border: 1.5px dashed #dee2e6;
                    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
                    transition: all 0.3s ease;
                    position: relative;
                    background: white;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    min-height: 350px;
                }

                .coupon-card:hover {
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                    border-color: #0d6efd;
                }

                .coupon-image-container {
                    height: 100px;
                    overflow: hidden;
                    border-bottom: 1px solid #dee2e6;
                }

                .coupon-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .coupon-main {
                    padding: 15px;
                    color: white;
                    position: relative;
                    flex-shrink: 0;
                }

                .coupon-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 8px;
                    min-height: 32px;
                }

                .coupon-type {
                    display: flex;
                    align-items: center;
                    font-size: 10px;
                    font-weight: 600;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 3px 8px;
                    border-radius: 15px;
                    backdrop-filter: blur(4px);
                    max-width: 70%;
                }

                .coupon-type-text {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 10px;
                }

                .nth-order-badge {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(255, 255, 255, 0.3);
                    color: white;
                    padding: 3px 6px;
                    border-radius: 15px;
                    font-size: 10px;
                    font-weight: 600;
                    width: 24px;
                    height: 24px;
                }

                .journey-stage-indicator {
                    display: flex;
                    justify-content: center;
                    margin: 8px 0;
                }

                .journey-stage-badge {
                    font-size: 9px;
                    padding: 3px 8px;
                    border-radius: 15px;
                }

                .journey-subtitle {
                    font-size: 10px;
                    opacity: 0.9;
                    margin-top: 3px;
                    display: block;
                }

                .journey-legend {
                    background: #f8f9fa;
                }

                .journey-badge {
                    display: flex;
                    align-items: center;
                }

                .journey-info-card {
                    background: #fff9e6;
                }

                .discount-section {
                    text-align: center;
                    margin: 5px 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .discount-value {
                    font-size: 24px;
                    font-weight: 800;
                    line-height: 1;
                    margin-bottom: 2px;
                    display: flex;
                    align-items: baseline;
                    justify-content: center;
                    gap: 2px;
                    flex-wrap: wrap;
                }

                .percent {
                    font-size: 22px;
                }

                .percent-symbol {
                    font-size: 18px;
                    margin-right: 4px;
                }

                .rupee {
                    font-size: 16px;
                    margin-right: 2px;
                }

                .amount {
                    font-size: 22px;
                }

                .off-label {
                    font-size: 12px;
                    font-weight: 600;
                    opacity: 0.9;
                    margin-top: 2px;
                }

                .max-discount {
                    font-size: 10px;
                    font-weight: 500;
                    opacity: 0.9;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 3px 8px;
                    border-radius: 15px;
                    display: inline-block;
                    margin-top: 5px;
                }

                .coupon-title {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .coupon-title h5 {
                    font-size: 13px;
                    font-weight: 700;
                    margin: 0;
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 1.3;
                }

                .coupon-details {
                    padding: 12px 15px;
                    background: white;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .detail-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 4px 0;
                    border-bottom: 1px solid #f1f3f4;
                }

                .detail-item:last-child {
                    border-bottom: none;
                }

                .detail-label {
                    font-size: 10px;
                    color: #6c757d;
                    font-weight: 600;
                    white-space: nowrap;
                }

                .detail-value {
                    font-size: 10px;
                    font-weight: 600;
                    text-align: right;
                    padding-left: 6px;
                    word-break: break-word;
                    flex-shrink: 1;
                    min-width: 0;
                }

                .usage-badge {
                    font-size: 9px;
                    padding: 2px 6px;
                }

                .created-date {
                    margin-top: 8px;
                    text-align: center;
                    font-size: 9px;
                    color: #6c757d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 16px;
                }

                .coupon-actions {
                    padding: 10px 15px;
                    background: #f8f9fa;
                    border-top: 1px solid #e9ecef;
                    display: flex;
                    gap: 6px;
                    flex-wrap: nowrap;
                    flex-shrink: 0;
                }

                .action-btn {
                    flex: 1;
                    font-size: 10px;
                    padding: 4px 6px;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .image-upload-area {
                    background: #f8f9fa;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .image-upload-area:hover {
                    background: #e9ecef;
                    border-color: #0d6efd;
                }

                .cursor-pointer {
                    cursor: pointer;
                }

                .uploaded-image-preview {
                    max-width: 100%;
                    height: auto;
                }

                @media (max-width: 1400px) {
                    .coupon-card {
                        min-height: 340px;
                    }

                    .discount-value {
                        font-size: 22px;
                    }

                    .percent, .amount {
                        font-size: 24px;
                    }

                    .coupon-title h5 {
                        font-size: 12px;
                    }
                }

                @media (max-width: 1200px) {
                    .coupon-card {
                        min-height: 330px;
                    }

                    .coupon-main {
                        padding: 12px;
                    }

                    .coupon-details {
                        padding: 10px 12px;
                    }

                    .discount-value {
                        font-size: 20px;
                    }

                    .percent, .amount {
                        font-size: 22px;
                    }
                }

                @media (max-width: 992px) {
                    .coupon-card {
                        min-height: 350px;
                    }

                    .coupon-title h5 {
                        font-size: 12px;
                    }

                    .detail-label {
                        font-size: 9px;
                    }

                    .detail-value {
                        font-size: 10px;
                    }
                }

                @media (max-width: 768px) {
                    .coupon-container {
                        height: auto;
                    }

                    .coupon-card {
                        min-height: auto;
                        height: auto;
                    }

                    .coupon-actions {
                        flex-direction: row;
                    }

                    .action-btn {
                        font-size: 9px;
                        padding: 3px 5px;
                    }

                    .discount-value {
                        font-size: 18px;
                    }

                    .percent, .amount {
                        font-size: 20px;
                    }

                    .off-label {
                        font-size: 11px;
                    }
                }

                @media (max-width: 576px) {
                    .coupon-card {
                        min-height: auto;
                        margin-bottom: 15px;
                    }

                    .coupon-main {
                        padding: 10px;
                    }

                    .coupon-details {
                        padding: 8px 10px;
                    }

                    .discount-value {
                        font-size: 16px;
                        flex-direction: column;
                        gap: 1px;
                    }

                    .percent, .amount {
                        font-size: 18px;
                    }

                    .off-label {
                        margin-left: 0;
                        font-size: 10px;
                    }

                    .coupon-title h5 {
                        font-size: 11px;
                    }
                }

                /* Ensure all cards have same height in row */
                .row.g-3 {
                    display: flex;
                    flex-wrap: wrap;
                }

                .row.g-3 > [class*="col-"] {
                    display: flex;
                    flex-direction: column;
                }
            `}</style>
        </>
    );
};

export default AutoCouponAllocation;